import React, { useState, useRef, useEffect } from 'react';

/* ═══════════════════════════════════════════════════════════════════════════ */
/*  DATA                                                                      */
/* ═══════════════════════════════════════════════════════════════════════════ */

const TRUST_HIERARCHY = [
  'Apple Yetkili Yenileme Merkezi',
  '12 Ay TSE Garantili',
  '21 Gün Koşulsuz İade Hakkı',
  '90 Gün Değişim Hakkı',
  'Gürgençler Güvencesi',
  'Ticaret Bakanlığı Yenileme Lisansı',
  'Bilişim Vadisi Teknopark',
];

const PRODUCTS = [
  {
    id: 'iphone',
    name: 'iPhone',
    icon: '📱',
    tagline: 'Hacim Ürünü, Güven Odaklı',
    coreMessage: '"Yenilenmiş deme, Yenilio yenisi de. Apple Yetkili Yenileme Merkezi\'nde 12 ay TSE garantili iPhone. Gürgençler güvencesiyle."',
    keywords: [
      { kw: 'yenilio',                    intent: 'Brand',     match: 'Exact',  campaign: 'Brand' },
      { kw: 'yenilio iphone',             intent: 'Brand',     match: 'Exact',  campaign: 'Brand' },
      { kw: 'yenilenmiş iphone 15',       intent: 'Yüksek',   match: 'Exact',  campaign: 'iPhone_15' },
      { kw: 'yenilenmiş iphone 14 pro',   intent: 'Yüksek',   match: 'Exact',  campaign: 'iPhone_14' },
      { kw: 'yenilenmiş iphone 13',       intent: 'Yüksek',   match: 'Exact',  campaign: 'iPhone_13' },
      { kw: 'ikinci el iphone garantili', intent: 'Yüksek',   match: 'Phrase', campaign: 'iPhone_Genel' },
      { kw: 'apple yetkili yenilenmiş iphone', intent: 'Yüksek', match: 'Phrase', campaign: 'iPhone_Genel' },
      { kw: 'TSE garantili iphone',       intent: 'Yüksek',   match: 'Phrase', campaign: 'iPhone_Genel' },
      { kw: 'sertifikalı yenilenmiş iphone', intent: 'Yüksek', match: 'Phrase', campaign: 'iPhone_Genel' },
      { kw: '2. el iphone 15',            intent: 'Orta',      match: 'Phrase', campaign: 'iPhone_15' },
      { kw: 'ucuz iphone 14',             intent: 'Orta',      match: 'Phrase', campaign: 'iPhone_14' },
      { kw: 'ikinci el iphone nereden alınır', intent: 'Araştırma', match: 'Broad', campaign: 'iPhone_Genel' },
      { kw: 'yenilenmiş telefon güvenilir mi', intent: 'Araştırma', match: 'Broad', campaign: 'iPhone_Genel' },
    ],
    negatives: 'tamir, arıza, kılıf, ekran koruyucu, sahibinden, letgo, kopya, replika, android, samsung',
    headlines: [
      { pos: 'H1', text: 'Apple Yetkili Yenileme: iPhone 15', pin: 1 },
      { pos: 'H2', text: '12 Ay TSE Garantili Yenilio Yenisi', pin: 2 },
      { pos: 'H3', text: '27 Nokta Kontrollü iPhone', pin: null },
      { pos: 'H4', text: '21 Gün Koşulsuz İade Hakkı', pin: null },
      { pos: 'H5', text: 'Gürgençler Güvencesiyle iPhone 15', pin: null },
      { pos: 'H6', text: 'Ticaret Bakanlığı Lisanslı', pin: null },
      { pos: 'H7', text: 'Peşin Fiyatına 12 Ay Taksit', pin: 3 },
      { pos: 'H8', text: '90 Gün İçinde Değişim Hakkı', pin: null },
      { pos: 'H9', text: 'Yenilio\'da iPhone 15 Keşfet', pin: null },
      { pos: 'H10', text: 'Akıllı Seçim: Yenilenmiş iPhone', pin: null },
    ],
    rsaPreview: {
      url: 'yenilio.com/iphone/iphone-15',
      h1: 'Apple Yetkili Yenileme: iPhone 15 — 12 Ay TSE Garantili Yenilio Yenisi',
      desc: '27 nokta kontrol, 21 gün koşulsuz iade, 90 gün değişim hakkı. Ticaret Bakanlığı lisanslı',
      cta: 'Yenilio\'da iPhone 15 şimdi peşin fiyatına 12 ay taksitle',
      sitelinks: ['12 Ay TSE Garantisi', '21 Gün İade Hakkı', 'Vade Farksız 12 Taksit', '90 Gün Değişim'],
    },
    metaAudiences: [
      { funnel: 'Prospecting',   audience: 'Apple Inc + iPhone + iOS + Engaged Shoppers', age: '18-45' },
      { funnel: 'Consideration', audience: 'Site ziyaretçileri (30 gün) + iPhone sayfası görüntüleyenler', age: '18-55' },
      { funnel: 'Conversion',    audience: 'ATC + Checkout terk + 90 gün alıcılar (cross-sell)', age: '18-55' },
    ],
  },
  {
    id: 'macbook',
    name: 'MacBook',
    icon: '💻',
    tagline: 'Düşük Rekabet, Uzman Yenileme',
    coreMessage: '"Profesyoneller için uzman ellerde yenilenmiş MacBook. Apple Yetkili Yenileme Merkezi\'nde 12 ay TSE garantili. Gürgençler\'in 15 yıllık deneyimiyle."',
    keywords: [
      { kw: 'yenilio macbook',               intent: 'Brand',   match: 'Exact',  campaign: 'Brand' },
      { kw: 'yenilio macbook pro',            intent: 'Brand',   match: 'Exact',  campaign: 'Brand' },
      { kw: 'yenilenmiş macbook pro',         intent: 'Yüksek', match: 'Exact',  campaign: 'MacBook_Pro' },
      { kw: 'yenilenmiş macbook air',         intent: 'Yüksek', match: 'Exact',  campaign: 'MacBook_Air' },
      { kw: 'yenilenmiş macbook pro m2',      intent: 'Yüksek', match: 'Exact',  campaign: 'MacBook_Pro' },
      { kw: 'yenilenmiş macbook air m1',      intent: 'Yüksek', match: 'Exact',  campaign: 'MacBook_Air' },
      { kw: 'garantili yenilenmiş macbook',   intent: 'Yüksek', match: 'Phrase', campaign: 'MacBook_Genel' },
      { kw: 'apple yetkili yenilenmiş macbook', intent: 'Yüksek', match: 'Phrase', campaign: 'MacBook_Genel' },
      { kw: 'TSE garantili macbook',          intent: 'Yüksek', match: 'Phrase', campaign: 'MacBook_Genel' },
      { kw: 'sertifikalı yenilenmiş macbook', intent: 'Yüksek', match: 'Phrase', campaign: 'MacBook_Genel' },
      { kw: 'macbook pro uygun fiyat',        intent: 'Orta',    match: 'Phrase', campaign: 'MacBook_Pro' },
      { kw: 'macbook air ucuz',               intent: 'Orta',    match: 'Phrase', campaign: 'MacBook_Air' },
      { kw: 'ikinci el macbook güvenilir mi', intent: 'Araştırma', match: 'Broad', campaign: 'MacBook_Genel' },
      { kw: 'macbook nereden alınır',         intent: 'Araştırma', match: 'Broad', campaign: 'MacBook_Genel' },
    ],
    negatives: 'windows, dell, lenovo, hp, asus, hackintosh, tamir, batarya değişimi, kılıf, çanta, aksesuar',
    headlines: [
      { pos: 'H1', text: 'Apple Yetkili Yenileme: MacBook', pin: 1 },
      { pos: 'H2', text: '12 Ay TSE Garantili MacBook Pro', pin: 2 },
      { pos: 'H3', text: 'Uzman Ellerde Yenilenmiş Mac', pin: null },
      { pos: 'H4', text: '15 Yıllık Apple Servis Deneyimi', pin: null },
      { pos: 'H5', text: '21 Gün İade + 90 Gün Değişim', pin: null },
      { pos: 'H6', text: 'MacBook Pro M2 Yenilio\'da', pin: null },
      { pos: 'H7', text: 'Peşin Fiyatına 12 Ay Taksit', pin: 3 },
      { pos: 'H8', text: 'Profesyoneller İçin Yenilenmiş', pin: null },
      { pos: 'H9', text: 'MacBook Air M1 Garantili', pin: null },
      { pos: 'H10', text: 'Bilişim Vadisi Kampüsünde', pin: null },
    ],
    rsaPreview: {
      url: 'yenilio.com/macbook/macbook-pro',
      h1: 'Apple Yetkili Yenileme: MacBook — 12 Ay TSE Garantili MacBook Pro',
      desc: 'Uzman ellerde yenilenmiş MacBook Pro ve Air. 15 yıllık Gürgençler deneyimiyle. Ticaret Bakanlığı lisanslı',
      cta: 'Profesyonel MacBook\'unuz Yenilio\'da peşin fiyatına 12 ay taksitle',
      sitelinks: ['MacBook Pro M2', 'MacBook Air M1', '12 Ay TSE Garantisi', '21 Gün İade Hakkı'],
    },
    metaAudiences: [
      { funnel: 'Prospecting',   audience: 'macOS ilgisi + Developer/Freelancer + Apple Inc', age: '22-50' },
      { funnel: 'Consideration', audience: 'Site ziyaretçileri (30 gün) + MacBook sayfası görüntüleyenler', age: '22-55' },
      { funnel: 'Conversion',    audience: 'ATC + Checkout terk + MacBook Lookalike %1', age: '22-55' },
    ],
  },
  {
    id: 'ipad',
    name: 'iPad',
    icon: '📲',
    tagline: 'Öğrenciden Profesyonele',
    coreMessage: '"Öğrenciden profesyonele, herkes için TSE garantili iPad. Apple Yetkili Yenileme Merkezi\'nde uzman ellerde yenilenmiş iPad modelleri Gürgençler güvencesiyle."',
    keywords: [
      { kw: 'yenilio ipad',                 intent: 'Brand',   match: 'Exact',  campaign: 'Brand' },
      { kw: 'yenilio ipad pro',              intent: 'Brand',   match: 'Exact',  campaign: 'Brand' },
      { kw: 'yenilenmiş ipad',               intent: 'Yüksek', match: 'Exact',  campaign: 'iPad_Genel' },
      { kw: 'yenilenmiş ipad pro',           intent: 'Yüksek', match: 'Exact',  campaign: 'iPad_Pro' },
      { kw: 'yenilenmiş ipad air',           intent: 'Yüksek', match: 'Exact',  campaign: 'iPad_Air' },
      { kw: 'yenilenmiş ipad m2',            intent: 'Yüksek', match: 'Exact',  campaign: 'iPad_Pro' },
      { kw: 'garantili yenilenmiş ipad',     intent: 'Yüksek', match: 'Phrase', campaign: 'iPad_Genel' },
      { kw: 'TSE garantili ipad',            intent: 'Yüksek', match: 'Phrase', campaign: 'iPad_Genel' },
      { kw: 'apple yetkili yenilenmiş ipad', intent: 'Yüksek', match: 'Phrase', campaign: 'iPad_Genel' },
      { kw: 'apple pencil uyumlu yenilenmiş ipad', intent: 'Yüksek', match: 'Phrase', campaign: 'iPad_Pro' },
      { kw: 'öğrenciye ipad',               intent: 'Orta',    match: 'Phrase', campaign: 'iPad_Genel' },
      { kw: 'ipad uygun fiyat',             intent: 'Orta',    match: 'Phrase', campaign: 'iPad_Genel' },
      { kw: 'en uygun ipad nereden alınır', intent: 'Araştırma', match: 'Broad', campaign: 'iPad_Genel' },
      { kw: 'tablet satın al',              intent: 'Araştırma', match: 'Broad', campaign: 'iPad_Genel' },
    ],
    negatives: 'android tablet, samsung tablet, huawei, tamir, onarım, ekran değişimi, kılıf, kalem, aksesuar',
    headlines: [
      { pos: 'H1', text: 'Apple Yetkili Yenileme: iPad', pin: 1 },
      { pos: 'H2', text: '12 Ay TSE Garantili iPad', pin: 2 },
      { pos: 'H3', text: 'Öğrenciye Garantili iPad', pin: null },
      { pos: 'H4', text: 'iPad Pro M2 Yenilio\'da', pin: null },
      { pos: 'H5', text: '21 Gün İade + 90 Gün Değişim', pin: null },
      { pos: 'H6', text: 'Apple Pencil Uyumlu iPad', pin: null },
      { pos: 'H7', text: 'Peşin Fiyatına 12 Ay Taksit', pin: 3 },
      { pos: 'H8', text: 'Gürgençler Güvencesiyle iPad', pin: null },
      { pos: 'H9', text: 'iPad Air Yenilenmiş Fırsatı', pin: null },
      { pos: 'H10', text: 'Profesyonel iPad Pro Yenilenmiş', pin: null },
    ],
    rsaPreview: {
      url: 'yenilio.com/ipad/ipad-pro',
      h1: 'Apple Yetkili Yenileme: iPad — 12 Ay TSE Garantili iPad',
      desc: 'Öğrenciden profesyonele herkes için TSE garantili yenilenmiş iPad. Apple Pencil uyumlu modeller',
      cta: 'Yenilio\'da iPad Pro ve iPad Air peşin fiyatına 12 ay taksitle',
      sitelinks: ['iPad Pro M2', 'iPad Air', '12 Ay TSE Garantisi', 'Apple Pencil Uyumlu'],
    },
    metaAudiences: [
      { funnel: 'Prospecting',   audience: 'Üniversite öğrencileri + Tasarım/çizim ilgisi + Apple tablet', age: '17-45' },
      { funnel: 'Consideration', audience: 'Site ziyaretçileri (30 gün) + iPad sayfası görüntüleyenler', age: '17-55' },
      { funnel: 'Conversion',    audience: 'ATC + Checkout terk + iPad Lookalike %1', age: '18-55' },
    ],
  },
  {
    id: 'watch',
    name: 'Apple Watch',
    icon: '⌚',
    tagline: 'Garantili Güvenli Alternatif',
    coreMessage: '"Batarya sağlığı ve su geçirmezlik dahil tam test sürecinden geçmiş Apple Watch. Apple Yetkili Yenileme Merkezi\'nde 12 ay TSE garantili. Gürgençler güvencesiyle."',
    keywords: [
      { kw: 'yenilio apple watch',          intent: 'Brand',   match: 'Exact',  campaign: 'Brand' },
      { kw: 'yenilio watch',                intent: 'Brand',   match: 'Exact',  campaign: 'Brand' },
      { kw: 'yenilenmiş apple watch',       intent: 'Yüksek', match: 'Exact',  campaign: 'Watch_Genel' },
      { kw: 'yenilenmiş apple watch ultra', intent: 'Yüksek', match: 'Exact',  campaign: 'Watch_Ultra' },
      { kw: 'yenilenmiş apple watch se',    intent: 'Yüksek', match: 'Exact',  campaign: 'Watch_SE' },
      { kw: 'yenilenmiş apple watch series 9', intent: 'Yüksek', match: 'Exact', campaign: 'Watch_Series' },
      { kw: 'garantili yenilenmiş apple watch', intent: 'Yüksek', match: 'Phrase', campaign: 'Watch_Genel' },
      { kw: 'TSE garantili apple watch',    intent: 'Yüksek', match: 'Phrase', campaign: 'Watch_Genel' },
      { kw: 'sertifikalı apple watch',      intent: 'Yüksek', match: 'Phrase', campaign: 'Watch_Genel' },
      { kw: 'apple watch uygun fiyat',      intent: 'Orta',    match: 'Phrase', campaign: 'Watch_Genel' },
      { kw: 'apple watch ucuz',             intent: 'Orta',    match: 'Phrase', campaign: 'Watch_Genel' },
      { kw: 'ikinci el apple watch güvenilir mi', intent: 'Araştırma', match: 'Broad', campaign: 'Watch_Genel' },
      { kw: 'akıllı saat satın al',         intent: 'Araştırma', match: 'Broad', campaign: 'Watch_Genel' },
    ],
    negatives: 'samsung watch, galaxy watch, huawei watch, android, kordon, kayış, tamir, batarya değişimi, cam',
    headlines: [
      { pos: 'H1', text: 'Apple Yetkili Yenileme: Watch', pin: 1 },
      { pos: 'H2', text: '12 Ay TSE Garantili Apple Watch', pin: 2 },
      { pos: 'H3', text: 'Batarya & Su Geçirmezlik Testli', pin: null },
      { pos: 'H4', text: '21 Gün İade + 90 Gün Değişim', pin: null },
      { pos: 'H5', text: 'Apple Watch Ultra Yenilio\'da', pin: null },
      { pos: 'H6', text: 'Watch SE Garantili Fırsatı', pin: null },
      { pos: 'H7', text: 'Peşin Fiyatına 12 Ay Taksit', pin: 3 },
      { pos: 'H8', text: 'Gürgençler Güvencesiyle Watch', pin: null },
      { pos: 'H9', text: 'Sağlık Takibi Güvenle Başlar', pin: null },
      { pos: 'H10', text: 'Ekosisteminizi Tamamlayın', pin: null },
    ],
    rsaPreview: {
      url: 'yenilio.com/apple-watch',
      h1: 'Apple Yetkili Yenileme: Watch — 12 Ay TSE Garantili Apple Watch',
      desc: 'Batarya sağlığı ve su geçirmezlik dahil tam test. 21 gün iade, 90 gün değişim hakkı',
      cta: 'Yenilio\'da Apple Watch şimdi peşin fiyatına 12 ay taksitle',
      sitelinks: ['Watch Ultra', 'Watch SE', '12 Ay TSE Garantisi', 'Batarya %100 Garantili'],
    },
    metaAudiences: [
      { funnel: 'Prospecting',   audience: 'iPhone sahipleri + Fitness/sağlık ilgisi + Apple Inc', age: '22-45' },
      { funnel: 'Consideration', audience: 'Site ziyaretçileri (30 gün) + Watch sayfası görüntüleyenler', age: '22-50' },
      { funnel: 'Conversion',    audience: 'ATC + Checkout terk + Watch Lookalike %1', age: '22-55' },
    ],
  },
];

const INTENT_COLORS = {
  Brand:      'bg-blue-500 text-white',
  'Yüksek':   'bg-green-500 text-white',
  Orta:       'bg-orange-400 text-white',
  'Araştırma': 'bg-purple-500 text-white',
};

const FUNNEL_COLORS = {
  Prospecting:   'bg-emerald-500 text-white',
  Consideration: 'bg-amber-500 text-white',
  Conversion:    'bg-rose-500 text-white',
};

/* ═══════════════════════════════════════════════════════════════════════════ */
/*  COMPONENTS                                                                */
/* ═══════════════════════════════════════════════════════════════════════════ */

function TrustHierarchySection() {
  return (
    <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">
      <div className="bg-gradient-to-r from-gray-900 to-gray-800 p-5 text-white">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-xl font-bold tracking-tight">YENİLİO — Dijital Strateji Revizyon Planı</h1>
            <p className="text-gray-400 text-sm mt-1">Apple Yetkili Yenileme Merkezi • Gürgençler Güvencesiyle • Mart 2026</p>
          </div>
          <div className="text-right">
            <p className="text-xs text-gray-400">Hazırlayan</p>
            <p className="text-sm font-medium">Glowytics</p>
          </div>
        </div>
      </div>
      <div className="p-5">
        <p className="text-sm font-bold text-gray-800 mb-3">Sabit Güven Hiyerarşisi — Tüm reklam metinlerinde bu sıra korunacak:</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2">
          {TRUST_HIERARCHY.map((item, i) => (
            <div key={i} className="flex items-center gap-2.5 px-3 py-2.5 rounded-lg bg-amber-50 border border-amber-200">
              <span className="flex-shrink-0 w-6 h-6 rounded-full bg-amber-500 text-white text-xs font-bold flex items-center justify-center">{i + 1}</span>
              <span className="text-sm font-medium text-amber-900">{item}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function ProductSection({ product }) {
  return (
    <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">
      {/* Title */}
      <div className="px-6 py-4 border-b bg-gray-50">
        <h2 className="text-lg font-bold text-gray-900">{product.icon} {product.name} Stratejisi — {product.tagline}</h2>
      </div>

      {/* Core Message */}
      <div className="mx-6 mt-5 px-4 py-3 rounded-lg bg-blue-50 border border-blue-200">
        <p className="text-sm text-blue-900"><span className="font-semibold">Temel Mesaj:</span> {product.coreMessage}</p>
      </div>

      {/* Two-Column Layout */}
      <div className="p-6 grid grid-cols-1 xl:grid-cols-2 gap-6">

        {/* LEFT — Keyword Plan */}
        <div className="rounded-xl border overflow-hidden">
          <div className="px-4 py-3 bg-gray-50 border-b flex items-center gap-2">
            <span className="text-base">🔍</span>
            <div>
              <p className="font-semibold text-sm text-gray-800">Google Ads — Anahtar Kelime Planı</p>
              <p className="text-[11px] text-gray-500">Niyet seviyesine göre gruplandırma</p>
            </div>
          </div>
          <div className="overflow-x-auto">
            <table className="min-w-full text-sm">
              <thead>
                <tr className="border-b bg-gray-50">
                  <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">Anahtar Kelime</th>
                  <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">Niyet</th>
                  <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">Eşleme</th>
                  <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">Kampanya</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {product.keywords.map((k, i) => (
                  <tr key={i} className="hover:bg-gray-50">
                    <td className="px-3 py-2 font-mono text-xs text-gray-800">{k.kw}</td>
                    <td className="px-3 py-2">
                      <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full ${INTENT_COLORS[k.intent]}`}>{k.intent}</span>
                    </td>
                    <td className="px-3 py-2 text-xs text-gray-600">{k.match}</td>
                    <td className="px-3 py-2 text-xs text-gray-600">{k.campaign}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="px-4 py-2.5 bg-red-50 border-t border-red-200">
            <p className="text-xs text-red-700"><span className="font-semibold">Negatifler:</span> {product.negatives}</p>
          </div>
        </div>

        {/* RIGHT — RSA Preview + Pin Strategy + Meta */}
        <div className="space-y-5">

          {/* RSA Preview */}
          <div className="rounded-xl border overflow-hidden">
            <div className="px-4 py-3 bg-gray-50 border-b flex items-center gap-2">
              <span className="text-base">📝</span>
              <div>
                <p className="font-semibold text-sm text-gray-800">Reklam Metni Şablonu (RSA)</p>
                <p className="text-[11px] text-gray-500">{product.name} örneği — güven odaklı</p>
              </div>
            </div>
            <div className="p-4">
              <div className="rounded-lg border border-gray-300 bg-white p-4 space-y-1.5">
                <p className="text-xs text-green-700 truncate">{product.rsaPreview.url}</p>
                <p className="text-blue-700 font-medium text-sm leading-snug">{product.rsaPreview.h1}</p>
                <p className="text-xs text-gray-600 leading-relaxed">{product.rsaPreview.desc}</p>
                <p className="text-xs text-green-700">{product.rsaPreview.cta}</p>
                <div className="flex flex-wrap gap-2 pt-2 border-t mt-2">
                  {product.rsaPreview.sitelinks.map((sl, i) => (
                    <span key={i} className="text-[10px] text-blue-600 underline">{sl}</span>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Headline Pin Strategy */}
          <div className="rounded-xl border overflow-hidden">
            <div className="px-4 py-3 bg-gray-50 border-b flex items-center gap-2">
              <span className="text-base">📌</span>
              <div>
                <p className="font-semibold text-sm text-gray-800">Headline Pin Stratejisi</p>
                <p className="text-[11px] text-gray-500">10 headline&apos;dan 3&apos;ü pin&apos;li</p>
              </div>
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full text-sm">
                <thead>
                  <tr className="border-b bg-gray-50">
                    <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 w-12">Poz.</th>
                    <th className="px-3 py-2 text-left text-xs font-medium text-gray-500">Headline</th>
                    <th className="px-3 py-2 text-right text-xs font-medium text-gray-500 w-20">Pin</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {product.headlines.map((h, i) => (
                    <tr key={i} className={h.pin ? 'bg-red-50/40' : 'hover:bg-gray-50'}>
                      <td className="px-3 py-2 text-xs font-medium text-gray-500">{h.pos}</td>
                      <td className="px-3 py-2 text-xs text-gray-800">{h.text}</td>
                      <td className="px-3 py-2 text-right">
                        {h.pin && <span className="text-[10px] font-bold text-red-600">📌 PIN {h.pin}</span>}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Meta Audiences */}
          <div className="rounded-xl border overflow-hidden">
            <div className="px-4 py-3 bg-gray-50 border-b flex items-center gap-2">
              <span className="text-base">👥</span>
              <div>
                <p className="font-semibold text-sm text-gray-800">Hedef Kitle — Meta</p>
              </div>
            </div>
            <table className="min-w-full text-sm">
              <thead>
                <tr className="border-b bg-gray-50">
                  <th className="px-3 py-2 text-left text-xs font-medium text-gray-500">Katman</th>
                  <th className="px-3 py-2 text-left text-xs font-medium text-gray-500">Kitle</th>
                  <th className="px-3 py-2 text-right text-xs font-medium text-gray-500">Yaş</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {product.metaAudiences.map((a, i) => (
                  <tr key={i} className="hover:bg-gray-50">
                    <td className="px-3 py-2.5">
                      <span className={`text-[10px] font-bold px-2.5 py-1 rounded-full ${FUNNEL_COLORS[a.funnel]}`}>{a.funnel}</span>
                    </td>
                    <td className="px-3 py-2.5 text-xs text-gray-700">{a.audience}</td>
                    <td className="px-3 py-2.5 text-xs text-gray-600 text-right">{a.age}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

function GoogleAdsSection() {
  return (
    <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">
      <div className="px-6 py-4 border-b bg-gray-50">
        <h2 className="text-lg font-bold text-gray-900">🔍 Google Ads — Kampanya Yapısı & Brand vs Non-Brand</h2>
      </div>
      <div className="p-6">
        <table className="min-w-full text-sm divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-2.5 text-left text-xs font-medium text-gray-500">Segment</th>
              <th className="px-4 py-2.5 text-left text-xs font-medium text-gray-500">Strateji</th>
              <th className="px-4 py-2.5 text-left text-xs font-medium text-gray-500">KPI</th>
              <th className="px-4 py-2.5 text-right text-xs font-medium text-gray-500">Bütçe</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            <tr className="bg-blue-50/50">
              <td className="px-4 py-3 font-semibold text-blue-800">Brand</td>
              <td className="px-4 py-3 text-gray-700">Marka aramalarını yakalama. "Yenilio" + varyasyonlar. Impression share &gt;90%</td>
              <td className="px-4 py-3 text-gray-700">IS &gt;90%, CPC min</td>
              <td className="px-4 py-3 text-right font-medium text-gray-800">%10-15</td>
            </tr>
            <tr>
              <td className="px-4 py-3 font-semibold text-green-800">Non-Brand (Yüksek Niyet)</td>
              <td className="px-4 py-3 text-gray-700">"yenilenmiş iphone", "garantili macbook" gibi satın alma niyetli aramalar</td>
              <td className="px-4 py-3 text-gray-700">CVR, ROAS, CPA</td>
              <td className="px-4 py-3 text-right font-medium text-gray-800">%50-60</td>
            </tr>
            <tr>
              <td className="px-4 py-3 font-semibold text-orange-800">Non-Brand (Genel)</td>
              <td className="px-4 py-3 text-gray-700">"iphone fiyat", "macbook ucuz" gibi araştırma aşaması</td>
              <td className="px-4 py-3 text-gray-700">CTR, ATC, Wishlist</td>
              <td className="px-4 py-3 text-right font-medium text-gray-800">%25-30</td>
            </tr>
            <tr className="bg-gray-50">
              <td className="px-4 py-3 font-semibold text-purple-800">Competitor</td>
              <td className="px-4 py-3 text-gray-700">Rakip marka arayanları yakalama (2. el platformlar, diğer yenileyiciler)</td>
              <td className="px-4 py-3 text-gray-700">IS, CTR</td>
              <td className="px-4 py-3 text-right font-medium text-gray-800">%5-10</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

function MetaAdsSection() {
  return (
    <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">
      <div className="px-6 py-4 border-b bg-gray-50">
        <h2 className="text-lg font-bold text-gray-900">📣 Meta Ads — Funnel Yapısı</h2>
      </div>
      <div className="p-6 grid grid-cols-1 md:grid-cols-3 gap-5">
        <div className="rounded-xl border-l-4 border-l-emerald-500 border p-5 bg-emerald-50/30">
          <p className="text-xs font-bold text-emerald-700 mb-1">TOFU — PROSPECTING</p>
          <p className="text-sm font-semibold text-gray-800 mb-3">Reach & Frequency + Video Views</p>
          <ul className="text-xs text-gray-700 space-y-2">
            <li><strong>Hedef:</strong> Marka bilinirliği, güven inşası</li>
            <li><strong>Kreatif:</strong> &quot;Gürgençler&apos;in 15 yıllık Apple deneyimi artık Yenilio&apos;da&quot; — 30sn + 15sn marka hikayesi videosu</li>
            <li><strong>Mesaj:</strong> Fiyat YOK, sadece güven hiyerarşisi + yenileme süreci</li>
            <li><strong>KPI:</strong> Reach, Video View Rate, ThruPlay</li>
          </ul>
        </div>
        <div className="rounded-xl border-l-4 border-l-amber-500 border p-5 bg-amber-50/30">
          <p className="text-xs font-bold text-amber-700 mb-1">MOFU — CONSIDERATION</p>
          <p className="text-sm font-semibold text-gray-800 mb-3">Traffic + Engagement</p>
          <ul className="text-xs text-gray-700 space-y-2">
            <li><strong>Hedef:</strong> Site trafiği, ürün keşfi</li>
            <li><strong>Kreatif:</strong> Güven carousel (her kartta bir rozet + müşteri yorumu) + Before/After yenileme süreci görselleri</li>
            <li><strong>Mesaj:</strong> "Neden Yenilio?" — TSE, iade, değişim detayları</li>
            <li><strong>KPI:</strong> CTR, Landing Page View, Time on Site</li>
          </ul>
        </div>
        <div className="rounded-xl border-l-4 border-l-rose-500 border p-5 bg-rose-50/30">
          <p className="text-xs font-bold text-rose-700 mb-1">BOFU — CONVERSION</p>
          <p className="text-sm font-semibold text-gray-800 mb-3">Sales (Advantage+ Shopping)</p>
          <ul className="text-xs text-gray-700 space-y-2">
            <li><strong>Hedef:</strong> Satın alma, sepet tamamlama</li>
            <li><strong>Kreatif:</strong> Dinamik ürün kataloğu + fiyat + güven rozeti overlay</li>
            <li><strong>Mesaj:</strong> Fiyat BURADA devreye girer — ama güven rozeti her zaman görünür</li>
            <li><strong>KPI:</strong> ROAS, CPA, Purchase, ATC Rate</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

function FunnelCROSection() {
  return (
    <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">
      <div className="px-6 py-4 border-b bg-gray-50">
        <h2 className="text-lg font-bold text-gray-900">🎯 Funnel & CRO — Trendyol vs Yenilio.com Derinlemesine Analiz</h2>
      </div>
      <div className="p-6 space-y-6">

        {/* Funnel KPI */}
        <div>
          <p className="text-sm font-bold text-gray-800 mb-3">Funnel KPI Hedefleri</p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="p-4 rounded-xl bg-blue-50 border border-blue-200 text-center">
              <p className="text-[10px] font-bold text-blue-600 uppercase">AWARENESS</p>
              <p className="text-lg font-bold text-blue-800 mt-1">Impression / Reach</p>
              <p className="text-xs text-blue-600 mt-1">&gt;500K/ay</p>
            </div>
            <div className="p-4 rounded-xl bg-amber-50 border border-amber-200 text-center">
              <p className="text-[10px] font-bold text-amber-600 uppercase">CONSIDERATION</p>
              <p className="text-lg font-bold text-amber-800 mt-1">CTR</p>
              <p className="text-xs text-amber-600 mt-1">&gt;%3 Search, &gt;%1.5 Meta</p>
            </div>
            <div className="p-4 rounded-xl bg-orange-50 border border-orange-200 text-center">
              <p className="text-[10px] font-bold text-orange-600 uppercase">INTENT</p>
              <p className="text-lg font-bold text-orange-800 mt-1">ATC Rate</p>
              <p className="text-xs text-orange-600 mt-1">&gt;%5 (ziyaretçi → sepet)</p>
            </div>
            <div className="p-4 rounded-xl bg-green-50 border border-green-200 text-center">
              <p className="text-[10px] font-bold text-green-600 uppercase">CONVERSION</p>
              <p className="text-lg font-bold text-green-800 mt-1">Purchase Rate</p>
              <p className="text-xs text-green-600 mt-1">&gt;%1.5 (ziyaretçi → satın alma)</p>
            </div>
          </div>
        </div>

        {/* Ana Tez */}
        <div className="p-5 rounded-xl bg-gradient-to-r from-gray-900 to-gray-800 text-white">
          <p className="text-base font-bold mb-2">Temel Tez: Trendyol Bir Satış Kanalı Değil, Garantör Mecradır</p>
          <p className="text-sm text-gray-300 leading-relaxed">
            Trendyol&apos;daki başarıyı &quot;iyi satış yapıyoruz&quot; olarak okumak yanlış. Trendyol aslında Yenilio için bir <span className="text-white font-semibold">güven aracısı</span> işlevi görüyor.
            Müşteri yenilenmiş ürün alırken en büyük bariyeri (güven) Trendyol&apos;un markası ve altyapısı otomatik olarak çözüyor.
            Bu demek oluyor ki sorun bizim ürünümüzde veya fiyatımızda değil — sorun <span className="text-white font-semibold">güven transferinin yenilio.com&apos;a henüz taşınamamış</span> olması.
          </p>
        </div>

        {/* Trendyol Detaylı Analiz */}
        <div className="rounded-xl border overflow-hidden">
          <div className="bg-orange-50 px-5 py-3 border-b border-orange-200">
            <p className="font-bold text-orange-900">Trendyol Neden Dönüştürüyor? — Detaylı Analiz</p>
          </div>
          <div className="p-5 space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

              <div className="p-4 rounded-lg border bg-white space-y-2">
                <p className="text-sm font-bold text-gray-800">1. Platform Güveni = Hazır Garanti Algısı</p>
                <p className="text-xs text-gray-600 leading-relaxed">
                  Trendyol&apos;dan alışveriş yapan kişi &quot;ya sorun çıkarsa?&quot; diye düşünmez çünkü Trendyol&apos;un kendi iade/değişim politikası
                  arka planda güvence sağlıyor. Müşteri aslında Yenilio&apos;ya değil, Trendyol&apos;a güvenerek satın alıyor.
                  Bu, Yenilio&apos;nun kendi güven altyapısını (TSE, 21 gün iade, 90 gün değişim) anlatmasına bile gerek kalmadan
                  dönüşüm sağlanmasını mümkün kılıyor.
                </p>
              </div>

              <div className="p-4 rounded-lg border bg-white space-y-2">
                <p className="text-sm font-bold text-gray-800">2. Hazır Trafik Havuzu</p>
                <p className="text-xs text-gray-600 leading-relaxed">
                  Trendyol&apos;da zaten &quot;yenilenmiş iphone&quot; arayan binlerce kişi var. Bu kitle satın alma niyetiyle platformda.
                  Reklam harcaması yapmadan organik görünürlük + platform içi arama trafiği geliyor.
                  Yenilio.com&apos;da ise her bir ziyaretçiyi reklam bütçesiyle çekmek gerekiyor — trafik maliyeti çok daha yüksek.
                </p>
              </div>

              <div className="p-4 rounded-lg border bg-white space-y-2">
                <p className="text-sm font-bold text-gray-800">3. Kolay Karşılaştırma & Sosyal Kanıt</p>
                <p className="text-xs text-gray-600 leading-relaxed">
                  Trendyol&apos;da müşteri anında diğer satıcılarla fiyat karşılaştırması yapabiliyor, yorumları okuyabiliyor,
                  satıcı puanını görebiliyor. Bu şeffaflık güven inşa ediyor. Yenilio.com&apos;da ise müşteri tek başına
                  bir sitede — karşılaştırma yapamıyor, yorum sayısı az, &quot;acaba gerçek mi?&quot; sorusu devam ediyor.
                </p>
              </div>

              <div className="p-4 rounded-lg border bg-white space-y-2">
                <p className="text-sm font-bold text-gray-800">4. Ödeme & İade Altyapısı</p>
                <p className="text-xs text-gray-600 leading-relaxed">
                  Trendyol&apos;un taksit seçenekleri, kapıda ödeme, tek tıkla iade gibi altyapıları müşterinin
                  risk algısını neredeyse sıfıra indiriyor. Yenilio.com&apos;da da aynı kolaylıklar var ama müşteri
                  bunu bilmiyor çünkü ilk kez ziyaret ediyor ve bu bilgilere ulaşmadan sayfadan çıkıyor.
                </p>
              </div>
            </div>

            <div className="p-4 rounded-lg bg-orange-50 border border-orange-200">
              <p className="text-xs text-orange-800 leading-relaxed">
                <strong>Sonuç:</strong> Trendyol&apos;daki başarı Yenilio&apos;nun ürün kalitesini doğruluyor. Ürün ve fiyat doğru.
                Problem sadece ve sadece <strong>güven transferi</strong>. Trendyol&apos;un otomatik olarak sağladığı güveni,
                yenilio.com&apos;da biz manuel olarak (içerik, kreatif, UX, sosyal kanıt) inşa etmeliyiz.
              </p>
            </div>
          </div>
        </div>

        {/* Yenilio.com Sorunlar & Çözümler */}
        <div className="rounded-xl border overflow-hidden">
          <div className="bg-red-50 px-5 py-3 border-b border-red-200">
            <p className="font-bold text-red-900">Yenilio.com — Tespit Edilen Bariyerler & Aksiyon Planı</p>
          </div>
          <div className="p-5">
            <table className="min-w-full text-sm divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-2.5 text-left text-xs font-medium text-gray-500 w-8">#</th>
                  <th className="px-4 py-2.5 text-left text-xs font-medium text-gray-500">Bariyer</th>
                  <th className="px-4 py-2.5 text-left text-xs font-medium text-gray-500">Detay</th>
                  <th className="px-4 py-2.5 text-left text-xs font-medium text-gray-500">Çözüm Aksiyonu</th>
                  <th className="px-4 py-2.5 text-center text-xs font-medium text-gray-500 w-20">Öncelik</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                <tr>
                  <td className="px-4 py-3 font-bold text-gray-500">1</td>
                  <td className="px-4 py-3 font-semibold text-gray-800">Güven Algısı Eksik</td>
                  <td className="px-4 py-3 text-xs text-gray-600">
                    İlk kez gelen ziyaretçi &quot;Apple Yetkili Yenileme Merkezi&quot; olduğumuzu anlamıyor.
                    Hero section fiyat odaklı, güven mesajları scroll gerektiriyor.
                  </td>
                  <td className="px-4 py-3 text-xs text-gray-700">
                    Landing page hero&apos;da sabit güven hiyerarşisi. Above the fold&apos;da
                    TSE logosu, Apple Yetkili rozeti, Gürgençler referansı.
                  </td>
                  <td className="px-4 py-3 text-center"><span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-red-500 text-white">KRİTİK</span></td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-bold text-gray-500">2</td>
                  <td className="px-4 py-3 font-semibold text-gray-800">Sosyal Kanıt Yetersiz</td>
                  <td className="px-4 py-3 text-xs text-gray-600">
                    Trendyol&apos;da yüzlerce olumlu yorum var ama yenilio.com&apos;da bunlar görünmüyor.
                    Ziyaretçi &quot;başkası almış mı, memnun mu?&quot; sorusuna cevap bulamıyor.
                  </td>
                  <td className="px-4 py-3 text-xs text-gray-700">
                    Trendyol yorumlarını &amp; puanlarını site&apos;ye entegre etme. Google Reviews widget.
                    Video testimonial (gerçek müşterilerden 15sn).
                  </td>
                  <td className="px-4 py-3 text-center"><span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-red-500 text-white">KRİTİK</span></td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-bold text-gray-500">3</td>
                  <td className="px-4 py-3 font-semibold text-gray-800">Funnel Eksikliği</td>
                  <td className="px-4 py-3 text-xs text-gray-600">
                    Mevcut yapıda ilk ziyarette direkt satış bekleniyor. Yenilenmiş ürün alımı
                    güven gerektiren bir karar — çoğu kullanıcı ilk ziyarette almaz, araştırır gider.
                  </td>
                  <td className="px-4 py-3 text-xs text-gray-700">
                    3 katmanlı funnel: Awareness (video + reach) → Consideration (güven içerikleri, retargeting) → Conversion (fiyat + taksit + garanti).
                    Email nurturing akışı.
                  </td>
                  <td className="px-4 py-3 text-center"><span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-orange-500 text-white">YÜKSEK</span></td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-bold text-gray-500">4</td>
                  <td className="px-4 py-3 font-semibold text-gray-800">Marka Hikayesi Anlatılmıyor</td>
                  <td className="px-4 py-3 text-xs text-gray-600">
                    Gürgençler&apos;in 15 yıllık Apple deneyimi, Bilişim Vadisi kampüsü,
                    Ticaret Bakanlığı lisansı — bunlar müşteriyi ikna edecek en güçlü argümanlar ama dijitalde görünmüyor.
                  </td>
                  <td className="px-4 py-3 text-xs text-gray-700">
                    &quot;Hakkımızda&quot; sayfası yeniden tasarım. Yenileme sürecini gösteren video (fabrika, test, paketleme).
                    Tüm reklam kreatiflerinde marka hikayesi entegrasyonu.
                  </td>
                  <td className="px-4 py-3 text-center"><span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-orange-500 text-white">YÜKSEK</span></td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-bold text-gray-500">5</td>
                  <td className="px-4 py-3 font-semibold text-gray-800">Checkout Güven Eksikliği</td>
                  <td className="px-4 py-3 text-xs text-gray-600">
                    Sepete ekleme var ama ödeme aşamasında terk oranı yüksek.
                    Ödeme sayfasında güven sinyalleri yetersiz.
                  </td>
                  <td className="px-4 py-3 text-xs text-gray-700">
                    Checkout sayfasında güven rozetleri (TSE, Apple Yetkili, 21 gün iade).
                    Exit intent popup: &quot;21 Gün İade Hakkınız Var&quot;.
                    Taksit detayları checkout&apos;ta görünür.
                  </td>
                  <td className="px-4 py-3 text-center"><span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-amber-500 text-white">ORTA</span></td>
                </tr>
                <tr>
                  <td className="px-4 py-3 font-bold text-gray-500">6</td>
                  <td className="px-4 py-3 font-semibold text-gray-800">Ürün Sayfası UX</td>
                  <td className="px-4 py-3 text-xs text-gray-600">
                    Ürün sayfalarında teknik özellikler var ama &quot;neden yenilenmiş almalıyım?&quot;
                    sorusuna cevap verilmiyor. Yenileme süreci anlatılmıyor.
                  </td>
                  <td className="px-4 py-3 text-xs text-gray-700">
                    Her ürün sayfasına &quot;Yenileme Süreci&quot; bölümü. 27 nokta kontrol listesi görsel olarak.
                    Batarya sağlığı, ekran testi gibi sonuçları şeffaf gösterme.
                  </td>
                  <td className="px-4 py-3 text-center"><span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-amber-500 text-white">ORTA</span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Strateji Özet */}
        <div className="p-5 rounded-xl bg-indigo-50 border border-indigo-200">
          <p className="text-sm font-bold text-indigo-900 mb-3">Strateji Özeti: Trendyol&apos;un Güvenini Yenilio.com&apos;a Taşıma</p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="p-3 rounded-lg bg-white border">
              <p className="text-xs font-bold text-indigo-800 mb-1.5">Adım 1 — Görünür Güven</p>
              <p className="text-xs text-gray-600">
                Trendyol&apos;un otomatik sağladığı güveni site&apos;de manuel olarak inşa et:
                TSE logosu, Apple Yetkili rozeti, Ticaret Bakanlığı lisansı, Gürgençler referansı —
                her sayfada, her zaman, above the fold.
              </p>
            </div>
            <div className="p-3 rounded-lg bg-white border">
              <p className="text-xs font-bold text-indigo-800 mb-1.5">Adım 2 — Sosyal Kanıt</p>
              <p className="text-xs text-gray-600">
                Trendyol&apos;daki olumlu yorumları ve deneyimleri yenilio.com&apos;a taşı.
                Gerçek müşteri videoları, Google Reviews, &quot;X kişi bu ürünü aldı&quot; sosyal kanıt
                elementleri ile ziyaretçinin &quot;başkası almış mı?&quot; sorusunu cevapla.
              </p>
            </div>
            <div className="p-3 rounded-lg bg-white border">
              <p className="text-xs font-bold text-indigo-800 mb-1.5">Adım 3 — Sabırlı Funnel</p>
              <p className="text-xs text-gray-600">
                İlk ziyarette satış bekleme. Önce güven inşa et (video, hikaye, rozet),
                sonra retargeting ile hatırlat, en son fiyat/taksit ile dönüştür.
                Yenilenmiş ürün satışı güven gerektirir — bu süreç zaman alır.
              </p>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

const CAT_COLORS = {
  iPhone: { line: '#3b82f6', bg: 'bg-blue-50', border: 'border-blue-200', text: 'text-blue-800', badge: 'bg-blue-100 text-blue-700' },
  Mac:    { line: '#6b7280', bg: 'bg-slate-50', border: 'border-slate-200', text: 'text-slate-800', badge: 'bg-slate-100 text-slate-700' },
  Watch:  { line: '#10b981', bg: 'bg-emerald-50', border: 'border-emerald-200', text: 'text-emerald-800', badge: 'bg-emerald-100 text-emerald-700' },
  iPad:   { line: '#8b5cf6', bg: 'bg-purple-50', border: 'border-purple-200', text: 'text-purple-800', badge: 'bg-purple-100 text-purple-700' },
};

function MiniSparkline({ history, dates, color, maxVal }) {
  if (!history || history.length < 2) return null;
  const dateMap = {};
  history.forEach(h => { dateMap[h.date] = h.stock; });
  const vals = dates.map(d => dateMap[d] ?? null);
  const mx = maxVal || Math.max(...vals.filter(v => v !== null), 1);

  const w = 80, h = 24;
  const pts = [];
  vals.forEach((v, i) => {
    if (v === null) return;
    const x = (i / (dates.length - 1)) * w;
    const y = h - (v / mx) * (h - 2) - 1;
    pts.push(`${x},${y}`);
  });

  return (
    <svg width={w} height={h} className="inline-block">
      <polyline points={pts.join(' ')} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function StockSection() {
  const [data, setData] = useState(null);
  const [expandedCat, setExpandedCat] = useState('iPhone');

  useEffect(() => {
    fetch('/yenilio-stock-data.json')
      .then(r => r.json())
      .then(d => setData(d))
      .catch(() => {});
  }, []);

  if (!data) return null;

  const { daily, products, dates } = data;
  const categories = ['iPhone', 'Mac', 'Watch', 'iPad'];
  const latest = daily[daily.length - 1];
  const first = daily[0];

  const fmtD = (d) => { const [y, m, day] = d.split('-'); return `${day}.${m}`; };

  const maxTotal = Math.max(...daily.flatMap(d => categories.map(c => d.categories[c]?.total || 0)));

  return (
    <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">
      <div className="px-6 py-4 border-b bg-gray-50">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-bold text-gray-900">Yenilio Stok Takibi — Ürün Bazlı Günlük Stok</h2>
          <span className="text-xs text-gray-500">{fmtD(first.date)} — {fmtD(latest.date)} ({daily.length} gün veri)</span>
        </div>
      </div>

      <div className="p-6 space-y-6">

        {/* Summary Cards */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {categories.map(cat => {
            const cc = CAT_COLORS[cat];
            const current = latest.categories[cat]?.total || 0;
            const prev = first.categories[cat]?.total || 0;
            const diff = current - prev;
            const inStock = (products[cat] || []).filter(p => p.latestStock > 0).length;
            const total = (products[cat] || []).length;
            return (
              <div key={cat} className={`p-4 rounded-xl ${cc.bg} border ${cc.border}`}>
                <p className={`text-xs font-medium ${cc.text}`}>{cat}</p>
                <p className={`text-2xl font-bold ${cc.text} mt-1`}>{current.toLocaleString('tr-TR')} adet</p>
                <p className="text-xs text-gray-500 mt-1">
                  {diff > 0 ? '+' : ''}{diff} vs {fmtD(first.date)} &middot; {inStock}/{total} ürün stokta
                </p>
              </div>
            );
          })}
        </div>

        {/* Category Trend Chart */}
        <div className="rounded-xl border overflow-hidden">
          <div className="px-4 py-3 bg-gray-50 border-b flex items-center justify-between">
            <p className="font-semibold text-sm text-gray-800">Kategori Toplam Stok Trendi</p>
            <div className="flex gap-3">
              {categories.map(cat => (
                <span key={cat} className="flex items-center gap-1.5 text-xs text-gray-600">
                  <span className="w-3 h-1.5 rounded-full" style={{ backgroundColor: CAT_COLORS[cat].line }} />
                  {cat}
                </span>
              ))}
            </div>
          </div>
          <div className="p-4">
            <svg viewBox="0 0 900 260" className="w-full" style={{ minHeight: 200 }}>
              {[0, 0.25, 0.5, 0.75, 1].map((pct, i) => {
                const y = 240 - pct * 220;
                return (
                  <g key={i}>
                    <line x1="40" y1={y} x2="880" y2={y} stroke="#e5e7eb" strokeWidth="1" />
                    <text x="35" y={y + 4} textAnchor="end" fill="#9ca3af" fontSize="10">{Math.round(maxTotal * pct)}</text>
                  </g>
                );
              })}
              {daily.map((d, i) => {
                const x = 40 + (i / (daily.length - 1)) * 840;
                return i % Math.max(1, Math.floor(daily.length / 8)) === 0 ? (
                  <text key={i} x={x} y={256} textAnchor="middle" fill="#9ca3af" fontSize="9">{fmtD(d.date)}</text>
                ) : null;
              })}
              {categories.map(cat => {
                const points = daily.map((d, i) => {
                  const x = 40 + (i / (daily.length - 1)) * 840;
                  const val = d.categories[cat]?.total || 0;
                  const y = 240 - (val / maxTotal) * 220;
                  return `${x},${y}`;
                }).join(' ');
                return <polyline key={cat} points={points} fill="none" stroke={CAT_COLORS[cat].line} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />;
              })}
              {categories.map(cat => {
                const val = latest.categories[cat]?.total || 0;
                const y = 240 - (val / maxTotal) * 220;
                return <circle key={cat} cx={880} cy={y} r="4" fill={CAT_COLORS[cat].line} />;
              })}
            </svg>
          </div>
        </div>

        {/* Product-Level Stock — per category */}
        {categories.map(cat => {
          const cc = CAT_COLORS[cat];
          const prods = products[cat] || [];
          const inStock = prods.filter(p => p.latestStock > 0);
          const outStock = prods.filter(p => p.latestStock === 0);
          const isExpanded = expandedCat === cat;
          const catMax = Math.max(...prods.map(p => Math.max(...p.history.map(h => h.stock))), 1);

          return (
            <div key={cat} className="rounded-xl border overflow-hidden">
              <button
                onClick={() => setExpandedCat(isExpanded ? null : cat)}
                className={`w-full px-4 py-3 ${cc.bg} border-b ${cc.border} flex items-center justify-between`}
              >
                <div className="flex items-center gap-2">
                  <span className={`font-bold text-sm ${cc.text}`}>{cat}</span>
                  <span className={`text-[10px] px-2 py-0.5 rounded-full ${cc.badge}`}>
                    {latest.categories[cat]?.total || 0} adet güncel stok
                  </span>
                  <span className="text-[10px] text-gray-500">{inStock.length} stokta / {outStock.length} stok dışı</span>
                </div>
                <span className="text-gray-400 text-xs">{isExpanded ? '▲' : '▼'}</span>
              </button>
              {isExpanded && (
                <div className="overflow-x-auto">
                  <table className="min-w-full text-xs">
                    <thead className="bg-gray-50 sticky top-0">
                      <tr>
                        <th className="px-3 py-2 text-left font-medium text-gray-500">Ürün</th>
                        <th className="px-3 py-2 text-right font-medium text-gray-500 w-20">Güncel Stok</th>
                        <th className="px-3 py-2 text-center font-medium text-gray-500 w-24">Trend</th>
                        {dates.map(d => (
                          <th key={d} className="px-1.5 py-2 text-center font-medium text-gray-400 w-10" style={{ minWidth: 36 }}>{fmtD(d)}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-50">
                      {inStock.map((p, i) => {
                        const dateMap = {};
                        p.history.forEach(h => { dateMap[h.date] = h.stock; });
                        const prevStock = p.history.length >= 2 ? p.history[p.history.length - 2].stock : p.latestStock;
                        const diff = p.latestStock - prevStock;
                        return (
                          <tr key={i} className="hover:bg-gray-50">
                            <td className="px-3 py-2 font-medium text-gray-800 whitespace-nowrap">{p.name}</td>
                            <td className="px-3 py-2 text-right">
                              <span className="font-bold text-gray-900">{p.latestStock}</span>
                              {diff !== 0 && (
                                <span className={`ml-1 text-[10px] ${diff > 0 ? 'text-green-600' : 'text-red-500'}`}>
                                  {diff > 0 ? '+' : ''}{diff}
                                </span>
                              )}
                            </td>
                            <td className="px-3 py-2 text-center">
                              <MiniSparkline history={p.history} dates={dates} color={cc.line} maxVal={catMax} />
                            </td>
                            {dates.map(d => {
                              const val = dateMap[d];
                              return (
                                <td key={d} className={`px-1.5 py-2 text-center tabular-nums ${val === undefined ? 'text-gray-200' : val === 0 ? 'text-red-300' : 'text-gray-700'}`}>
                                  {val === undefined ? '—' : val}
                                </td>
                              );
                            })}
                          </tr>
                        );
                      })}
                      {outStock.length > 0 && (
                        <tr className="bg-gray-50">
                          <td colSpan={3 + dates.length} className="px-3 py-2 text-gray-400 italic">
                            {outStock.length} ürün stok dışı: {outStock.map(p => p.name).join(', ')}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          );
        })}

        {/* Daily Category Totals Table */}
        <div className="rounded-xl border overflow-hidden">
          <div className="px-4 py-3 bg-gray-50 border-b">
            <p className="font-semibold text-sm text-gray-800">Günlük Kategori Toplam Stok</p>
          </div>
          <div className="overflow-x-auto">
            <table className="min-w-full text-sm">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500">Tarih</th>
                  {categories.map(c => (
                    <th key={c} className="px-4 py-2 text-right text-xs font-medium text-gray-500">{c}</th>
                  ))}
                  <th className="px-4 py-2 text-right text-xs font-medium text-gray-500 bg-gray-100">Toplam</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {[...daily].reverse().map((d, i) => {
                  const totals = categories.map(c => d.categories[c]?.total || 0);
                  const grand = totals.reduce((a, b) => a + b, 0);
                  return (
                    <tr key={i} className={i === 0 ? 'bg-blue-50/50 font-medium' : 'hover:bg-gray-50'}>
                      <td className="px-4 py-2 text-xs text-gray-700">{fmtD(d.date)}</td>
                      {totals.map((t, j) => (
                        <td key={j} className="px-4 py-2 text-xs text-right text-gray-700">{t.toLocaleString('tr-TR')}</td>
                      ))}
                      <td className="px-4 py-2 text-xs text-right font-semibold text-gray-900 bg-gray-50">{grand.toLocaleString('tr-TR')}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
  );
}

function ActionPlanSection() {
  const weeks = [
    {
      week: 'Hafta 1', subtitle: 'Temel Revizyon',
      google: ['Tüm RSA\'larda H1-H2 pin\'leme', 'iPad ve Watch kampanyaları oluşturma', 'MacBook keyword genişletme', 'Brand vs Non-brand ayrımı'],
      meta: ['Funnel yapısı kurulumu (3 katman)', 'Marka hikayesi video kreatifleri', 'Mac/iPad/Watch ayrı ad set\'ler'],
      site: ['Landing page güven hiyerarşisi', 'Trendyol yorumlarını taşıma'],
    },
    {
      week: 'Hafta 2', subtitle: 'Kreatif & İçerik',
      google: ['Yeni reklam metinleri yayına alma', 'Negatif kelime listesi güncelleme', 'YouTube Video kampanyası (awareness)'],
      meta: ['Güven carousel kreatifleri', 'Yenileme süreci görselleri', 'A/B test: fiyat vs güven'],
      site: ['Video testimonial çekimleri', 'Güven rozeti standartlaştırma'],
    },
    {
      week: 'Hafta 3', subtitle: 'Optimizasyon',
      google: ['İlk hafta verisine göre bid ayarı', 'Düşük CTR keyword eleme', 'Yüksek performansa bütçe kaydırma'],
      meta: ['Kazanan kreatif scale', 'Remarketing havuzu değerlendirme', 'Lookalike genişletme'],
      site: ['Heatmap analizi', 'Checkout flow iyileştirme'],
    },
    {
      week: 'Hafta 4', subtitle: 'Rapor & Scale',
      google: ['Brand vs Non-brand performans raporu', 'Ürün grubu bazlı ROAS analizi', 'Bütçe reallokasyonu önerisi'],
      meta: ['Funnel kırılımlı performans raporu', 'Kreatif yorgunluk analizi', 'Yeni ay planı'],
      site: ['CVR karşılaştırması (öncesi vs sonrası)', 'Trendyol vs Yenilio.com gap güncelleme'],
    },
  ];

  return (
    <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">
      <div className="px-6 py-4 border-b bg-gray-900">
        <h2 className="text-lg font-bold text-white">📋 30 Günlük Revize Aksiyon Planı</h2>
      </div>
      <div className="p-6">
        <table className="min-w-full text-sm divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-2.5 text-left text-xs font-medium text-gray-500 w-28">Hafta</th>
              <th className="px-4 py-2.5 text-left text-xs font-medium text-gray-500">Google Ads</th>
              <th className="px-4 py-2.5 text-left text-xs font-medium text-gray-500">Meta Ads</th>
              <th className="px-4 py-2.5 text-left text-xs font-medium text-gray-500">Site / CRO</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {weeks.map((w, i) => (
              <tr key={i}>
                <td className="px-4 py-3 align-top">
                  <p className="font-bold text-gray-800">{w.week}</p>
                  <p className="text-[10px] text-gray-400">{w.subtitle}</p>
                </td>
                <td className="px-4 py-3 align-top"><ul className="space-y-1 text-xs text-gray-700">{w.google.map((g, j) => <li key={j}>• {g}</li>)}</ul></td>
                <td className="px-4 py-3 align-top"><ul className="space-y-1 text-xs text-gray-700">{w.meta.map((m, j) => <li key={j}>• {m}</li>)}</ul></td>
                <td className="px-4 py-3 align-top"><ul className="space-y-1 text-xs text-gray-700">{w.site.map((s, j) => <li key={j}>• {s}</li>)}</ul></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════════════════════ */
/*  KAMPANYA BAZLI SATIS PERFORMANSI — Campaign Type Karsilastirmasi          */
/* ═══════════════════════════════════════════════════════════════════════════ */

const G_TYPES = ['Search (Brand)','Performance Max','Search (Generic)','Display (GDN)','YouTube / Video','Search (Diger)'];
const G_TYPE_COLORS = {
  'Search (Brand)':    { bg: 'bg-blue-600', text: 'text-blue-800', light: 'bg-blue-50' },
  'Performance Max':   { bg: 'bg-emerald-600', text: 'text-emerald-800', light: 'bg-emerald-50' },
  'Search (Generic)':  { bg: 'bg-amber-500', text: 'text-amber-800', light: 'bg-amber-50' },
  'Display (GDN)':     { bg: 'bg-red-400', text: 'text-red-700', light: 'bg-red-50' },
  'YouTube / Video':   { bg: 'bg-red-600', text: 'text-red-800', light: 'bg-red-50' },
  'Search (Diger)':    { bg: 'bg-gray-400', text: 'text-gray-700', light: 'bg-gray-50' },
};

const G_TYPE_DATA = {
  '2025-09': { 'Search (Brand)': { spend:5494, value:325164, conv:252 }, 'Performance Max': { spend:21974, value:39861, conv:297 }, 'Search (Generic)': { spend:3296, value:0, conv:73 } },
  '2025-10': { 'Search (Brand)': { spend:35412, value:1174502, conv:1361 }, 'Performance Max': { spend:76125, value:742796, conv:1828 }, 'Search (Generic)': { spend:52772, value:78911, conv:649 } },
  '2025-11': { 'Search (Brand)': { spend:32197, value:606124, conv:1342 }, 'Performance Max': { spend:36739, value:316284, conv:1442 }, 'Search (Generic)': { spend:57845, value:33770, conv:870 } },
  '2025-12': { 'Search (Brand)': { spend:45591, value:1413443, conv:1731 }, 'Performance Max': { spend:103712, value:816441, conv:2739 }, 'Search (Generic)': { spend:90767, value:74481, conv:909 } },
  '2026-01': { 'Search (Brand)': { spend:50016, value:1293213, conv:1692 }, 'Performance Max': { spend:106430, value:1061590, conv:2856 }, 'Search (Generic)': { spend:95136, value:26950, conv:842 }, 'Display (GDN)': { spend:17017, value:0, conv:0 } },
  '2026-02': { 'Search (Brand)': { spend:54745, value:635284, conv:1162 }, 'Performance Max': { spend:102416, value:354896, conv:2040 }, 'Search (Generic)': { spend:88561, value:72585, conv:539 }, 'Display (GDN)': { spend:22093, value:0, conv:0 }, 'YouTube / Video': { spend:6009, value:0, conv:0 } },
  '2026-03': { 'Search (Brand)': { spend:40730, value:1104551, conv:881 }, 'Performance Max': { spend:40394, value:268162, conv:976 }, 'Search (Generic)': { spend:21632, value:0, conv:113 }, 'Display (GDN)': { spend:6943, value:0, conv:0 }, 'YouTube / Video': { spend:22101, value:0, conv:0 }, 'Search (Diger)': { spend:5028, value:145322, conv:4 } },
};

const M_TYPES = ['Sales / Conversion','Advantage+ Catalog','Engagement','Location (Awareness)','Reach / Awareness','Traffic'];
const M_TYPE_COLORS = {
  'Sales / Conversion':   { bg: 'bg-green-600', text: 'text-green-800', light: 'bg-green-50' },
  'Advantage+ Catalog':   { bg: 'bg-purple-600', text: 'text-purple-800', light: 'bg-purple-50' },
  'Engagement':           { bg: 'bg-red-400', text: 'text-red-700', light: 'bg-red-50' },
  'Location (Awareness)': { bg: 'bg-red-500', text: 'text-red-700', light: 'bg-red-50' },
  'Reach / Awareness':    { bg: 'bg-orange-400', text: 'text-orange-700', light: 'bg-orange-50' },
  'Traffic':              { bg: 'bg-gray-400', text: 'text-gray-600', light: 'bg-gray-50' },
};

const M_TYPE_DATA = {
  '2025-09': { 'Sales / Conversion': { spend:16758, value:165650 }, 'Advantage+ Catalog': { spend:19572, value:167258 }, 'Traffic': { spend:8217, value:0 } },
  '2025-10': { 'Sales / Conversion': { spend:72192, value:1405763 }, 'Advantage+ Catalog': { spend:43138, value:285289 } },
  '2025-11': { 'Sales / Conversion': { spend:52604, value:164426 }, 'Advantage+ Catalog': { spend:27775, value:130351 } },
  '2025-12': { 'Sales / Conversion': { spend:47391, value:783288 }, 'Advantage+ Catalog': { spend:31062, value:429459 }, 'Engagement': { spend:3620, value:0 } },
  '2026-01': { 'Sales / Conversion': { spend:77167, value:780501 }, 'Advantage+ Catalog': { spend:32323, value:166700 }, 'Engagement': { spend:25982, value:0 } },
  '2026-02': { 'Sales / Conversion': { spend:80143, value:306013 }, 'Advantage+ Catalog': { spend:44769, value:309524 }, 'Engagement': { spend:50648, value:0 }, 'Reach / Awareness': { spend:2628, value:0 } },
  '2026-03': { 'Sales / Conversion': { spend:64057, value:835891 }, 'Advantage+ Catalog': { spend:56591, value:371421 }, 'Engagement': { spend:2584, value:0 }, 'Location (Awareness)': { spend:50023, value:16999 }, 'Reach / Awareness': { spend:11063, value:0 } },
};

function CampaignTypeSection() {
  const [platform, setPlatform] = useState('google');

  const data = platform === 'google' ? G_TYPE_DATA : M_TYPE_DATA;
  const types = platform === 'google' ? G_TYPES : M_TYPES;
  const colors = platform === 'google' ? G_TYPE_COLORS : M_TYPE_COLORS;

  // 6 ay toplam hesapla
  const totals = {};
  types.forEach(t => {
    const spend = MONTHS_6.reduce((s,m) => s + (data[m]?.[t]?.spend || 0), 0);
    const value = MONTHS_6.reduce((s,m) => s + (data[m]?.[t]?.value || 0), 0);
    totals[t] = { spend, value, roas: spend > 0 ? (value / spend).toFixed(2) : 0 };
  });
  const grandSpend = Object.values(totals).reduce((s,v) => s + v.spend, 0);
  const grandValue = Object.values(totals).reduce((s,v) => s + v.value, 0);

  // Sort types by total spend
  const sortedTypes = [...types].sort((a,b) => (totals[b]?.spend || 0) - (totals[a]?.spend || 0));

  return (
    <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">
      <div className="px-6 py-4 border-b bg-gradient-to-r from-gray-900 to-gray-800">
        <h2 className="text-lg font-bold text-white">Kampanya Bazli Satis Performansi — Campaign Type Karsilastirmasi</h2>
        <p className="text-xs text-gray-300 mt-1">Son 6 ay, kampanya tipine gore harcama ve getiri analizi</p>
      </div>

      <div className="border-b bg-gray-50 px-6">
        <div className="flex gap-1 py-2">
          {[
            { id: 'google', label: 'Google Ads', icon: '🔍' },
            { id: 'meta', label: 'Meta Ads', icon: '📣' },
          ].map(t => (
            <button key={t.id} onClick={() => setPlatform(t.id)}
              className={`px-5 py-2 text-xs font-medium rounded-lg transition-colors ${platform === t.id ? 'bg-gray-900 text-white' : 'text-gray-600 hover:bg-gray-200'}`}
            >{t.icon} {t.label}</button>
          ))}
        </div>
      </div>

      <div className="p-6 space-y-6">

        {/* Toplam ozet kartlari */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
          {sortedTypes.filter(t => totals[t].spend > 0).map(t => {
            const d = totals[t];
            const c = colors[t] || { bg: 'bg-gray-400', text: 'text-gray-700', light: 'bg-gray-50' };
            const pct = grandSpend > 0 ? ((d.spend / grandSpend) * 100).toFixed(0) : 0;
            const isWaste = Number(d.roas) === 0;
            return (
              <div key={t} className={`p-3 rounded-xl border ${isWaste ? 'border-red-300 bg-red-50/50' : 'border-gray-200'}`}>
                <div className="flex items-center gap-1.5 mb-2">
                  <span className={`w-2.5 h-2.5 rounded-full ${c.bg}`} />
                  <p className={`text-[10px] font-bold ${c.text}`}>{t}</p>
                </div>
                <p className="text-sm font-bold text-gray-900">{fmt(d.spend)} TL</p>
                <p className="text-[10px] text-gray-500">%{pct} toplam butce</p>
                <div className="mt-2 pt-2 border-t">
                  <p className="text-[10px] text-gray-500">Getiri: {fmt(d.value)} TL</p>
                  <p className={`text-xs font-bold mt-0.5 ${isWaste ? 'text-red-600' : Number(d.roas) >= 5 ? 'text-green-700' : 'text-amber-600'}`}>
                    ROAS: {d.roas}x {isWaste && '⚠️'}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Bar chart - proportional spend */}
        <div className="rounded-xl border overflow-hidden">
          <div className="px-4 py-3 bg-gray-50 border-b">
            <p className="font-semibold text-sm text-gray-800">6 Aylik Butce Dagilimi (Kampanya Tipine Gore)</p>
          </div>
          <div className="p-4">
            <div className="flex rounded-lg overflow-hidden h-10">
              {sortedTypes.filter(t => totals[t].spend > 0).map(t => {
                const pct = grandSpend > 0 ? (totals[t].spend / grandSpend) * 100 : 0;
                const c = colors[t] || { bg: 'bg-gray-400' };
                return pct > 0 ? (
                  <div key={t} className={`${c.bg} flex items-center justify-center`} style={{ width: `${pct}%` }}
                    title={`${t}: ${fmt(totals[t].spend)} TL (%${pct.toFixed(0)})`}
                  >
                    {pct > 8 && <span className="text-[9px] text-white font-bold truncate px-1">%{pct.toFixed(0)}</span>}
                  </div>
                ) : null;
              })}
            </div>
            <div className="flex flex-wrap gap-3 mt-3">
              {sortedTypes.filter(t => totals[t].spend > 0).map(t => {
                const c = colors[t] || { bg: 'bg-gray-400', text: 'text-gray-600' };
                const pct = grandSpend > 0 ? ((totals[t].spend / grandSpend) * 100).toFixed(0) : 0;
                return (
                  <span key={t} className="flex items-center gap-1.5 text-[10px] text-gray-600">
                    <span className={`w-2.5 h-2.5 rounded-sm ${c.bg}`} />
                    {t} (%{pct})
                  </span>
                );
              })}
            </div>
          </div>
        </div>

        {/* Aylik detay tablosu */}
        <div className="rounded-xl border overflow-hidden">
          <div className="px-4 py-3 bg-gray-50 border-b">
            <p className="font-semibold text-sm text-gray-800">Aylik Harcama &amp; ROAS — Kampanya Tipine Gore</p>
          </div>
          <div className="overflow-x-auto">
            <table className="min-w-full text-xs divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-3 py-2 text-left font-medium text-gray-500">Ay</th>
                  {sortedTypes.filter(t => totals[t].spend > 0).map(t => (
                    <th key={t} className="px-2 py-2 text-center font-medium border-l" colSpan={2}>
                      <span className={`text-[10px] ${(colors[t] || {text:'text-gray-600'}).text}`}>{t}</span>
                    </th>
                  ))}
                  <th className="px-2 py-2 text-right font-medium text-gray-700 border-l bg-gray-100">Toplam</th>
                </tr>
                <tr>
                  <th className="px-3 py-1"></th>
                  {sortedTypes.filter(t => totals[t].spend > 0).map(t => (
                    <React.Fragment key={t}>
                      <th className="px-1 py-1 text-right text-[9px] text-gray-400 border-l">Harcama</th>
                      <th className="px-1 py-1 text-right text-[9px] text-gray-400">ROAS</th>
                    </React.Fragment>
                  ))}
                  <th className="px-2 py-1 text-right text-[9px] text-gray-400 border-l bg-gray-100">Harcama</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {MONTHS_6.map(m => {
                  const monthTotal = sortedTypes.reduce((s,t) => s + (data[m]?.[t]?.spend || 0), 0);
                  return (
                    <tr key={m} className={m === '2026-03' ? 'bg-yellow-50/50 font-medium' : ''}>
                      <td className="px-3 py-2.5 font-semibold text-gray-800">{MONTH_LABELS[m]}</td>
                      {sortedTypes.filter(t => totals[t].spend > 0).map(t => {
                        const d = data[m]?.[t];
                        if (!d || d.spend === 0) return (
                          <React.Fragment key={t}>
                            <td className="px-1 py-2.5 text-right text-gray-300 border-l">—</td>
                            <td className="px-1 py-2.5 text-right text-gray-300">—</td>
                          </React.Fragment>
                        );
                        const roas = d.spend > 0 ? (d.value / d.spend).toFixed(1) : 0;
                        return (
                          <React.Fragment key={t}>
                            <td className="px-1 py-2.5 text-right border-l">{fmtK(d.spend)}</td>
                            <td className={`px-1 py-2.5 text-right font-bold ${Number(roas) >= 5 ? 'text-green-700' : Number(roas) > 0 ? 'text-amber-600' : 'text-red-400'}`}>{roas}x</td>
                          </React.Fragment>
                        );
                      })}
                      <td className="px-2 py-2.5 text-right font-semibold border-l bg-gray-50">{fmt(monthTotal)}</td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot className="bg-gray-100 font-bold">
                <tr>
                  <td className="px-3 py-2.5">6 AY TOPLAM</td>
                  {sortedTypes.filter(t => totals[t].spend > 0).map(t => {
                    const d = totals[t];
                    return (
                      <React.Fragment key={t}>
                        <td className="px-1 py-2.5 text-right border-l">{fmtK(d.spend)}</td>
                        <td className={`px-1 py-2.5 text-right ${Number(d.roas) >= 5 ? 'text-green-700' : Number(d.roas) > 0 ? 'text-amber-600' : 'text-red-500'}`}>{d.roas}x</td>
                      </React.Fragment>
                    );
                  })}
                  <td className="px-2 py-2.5 text-right border-l bg-gray-50">{fmt(grandSpend)}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>

        {/* Getiri tablosu */}
        <div className="rounded-xl border overflow-hidden">
          <div className="px-4 py-3 bg-gray-50 border-b">
            <p className="font-semibold text-sm text-gray-800">Aylik Getiri (Conversion Value) — Kampanya Tipine Gore</p>
          </div>
          <div className="overflow-x-auto">
            <table className="min-w-full text-xs divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-3 py-2 text-left font-medium text-gray-500">Ay</th>
                  {sortedTypes.filter(t => totals[t].spend > 0).map(t => (
                    <th key={t} className={`px-2 py-2 text-right font-medium border-l text-[10px] ${(colors[t]||{text:'text-gray-600'}).text}`}>{t}</th>
                  ))}
                  <th className="px-2 py-2 text-right font-medium text-gray-700 border-l bg-gray-100">Toplam</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {MONTHS_6.map(m => {
                  const monthValue = sortedTypes.reduce((s,t) => s + (data[m]?.[t]?.value || 0), 0);
                  return (
                    <tr key={m} className={m === '2026-03' ? 'bg-yellow-50/50 font-medium' : ''}>
                      <td className="px-3 py-2.5 font-semibold text-gray-800">{MONTH_LABELS[m]}</td>
                      {sortedTypes.filter(t => totals[t].spend > 0).map(t => {
                        const d = data[m]?.[t];
                        const val = d?.value || 0;
                        return (
                          <td key={t} className={`px-2 py-2.5 text-right border-l ${val > 0 ? 'font-medium' : 'text-gray-300'}`}>
                            {val > 0 ? fmt(val) : '—'}
                          </td>
                        );
                      })}
                      <td className="px-2 py-2.5 text-right font-bold border-l bg-gray-50">{fmt(monthValue)}</td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot className="bg-gray-100 font-bold">
                <tr>
                  <td className="px-3 py-2.5">6 AY TOPLAM</td>
                  {sortedTypes.filter(t => totals[t].spend > 0).map(t => (
                    <td key={t} className={`px-2 py-2.5 text-right border-l ${totals[t].value > 0 ? '' : 'text-red-500'}`}>{fmt(totals[t].value)}</td>
                  ))}
                  <td className="px-2 py-2.5 text-right border-l bg-gray-50">{fmt(grandValue)}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>

        {/* Insight box */}
        <div className="p-4 rounded-xl bg-gradient-to-r from-gray-900 to-gray-800 text-white">
          <p className="text-sm font-bold mb-2">
            {platform === 'google' ? 'Google Ads Ozet' : 'Meta Ads Ozet'}
          </p>
          {platform === 'google' ? (
            <ul className="text-xs text-gray-300 space-y-1.5 leading-relaxed">
              <li>&bull; <strong className="text-white">Search (Brand)</strong> en yuksek ROAS (24.80x) — 264K TL harcama, 6.55M TL getiri. Ciromuzun ana motoru.</li>
              <li>&bull; <strong className="text-white">Performance Max</strong> en yuksek hacimli kanal (488K TL) — ROAS 7.38x, iyi performans.</li>
              <li>&bull; <strong className="text-red-400">Search (Generic)</strong> ciddi sorunlu — 410K TL harcama, sadece 287K TL getiri (ROAS 0.70x). Zarar ediyor!</li>
              <li>&bull; <strong className="text-red-400">Display + YouTube</strong> toplam 74K TL, 0 getiri. Tamamen israf.</li>
              <li>&bull; <strong className="text-green-400">Oneri:</strong> Generic Search&apos;te conversion tracking duzeltilmeli (value=0 gorunuyor). Display/YouTube durdurulmali.</li>
            </ul>
          ) : (
            <ul className="text-xs text-gray-300 space-y-1.5 leading-relaxed">
              <li>&bull; <strong className="text-white">Sales / Conversion</strong> en cok getiren (4.44M TL, ROAS 10.82x) — butcenin %50&apos;si, dogru yatirim.</li>
              <li>&bull; <strong className="text-white">Advantage+ Catalog</strong> saglam performans (1.86M TL, ROAS 7.29x) — butcenin %31&apos;i.</li>
              <li>&bull; <strong className="text-red-400">Engagement</strong> 83K TL harcama, 0 getiri. Satis odakli degilse bile cok pahali.</li>
              <li>&bull; <strong className="text-red-400">Location + Reach</strong> 64K TL harcama, 17K TL getiri. Magaza trafigi icin bile verimsiz.</li>
              <li>&bull; <strong className="text-green-400">Oneri:</strong> Butceyi Sales + Advantage+ Catalog&apos;a yogunlastir. Engagement/Location&apos;i azalt veya durdur.</li>
            </ul>
          )}
        </div>

      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════════════════════ */
/*  REMARKETING ANALIZI — Son 6 Ay                                            */
/* ═══════════════════════════════════════════════════════════════════════════ */

const MONTHS_6 = ['2025-09','2025-10','2025-11','2025-12','2026-01','2026-02','2026-03'];
const MONTH_LABELS = { '2025-09':'Eyl 25','2025-10':'Eki 25','2025-11':'Kas 25','2025-12':'Ara 25','2026-01':'Oca 26','2026-02':'Sub 26','2026-03':'Mar 26' };

const META_RM_ADSETS = {
  '2025-09': { spend: 8333, value: 108209, clicks: 1677, roas: 12.99 },
  '2025-10': { spend: 23427, value: 610152, clicks: 5424, roas: 26.04 },
  '2025-11': { spend: 1702, value: 0, clicks: 336, roas: 0 },
  '2025-12': { spend: 3160, value: 132954, clicks: 962, roas: 42.08 },
  '2026-01': { spend: 2756, value: 35999, clicks: 743, roas: 13.06 },
  '2026-02': { spend: 14905, value: 71997, clicks: 4784, roas: 4.83 },
  '2026-03': { spend: 0, value: 0, clicks: 0, roas: 0 },
};

const META_ADV_CATALOG = {
  '2025-09': { spend: 19572, value: 167258, clicks: 13765, roas: 8.55 },
  '2025-10': { spend: 43138, value: 285289, clicks: 47437, roas: 6.61 },
  '2025-11': { spend: 27775, value: 130351, clicks: 39947, roas: 4.69 },
  '2025-12': { spend: 31062, value: 429459, clicks: 50642, roas: 13.83 },
  '2026-01': { spend: 32323, value: 166700, clicks: 55369, roas: 5.16 },
  '2026-02': { spend: 44769, value: 309524, clicks: 63187, roas: 6.91 },
  '2026-03': { spend: 56591, value: 371421, clicks: 18255, roas: 6.56 },
};

const META_TOTAL = {
  '2025-09': { spend: 44547, value: 332908, roas: 7.47 },
  '2025-10': { spend: 115330, value: 1691052, roas: 14.66 },
  '2025-11': { spend: 80379, value: 294777, roas: 3.67 },
  '2025-12': { spend: 82073, value: 1212747, roas: 14.78 },
  '2026-01': { spend: 135472, value: 947201, roas: 6.99 },
  '2026-02': { spend: 178188, value: 615537, roas: 3.45 },
  '2026-03': { spend: 184319, value: 1224311, roas: 6.64 },
};

const GOOGLE_PMAX = {
  '2025-09': { spend: 21974, value: 39861, roas: 1.81 },
  '2025-10': { spend: 76125, value: 742796, roas: 9.76 },
  '2025-11': { spend: 36739, value: 316284, roas: 8.61 },
  '2025-12': { spend: 103712, value: 816441, roas: 7.87 },
  '2026-01': { spend: 106430, value: 1061590, roas: 9.97 },
  '2026-02': { spend: 102416, value: 354896, roas: 3.47 },
  '2026-03': { spend: 40394, value: 268162, roas: 6.64 },
};

const GOOGLE_TOTAL = {
  '2025-09': { spend: 30764, value: 365025, roas: 11.87 },
  '2025-10': { spend: 164308, value: 1996210, roas: 12.15 },
  '2025-11': { spend: 126781, value: 956178, roas: 7.54 },
  '2025-12': { spend: 240070, value: 2304365, roas: 9.60 },
  '2026-01': { spend: 268599, value: 2381753, roas: 8.87 },
  '2026-02': { spend: 273822, value: 1062765, roas: 3.88 },
  '2026-03': { spend: 136827, value: 1518035, roas: 11.09 },
};

const META_RM_ADSET_DETAIL = [
  { name: 'Remarketing', campaign: 'iPhone 11 | Fiyat Teklifi | 12 Ay Taksit', spend: 14469, value: 133279, roas: 9.21 },
  { name: 'Remarketing', campaign: 'Gulümseten Gece Fırsatları - 12 Taksit', spend: 10536, value: 382478, roas: 36.30 },
  { name: 'Remarketing', campaign: 'Vakıfbank | Cashback | Ekim', spend: 4465, value: 112058, roas: 25.09 },
  { name: 'Remarketing', campaign: 'iPhone 12 | Fiyat Teklifi | 12 Ay Taksit', spend: 4288, value: 125809, roas: 29.34 },
  { name: 'iPhone 11 - 12 Taksit & Interest / RM', campaign: 'Sevgililer Gunu', spend: 3471, value: 0, roas: 0 },
  { name: 'Generic - 12 Taksit & Interest / RM', campaign: 'Sevgililer Gunu', spend: 3154, value: 43197, roas: 13.70 },
  { name: 'Remarketing', campaign: 'iPhone 14 | Fiyat Teklifi | 12 Ay Taksit', spend: 2421, value: 64892, roas: 26.81 },
  { name: 'Kalp Atisi - iPhone - Interest & RM', campaign: 'Sevgililer Gunu', spend: 2234, value: 0, roas: 0 },
  { name: 'Kalp Atisi - MacBook - Interest & RM', campaign: 'Sevgililer Gunu', spend: 2171, value: 0, roas: 0 },
  { name: 'Kalp Atisi - Watch - Interest & RM', campaign: 'Sevgililer Gunu', spend: 2088, value: 0, roas: 0 },
  { name: 'Remarketing', campaign: 'BTS | Mac Kampanyasi', spend: 1981, value: 69088, roas: 34.87 },
  { name: 'Remarketing', campaign: 'BTS | iPhone Kampanyasi', spend: 967, value: 28510, roas: 29.47 },
  { name: 'Remarketing', campaign: 'Diger (6 kampanya)', spend: 2036, value: 0, roas: 0 },
];

const fmt = (n) => n.toLocaleString('tr-TR');
const fmtK = (n) => n >= 1000 ? `${(n/1000).toFixed(0)}K` : fmt(n);

function RemarketingSection() {
  const [view, setView] = useState('overview');

  // Meta RM toplam (adset remarketing + adv+ catalog)
  const metaRmTotal = {};
  MONTHS_6.forEach(m => {
    const rm = META_RM_ADSETS[m] || { spend:0, value:0 };
    const adv = META_ADV_CATALOG[m] || { spend:0, value:0 };
    const spend = rm.spend + adv.spend;
    const value = rm.value + adv.value;
    metaRmTotal[m] = { spend, value, roas: spend > 0 ? +(value/spend).toFixed(2) : 0 };
  });

  // Google RM = PMax (aciklama ile)
  const googleRm = {};
  MONTHS_6.forEach(m => {
    const p = GOOGLE_PMAX[m] || { spend:0, value:0 };
    googleRm[m] = { spend: p.spend, value: p.value, roas: p.roas };
  });

  return (
    <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">
      <div className="px-6 py-4 border-b bg-gradient-to-r from-purple-900 to-purple-800">
        <h2 className="text-lg font-bold text-white">Remarketing / Retargeting Analizi — Son 6 Ay</h2>
        <p className="text-xs text-purple-200 mt-1">Kampanya ve ad group isimlerinden &quot;Remarketing&quot;, &quot;RM&quot;, &quot;Retargeting&quot;, &quot;Advantage+ Catalog&quot; filtreleme</p>
      </div>

      <div className="border-b bg-gray-50 px-6">
        <div className="flex gap-1 py-2">
          {[
            { id: 'overview', label: 'Genel Bakis' },
            { id: 'meta', label: 'Meta Detay' },
            { id: 'google', label: 'Google Detay' },
            { id: 'adsets', label: 'Adset Kirilim' },
          ].map(t => (
            <button key={t.id} onClick={() => setView(t.id)}
              className={`px-4 py-2 text-xs font-medium rounded-lg transition-colors ${view === t.id ? 'bg-purple-600 text-white' : 'text-gray-600 hover:bg-gray-200'}`}
            >{t.label}</button>
          ))}
        </div>
      </div>

      <div className="p-6">
        {view === 'overview' && (
          <div className="space-y-6">
            {/* Summary cards */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {(() => {
                const mrmSpend = Object.values(metaRmTotal).reduce((s,v) => s + v.spend, 0);
                const mrmValue = Object.values(metaRmTotal).reduce((s,v) => s + v.value, 0);
                const grmSpend = Object.values(googleRm).reduce((s,v) => s + v.spend, 0);
                const grmValue = Object.values(googleRm).reduce((s,v) => s + v.value, 0);
                const metaTot = Object.values(META_TOTAL).reduce((s,v) => s + v.spend, 0);
                const googleTot = Object.values(GOOGLE_TOTAL).reduce((s,v) => s + v.spend, 0);
                return [
                  { label: 'Meta RM Toplam Harcama', value: `${fmt(mrmSpend)} TL`, sub: `Toplamin %${((mrmSpend/metaTot)*100).toFixed(0)}'i`, color: 'bg-purple-50 border-purple-200 text-purple-800' },
                  { label: 'Meta RM Toplam Deger', value: `${fmt(mrmValue)} TL`, sub: `ROAS: ${(mrmValue/mrmSpend).toFixed(2)}x`, color: 'bg-purple-50 border-purple-200 text-purple-800' },
                  { label: 'Google RM Toplam Harcama', value: `${fmt(grmSpend)} TL`, sub: `PMax = %${((grmSpend/googleTot)*100).toFixed(0)} toplam`, color: 'bg-blue-50 border-blue-200 text-blue-800' },
                  { label: 'Google RM Toplam Deger', value: `${fmt(grmValue)} TL`, sub: `ROAS: ${(grmValue/grmSpend).toFixed(2)}x`, color: 'bg-blue-50 border-blue-200 text-blue-800' },
                ];
              })().map((c, i) => (
                <div key={i} className={`p-4 rounded-xl border ${c.color}`}>
                  <p className="text-[10px] font-medium opacity-70">{c.label}</p>
                  <p className="text-lg font-bold mt-1">{c.value}</p>
                  <p className="text-[10px] opacity-60 mt-1">{c.sub}</p>
                </div>
              ))}
            </div>

            {/* Ana karsilastirma tablosu — Meta */}
            <div className="rounded-xl border overflow-hidden">
              <div className="px-4 py-3 bg-purple-50 border-b">
                <p className="font-semibold text-sm text-purple-900">Meta Ads — Remarketing vs Diger Kampanyalar (Aylik)</p>
              </div>
              <div className="overflow-x-auto">
                <table className="min-w-full text-xs divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-3 py-2 text-left font-medium text-gray-500">Ay</th>
                      <th className="px-2 py-2 text-right font-medium text-purple-700">RM Harcama</th>
                      <th className="px-2 py-2 text-right font-medium text-purple-700">RM Deger</th>
                      <th className="px-2 py-2 text-right font-medium text-purple-700">RM ROAS</th>
                      <th className="px-2 py-2 text-right font-medium text-gray-500 border-l">Diger Harcama</th>
                      <th className="px-2 py-2 text-right font-medium text-gray-500">Diger Deger</th>
                      <th className="px-2 py-2 text-right font-medium text-gray-500">Diger ROAS</th>
                      <th className="px-2 py-2 text-right font-medium text-gray-700 border-l bg-gray-100">Toplam</th>
                      <th className="px-2 py-2 text-right font-medium text-purple-600 bg-purple-50">RM Orani</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100">
                    {MONTHS_6.map(m => {
                      const mr = metaRmTotal[m];
                      const mt = META_TOTAL[m];
                      const otherSpend = mt.spend - mr.spend;
                      const otherValue = mt.value - mr.value;
                      const otherRoas = otherSpend > 0 ? (otherValue / otherSpend).toFixed(2) : 0;
                      const pct = mt.spend > 0 ? ((mr.spend / mt.spend) * 100).toFixed(0) : 0;
                      return (
                        <tr key={m} className={m === '2026-03' ? 'bg-yellow-50/50 font-medium' : ''}>
                          <td className="px-3 py-2.5 font-semibold text-gray-800">{MONTH_LABELS[m]}</td>
                          <td className="px-2 py-2.5 text-right text-purple-800">{fmt(mr.spend)}</td>
                          <td className="px-2 py-2.5 text-right text-purple-800">{fmt(mr.value)}</td>
                          <td className={`px-2 py-2.5 text-right font-bold ${mr.roas >= 5 ? 'text-green-700' : mr.roas > 0 ? 'text-amber-600' : 'text-gray-400'}`}>{mr.roas}x</td>
                          <td className="px-2 py-2.5 text-right border-l">{fmt(otherSpend)}</td>
                          <td className="px-2 py-2.5 text-right">{fmt(otherValue)}</td>
                          <td className={`px-2 py-2.5 text-right font-bold ${otherRoas >= 5 ? 'text-green-700' : otherRoas > 0 ? 'text-amber-600' : 'text-gray-400'}`}>{otherRoas}x</td>
                          <td className="px-2 py-2.5 text-right font-semibold border-l bg-gray-50">{fmt(mt.spend)}</td>
                          <td className="px-2 py-2.5 text-right font-bold text-purple-700 bg-purple-50/50">%{pct}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                  <tfoot className="bg-gray-100">
                    {(() => {
                      const mrmS = Object.values(metaRmTotal).reduce((s,v)=>s+v.spend,0);
                      const mrmV = Object.values(metaRmTotal).reduce((s,v)=>s+v.value,0);
                      const mtS = Object.values(META_TOTAL).reduce((s,v)=>s+v.spend,0);
                      const mtV = Object.values(META_TOTAL).reduce((s,v)=>s+v.value,0);
                      const oS = mtS - mrmS; const oV = mtV - mrmV;
                      return (
                        <tr className="font-bold text-xs">
                          <td className="px-3 py-2.5">TOPLAM</td>
                          <td className="px-2 py-2.5 text-right text-purple-800">{fmt(mrmS)}</td>
                          <td className="px-2 py-2.5 text-right text-purple-800">{fmt(mrmV)}</td>
                          <td className="px-2 py-2.5 text-right text-green-700">{(mrmV/mrmS).toFixed(2)}x</td>
                          <td className="px-2 py-2.5 text-right border-l">{fmt(oS)}</td>
                          <td className="px-2 py-2.5 text-right">{fmt(oV)}</td>
                          <td className="px-2 py-2.5 text-right text-green-700">{(oV/oS).toFixed(2)}x</td>
                          <td className="px-2 py-2.5 text-right border-l bg-gray-50">{fmt(mtS)}</td>
                          <td className="px-2 py-2.5 text-right text-purple-700 bg-purple-50/50">%{((mrmS/mtS)*100).toFixed(0)}</td>
                        </tr>
                      );
                    })()}
                  </tfoot>
                </table>
              </div>
            </div>

            {/* Google Ads tablosu */}
            <div className="rounded-xl border overflow-hidden">
              <div className="px-4 py-3 bg-blue-50 border-b">
                <p className="font-semibold text-sm text-blue-900">Google Ads — PMax (Remarketing iceren) vs Diger Kampanyalar (Aylik)</p>
              </div>
              <div className="overflow-x-auto">
                <table className="min-w-full text-xs divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-3 py-2 text-left font-medium text-gray-500">Ay</th>
                      <th className="px-2 py-2 text-right font-medium text-blue-700">PMax Harcama</th>
                      <th className="px-2 py-2 text-right font-medium text-blue-700">PMax Deger</th>
                      <th className="px-2 py-2 text-right font-medium text-blue-700">PMax ROAS</th>
                      <th className="px-2 py-2 text-right font-medium text-gray-500 border-l">Diger Harcama</th>
                      <th className="px-2 py-2 text-right font-medium text-gray-500">Diger Deger</th>
                      <th className="px-2 py-2 text-right font-medium text-gray-500">Diger ROAS</th>
                      <th className="px-2 py-2 text-right font-medium text-gray-700 border-l bg-gray-100">Toplam</th>
                      <th className="px-2 py-2 text-right font-medium text-blue-600 bg-blue-50">PMax Orani</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100">
                    {MONTHS_6.map(m => {
                      const gr = googleRm[m];
                      const gt = GOOGLE_TOTAL[m];
                      const otherSpend = gt.spend - gr.spend;
                      const otherValue = gt.value - gr.value;
                      const otherRoas = otherSpend > 0 ? (otherValue / otherSpend).toFixed(2) : 0;
                      const pct = gt.spend > 0 ? ((gr.spend / gt.spend) * 100).toFixed(0) : 0;
                      return (
                        <tr key={m} className={m === '2026-03' ? 'bg-yellow-50/50 font-medium' : ''}>
                          <td className="px-3 py-2.5 font-semibold text-gray-800">{MONTH_LABELS[m]}</td>
                          <td className="px-2 py-2.5 text-right text-blue-800">{fmt(gr.spend)}</td>
                          <td className="px-2 py-2.5 text-right text-blue-800">{fmt(gr.value)}</td>
                          <td className={`px-2 py-2.5 text-right font-bold ${gr.roas >= 5 ? 'text-green-700' : gr.roas > 0 ? 'text-amber-600' : 'text-gray-400'}`}>{gr.roas}x</td>
                          <td className="px-2 py-2.5 text-right border-l">{fmt(otherSpend)}</td>
                          <td className="px-2 py-2.5 text-right">{fmt(otherValue)}</td>
                          <td className={`px-2 py-2.5 text-right font-bold ${otherRoas >= 5 ? 'text-green-700' : otherRoas > 0 ? 'text-amber-600' : 'text-gray-400'}`}>{otherRoas}x</td>
                          <td className="px-2 py-2.5 text-right font-semibold border-l bg-gray-50">{fmt(gt.spend)}</td>
                          <td className="px-2 py-2.5 text-right font-bold text-blue-700 bg-blue-50/50">%{pct}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                  <tfoot className="bg-gray-100">
                    {(() => {
                      const grmS = Object.values(googleRm).reduce((s,v)=>s+v.spend,0);
                      const grmV = Object.values(googleRm).reduce((s,v)=>s+v.value,0);
                      const gtS = Object.values(GOOGLE_TOTAL).reduce((s,v)=>s+v.spend,0);
                      const gtV = Object.values(GOOGLE_TOTAL).reduce((s,v)=>s+v.value,0);
                      const oS = gtS - grmS; const oV = gtV - grmV;
                      return (
                        <tr className="font-bold text-xs">
                          <td className="px-3 py-2.5">TOPLAM</td>
                          <td className="px-2 py-2.5 text-right text-blue-800">{fmt(grmS)}</td>
                          <td className="px-2 py-2.5 text-right text-blue-800">{fmt(grmV)}</td>
                          <td className="px-2 py-2.5 text-right text-green-700">{(grmV/grmS).toFixed(2)}x</td>
                          <td className="px-2 py-2.5 text-right border-l">{fmt(oS)}</td>
                          <td className="px-2 py-2.5 text-right">{fmt(oV)}</td>
                          <td className="px-2 py-2.5 text-right text-green-700">{oS > 0 ? (oV/oS).toFixed(2) : 0}x</td>
                          <td className="px-2 py-2.5 text-right border-l bg-gray-50">{fmt(gtS)}</td>
                          <td className="px-2 py-2.5 text-right text-blue-700 bg-blue-50/50">%{((grmS/gtS)*100).toFixed(0)}</td>
                        </tr>
                      );
                    })()}
                  </tfoot>
                </table>
              </div>
            </div>

            {/* Not */}
            <div className="p-4 rounded-lg bg-amber-50 border border-amber-200">
              <p className="text-xs text-amber-800 leading-relaxed">
                <strong>Not:</strong> Google Ads&apos;te kampanya/ad group isimlerinde &quot;Remarketing&quot; veya &quot;RM&quot; gecen hicbir kampanya bulunmadi.
                Google tarafinda en yakin remarketing karsiligi <strong>Performance Max (PMax)</strong> kampanyalaridir — PMax icinde otomatik olarak
                site ziyaretcilerine ve mevcut musterilere yeniden pazarlama yapilir. Meta tarafinda ise adset isimlerinde &quot;Remarketing&quot; gecenler
                + <strong>Advantage+ Catalog</strong> (dinamik urun retargeting) birlikte gosterilmistir.
              </p>
            </div>
          </div>
        )}

        {view === 'meta' && (
          <div className="space-y-5">
            <p className="text-sm font-bold text-gray-800">Meta Ads — Remarketing Kirilimi (Aylik)</p>
            <div className="overflow-x-auto">
              <table className="min-w-full text-xs divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-3 py-2 text-left font-medium text-gray-500">Ay</th>
                    <th className="px-3 py-2 text-right font-medium text-purple-600">Adset RM Harcama</th>
                    <th className="px-3 py-2 text-right font-medium text-purple-600">Adset RM ROAS</th>
                    <th className="px-3 py-2 text-right font-medium text-indigo-600">ADV+ Catalog Harcama</th>
                    <th className="px-3 py-2 text-right font-medium text-indigo-600">ADV+ Catalog ROAS</th>
                    <th className="px-3 py-2 text-right font-medium text-gray-600 bg-gray-100">RM Toplam Harcama</th>
                    <th className="px-3 py-2 text-right font-medium text-gray-600 bg-gray-100">Meta Toplam</th>
                    <th className="px-3 py-2 text-right font-medium text-gray-600 bg-gray-100">RM Orani</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {MONTHS_6.map(m => {
                    const rm = META_RM_ADSETS[m] || {spend:0,roas:0};
                    const adv = META_ADV_CATALOG[m] || {spend:0,roas:0};
                    const tot = META_TOTAL[m];
                    const rmTotal = rm.spend + adv.spend;
                    return (
                      <tr key={m}>
                        <td className="px-3 py-2.5 font-semibold text-gray-800">{MONTH_LABELS[m]}</td>
                        <td className="px-3 py-2.5 text-right">{fmt(rm.spend)} TL</td>
                        <td className={`px-3 py-2.5 text-right font-bold ${rm.roas >= 10 ? 'text-green-700' : rm.roas > 0 ? 'text-amber-600' : 'text-gray-400'}`}>{rm.roas}x</td>
                        <td className="px-3 py-2.5 text-right">{fmt(adv.spend)} TL</td>
                        <td className={`px-3 py-2.5 text-right font-bold ${adv.roas >= 5 ? 'text-green-700' : 'text-amber-600'}`}>{adv.roas}x</td>
                        <td className="px-3 py-2.5 text-right font-semibold bg-gray-50">{fmt(rmTotal)} TL</td>
                        <td className="px-3 py-2.5 text-right bg-gray-50">{fmt(tot.spend)} TL</td>
                        <td className="px-3 py-2.5 text-right font-medium bg-gray-50">%{tot.spend > 0 ? ((rmTotal/tot.spend)*100).toFixed(0) : 0}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <p className="text-xs text-gray-500">
              <strong>Adset RM:</strong> Adset isminde &quot;Remarketing&quot; gecen kampanyalar (Interest &amp; Remarketing, Kalp Atisi RM, vb.) &nbsp;|&nbsp;
              <strong>ADV+ Catalog:</strong> Advantage+ Shopping / Catalog kampanyalari (dinamik urun retargeting)
            </p>
          </div>
        )}

        {view === 'google' && (
          <div className="space-y-5">
            <p className="text-sm font-bold text-gray-800">Google Ads — PMax (Remarketing Iceren) vs Toplam (Aylik)</p>
            <div className="overflow-x-auto">
              <table className="min-w-full text-xs divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-3 py-2 text-left font-medium text-gray-500">Ay</th>
                    <th className="px-3 py-2 text-right font-medium text-blue-600">PMax Harcama</th>
                    <th className="px-3 py-2 text-right font-medium text-blue-600">PMax Deger</th>
                    <th className="px-3 py-2 text-right font-medium text-blue-600">PMax ROAS</th>
                    <th className="px-3 py-2 text-right font-medium text-gray-600 bg-gray-100">Google Toplam Harcama</th>
                    <th className="px-3 py-2 text-right font-medium text-gray-600 bg-gray-100">Google Toplam Deger</th>
                    <th className="px-3 py-2 text-right font-medium text-gray-600 bg-gray-100">PMax Orani</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {MONTHS_6.map(m => {
                    const pm = GOOGLE_PMAX[m];
                    const gt = GOOGLE_TOTAL[m];
                    return (
                      <tr key={m}>
                        <td className="px-3 py-2.5 font-semibold text-gray-800">{MONTH_LABELS[m]}</td>
                        <td className="px-3 py-2.5 text-right">{fmt(pm.spend)} TL</td>
                        <td className="px-3 py-2.5 text-right">{fmt(pm.value)} TL</td>
                        <td className={`px-3 py-2.5 text-right font-bold ${pm.roas >= 5 ? 'text-green-700' : pm.roas > 0 ? 'text-amber-600' : 'text-gray-400'}`}>{pm.roas}x</td>
                        <td className="px-3 py-2.5 text-right bg-gray-50">{fmt(gt.spend)} TL</td>
                        <td className="px-3 py-2.5 text-right bg-gray-50">{fmt(gt.value)} TL</td>
                        <td className="px-3 py-2.5 text-right font-medium bg-gray-50">%{gt.spend > 0 ? ((pm.spend/gt.spend)*100).toFixed(0) : 0}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="p-3 rounded-lg bg-blue-50 border border-blue-200">
              <p className="text-xs text-blue-800">
                <strong>Onemli:</strong> Google Ads&apos;te ayri bir &quot;Remarketing&quot; kampanyasi yok. PMax kampanyalari icinde Google otomatik olarak
                remarketing kitlesine (site ziyaretcileri, sepet terk edenler, mevcut musteriler) reklam gosteriyor.
                PMax icindeki remarketing oranini ayristirmak mumkun degil — Google bu veriyi paylasmiyor.
              </p>
            </div>
          </div>
        )}

        {view === 'adsets' && (
          <div className="space-y-5">
            <p className="text-sm font-bold text-gray-800">Meta Remarketing Adset Detayi (Son 6 Ay Toplam)</p>
            <div className="overflow-x-auto">
              <table className="min-w-full text-xs divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-3 py-2 text-left font-medium text-gray-500">Adset Adi</th>
                    <th className="px-3 py-2 text-left font-medium text-gray-500">Kampanya</th>
                    <th className="px-3 py-2 text-right font-medium text-gray-500">Harcama</th>
                    <th className="px-3 py-2 text-right font-medium text-gray-500">Deger</th>
                    <th className="px-3 py-2 text-right font-medium text-gray-500">ROAS</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {META_RM_ADSET_DETAIL.map((d, i) => (
                    <tr key={i}>
                      <td className="px-3 py-2.5 font-medium text-gray-800">{d.name}</td>
                      <td className="px-3 py-2.5 text-gray-600">{d.campaign}</td>
                      <td className="px-3 py-2.5 text-right">{fmt(d.spend)} TL</td>
                      <td className="px-3 py-2.5 text-right font-medium">{fmt(d.value)} TL</td>
                      <td className={`px-3 py-2.5 text-right font-bold ${d.roas >= 10 ? 'text-green-700' : d.roas >= 5 ? 'text-amber-600' : 'text-red-500'}`}>{d.roas}x</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot className="bg-gray-100">
                  <tr className="font-bold">
                    <td className="px-3 py-2.5" colSpan={2}>TOPLAM</td>
                    <td className="px-3 py-2.5 text-right">{fmt(META_RM_ADSET_DETAIL.reduce((s,d)=>s+d.spend,0))} TL</td>
                    <td className="px-3 py-2.5 text-right">{fmt(META_RM_ADSET_DETAIL.reduce((s,d)=>s+d.value,0))} TL</td>
                    <td className="px-3 py-2.5 text-right text-green-700">
                      {(META_RM_ADSET_DETAIL.reduce((s,d)=>s+d.value,0) / META_RM_ADSET_DETAIL.reduce((s,d)=>s+d.spend,0)).toFixed(2)}x
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
            <p className="text-xs text-gray-500">
              Bu tablo sadece adset isminde &quot;Remarketing&quot; gecen kampanyalari gosterir. Advantage+ Catalog dahil degildir.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════════════════════ */
/*  ALI BEY YANIT — Mart 2026 Mail Cevabı                                    */
/* ═══════════════════════════════════════════════════════════════════════════ */

function AliBeyYanitSection() {
  const [tab, setTab] = useState('yanit');
  const tabs = [
    { id: 'yanit', label: 'Mail Yaniti' },
    { id: 'data', label: 'Veri Detaylari' },
    { id: 'strateji', label: 'Strateji & Aksiyon' },
  ];

  return (
    <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">
      <div className="px-6 py-4 border-b bg-gradient-to-r from-indigo-900 to-indigo-800">
        <h2 className="text-lg font-bold text-white">Ali Bey Yanit — Mart 2026</h2>
        <p className="text-xs text-indigo-200 mt-1">3 maile karsilik veri odakli yanit + strateji onerisi</p>
      </div>

      <div className="border-b bg-gray-50 px-6">
        <div className="flex gap-1 py-2">
          {tabs.map(t => (
            <button key={t.id} onClick={() => setTab(t.id)}
              className={`px-4 py-2 text-xs font-medium rounded-lg transition-colors ${tab === t.id ? 'bg-indigo-600 text-white' : 'text-gray-600 hover:bg-gray-200'}`}
            >{t.label}</button>
          ))}
        </div>
      </div>

      <div className="p-6">
        {tab === 'yanit' && <YanitContent />}
        {tab === 'data' && <VeriDetayContent />}
        {tab === 'strateji' && <StratejiContent />}
      </div>
    </div>
  );
}

function YanitContent() {
  return (
    <div className="space-y-6 text-sm text-gray-800 leading-relaxed">
      {/* Giriş */}
      <div className="p-5 rounded-xl bg-blue-50 border border-blue-200">
        <p className="font-bold text-blue-900 mb-2">Ali Bey, merhabalar.</p>
        <p className="text-blue-800">
          Maillerinizdeki tum sorulari tek tek inceledik, verilerle destekledik. Asagida once onceki raporumuzda (9 Mart) zaten paylastigimiz konulari,
          ardindan yeni sorulariniza detayli yanitlari bulacaksiniz. Her soru icin gercek kampanya datasi kullanildi.
        </p>
      </div>

      {/* Daha once gönderilen vs yeni istenen */}
      <div className="rounded-xl border overflow-hidden">
        <div className="px-5 py-3 bg-gray-900 text-white">
          <p className="font-bold text-sm">9 Mart Raporunda Zaten Paylasilan Konular</p>
        </div>
        <div className="p-5">
          <table className="min-w-full text-xs divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-3 py-2 text-left font-medium text-gray-500">Konu</th>
                <th className="px-3 py-2 text-center font-medium text-gray-500 w-24">Raporda Var</th>
                <th className="px-3 py-2 text-left font-medium text-gray-500">Aciklama</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {[
                { konu: 'Aylik harcama ve satis datasi', var: true, aciklama: 'Sayfa 1-4: Kanal bazli harcama, satis ve ROAS verileri paylasildi' },
                { konu: 'Reklam metinleri revizesi', var: true, aciklama: 'Sayfa 10-13: Guven odakli yeni reklam metinleri + kanal bazli soylemler hazirlanmisti' },
                { konu: 'En cok satis getiren kreatifler', var: true, aciklama: 'Sayfa 21-28: Son 6 aylik en iyi performansli kreatifler gorselleriyle paylasildi' },
                { konu: 'Funnel analizi', var: true, aciklama: 'Sayfa 33: Musteri yolculugu funnel grafigi paylasildi' },
                { konu: 'Remarketing / New User dagilimi', var: true, aciklama: 'Sayfa 32: Remarketing vs new user dagilimi gosterildi' },
                { konu: 'Add to Cart dusen urunler', var: true, aciklama: 'Sayfa 34-37: ATC asamamasinda en cok kayip veren urunler detaylandirildi' },
                { konu: 'Icerik plani / listesi', var: true, aciklama: 'Sayfa 14-20: 7 sayfalik icerik plani olusturulmustu' },
                { konu: 'Brand konumlandirma onerileri', var: true, aciklama: 'Ayrica platform sayfamizda guven hiyerarsisi, urun bazli strateji, 30 gunluk aksiyon plani detayli paylasild\u0131' },
                { konu: 'Butce artirma senaryolari', var: false, aciklama: 'Yeni talep — asagida detayli yanitlandi' },
                { konu: 'En karli urun analizi', var: false, aciklama: 'Yeni talep — asagida detayli yanitlandi' },
                { konu: 'Butce reallokasyonu', var: false, aciklama: 'Yeni talep — KRITIK: 113K TL/ay israf tespiti yapildi' },
              ].map((r, i) => (
                <tr key={i} className={r.var ? '' : 'bg-amber-50'}>
                  <td className="px-3 py-2 font-medium text-gray-800">{r.konu}</td>
                  <td className="px-3 py-2 text-center">
                    <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full ${r.var ? 'bg-green-100 text-green-700' : 'bg-amber-100 text-amber-700'}`}>
                      {r.var ? 'EVET' : 'YENI'}
                    </span>
                  </td>
                  <td className="px-3 py-2 text-gray-600">{r.aciklama}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* SORU 1: Reklamlarin satisa etkisi */}
      <div className="rounded-xl border overflow-hidden">
        <div className="px-5 py-3 bg-indigo-50 border-b border-indigo-200">
          <p className="font-bold text-indigo-900">Soru 1: Reklamlarin satisa etkisi nedir?</p>
        </div>
        <div className="p-5 space-y-3">
          <p>Son 30 gun toplam reklam performansi:</p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {[
              { label: 'Toplam Harcama', value: '412,728 TL', sub: 'Google: 178,647 + Meta: 234,081' },
              { label: 'Toplam Deger', value: '3,237,709 TL', sub: 'Google: 1,826,057 + Meta: 1,411,652' },
              { label: 'Ortalama ROAS', value: '7.85x', sub: 'Her 1 TL icin 7.85 TL gelir' },
              { label: 'Toplam Tiklanma', value: '148,337', sub: 'Google: 60,250 + Meta: 88,087' },
            ].map((m, i) => (
              <div key={i} className="p-3 rounded-lg bg-gray-50 border">
                <p className="text-[10px] text-gray-500 font-medium">{m.label}</p>
                <p className="text-lg font-bold text-gray-900 mt-1">{m.value}</p>
                <p className="text-[10px] text-gray-400 mt-1">{m.sub}</p>
              </div>
            ))}
          </div>
          <div className="p-3 rounded-lg bg-red-50 border border-red-200 mt-3">
            <p className="text-xs text-red-800">
              <strong>KRITIK BULGU:</strong> Toplam harcamanin ~113,000 TL&apos;si (%27.4) Location/Awareness/Engagement kampanyalarina gidiyor
              ve bu kampanyalardan neredeyse hic donusum gelmiyor. Bu butceyi performans kampanyalarina kaydirarak ROAS&apos;i ciddi olcude artirma potansiyelimiz var.
            </p>
          </div>
        </div>
      </div>

      {/* SORU 2: En çok tıklanan anahtar kelimeler */}
      <div className="rounded-xl border overflow-hidden">
        <div className="px-5 py-3 bg-indigo-50 border-b border-indigo-200">
          <p className="font-bold text-indigo-900">Soru 2: En cok tiklanan / donusum getiren anahtar kelimeler</p>
        </div>
        <div className="p-5">
          <table className="min-w-full text-xs divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-3 py-2 text-left font-medium text-gray-500">Anahtar Kelime</th>
                <th className="px-3 py-2 text-right font-medium text-gray-500">Harcama</th>
                <th className="px-3 py-2 text-right font-medium text-gray-500">Tik</th>
                <th className="px-3 py-2 text-right font-medium text-gray-500">Donusum</th>
                <th className="px-3 py-2 text-right font-medium text-gray-500">Deger</th>
                <th className="px-3 py-2 text-right font-medium text-gray-500">ROAS</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {[
                { kw: 'yenilio', spend: '48,746', clicks: '15,035', conv: '1,043', value: '1,258,140', roas: '25.81x', highlight: true },
                { kw: 'yenilio.com', spend: '7,727', clicks: '1,562', conv: '103', value: '171,965', roas: '22.26x', highlight: true },
                { kw: 'yenilenmis apple', spend: '471', clicks: '129', conv: '1', value: '10,631', roas: '22.56x', highlight: false },
                { kw: '2 el macbook', spend: '707', clicks: '270', conv: '9', value: '—', roas: '—', highlight: false },
                { kw: 'ikinci el macbook pro', spend: '171', clicks: '64', conv: '0', value: '—', roas: '—', highlight: false },
              ].map((k, i) => (
                <tr key={i} className={k.highlight ? 'bg-green-50' : ''}>
                  <td className="px-3 py-2 font-medium text-gray-800">{k.kw}</td>
                  <td className="px-3 py-2 text-right">{k.spend} TL</td>
                  <td className="px-3 py-2 text-right">{k.clicks}</td>
                  <td className="px-3 py-2 text-right font-medium">{k.conv}</td>
                  <td className="px-3 py-2 text-right font-medium">{k.value} TL</td>
                  <td className="px-3 py-2 text-right font-bold text-green-700">{k.roas}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="text-xs text-gray-600 mt-3">
            <strong>Yorum:</strong> Ciromuzun %69&apos;u &quot;yenilio&quot; brand aramasindan geliyor. Bu, marka bilinirliginin satis uzerindeki
            etkisini net gosteriyor. Non-brand keyword&apos;lerde (yenilenmis iphone, ikinci el macbook vb.) henuz yeterli conversion value
            takibi yapilamiyor — bu konuda tracking iyilestirmesi planliyoruz.
          </p>
        </div>
      </div>

      {/* SORU 3: En iyi performans gösteren kreatifler */}
      <div className="rounded-xl border overflow-hidden">
        <div className="px-5 py-3 bg-indigo-50 border-b border-indigo-200">
          <p className="font-bold text-indigo-900">Soru 3: En iyi performans gosteren reklam kreatifleri</p>
        </div>
        <div className="p-5">
          <table className="min-w-full text-xs divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-3 py-2 text-left font-medium text-gray-500">Kreatif / Kampanya</th>
                <th className="px-3 py-2 text-right font-medium text-gray-500">Harcama</th>
                <th className="px-3 py-2 text-right font-medium text-gray-500">Deger</th>
                <th className="px-3 py-2 text-right font-medium text-gray-500">ROAS</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {[
                { name: 'Vakifbank 1.000 TL Ekstre Indirimi', spend: '5,124', value: '331,292', roas: '64.65x', star: true },
                { name: 'Paraf CB Kampanyasi', spend: '1,190', value: '65,446', roas: '54.98x', star: true },
                { name: 'Seker Tadinda Bayram (iPhone 13)', spend: '1,996', value: '59,498', roas: '29.80x', star: false },
                { name: 'Seker Tadinda Bayram (iPhone 11)', spend: '1,993', value: '56,858', roas: '28.52x', star: false },
                { name: 'Seker Tadinda Bayram (All)', spend: '3,998', value: '79,046', roas: '19.77x', star: false },
                { name: 'Yenilio Yenisi Apple 12 Taksit', spend: '12,610', value: '199,245', roas: '15.80x', star: false },
                { name: 'Advantage+ Catalog Dynamic', spend: '40,930', value: '471,317', roas: '11.52x', star: false },
                { name: 'iPhone 12-to-14 Upgrade', spend: '4,489', value: '21,999', roas: '4.90x', star: false },
                { name: 'Izmir Optimum Magaza', spend: '10,284', value: '44,887', roas: '4.36x', star: false },
                { name: '0 Faizli AVK', spend: '13,171', value: '52,566', roas: '3.99x', star: false },
              ].map((c, i) => (
                <tr key={i} className={c.star ? 'bg-yellow-50' : ''}>
                  <td className="px-3 py-2 font-medium text-gray-800">
                    {c.star && <span className="text-yellow-500 mr-1">&#9733;</span>}
                    {c.name}
                  </td>
                  <td className="px-3 py-2 text-right">{c.spend} TL</td>
                  <td className="px-3 py-2 text-right font-medium">{c.value} TL</td>
                  <td className="px-3 py-2 text-right font-bold text-green-700">{c.roas}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="text-xs text-gray-600 mt-3">
            <strong>Yorum:</strong> Banka kampanyalari (Vakifbank, Paraf) en yuksek ROAS&apos;i getiriyor. Bayram kampanyalari da mukemmel performans gosteriyor.
            Advantage+ Catalog en yuksek hacimli kampanya (471K TL deger). Bu kreatif yaklasimlarini (banka isbirligi + mevsimsel kampanya + dinamik katalog)
            agirlikli olarak kullanmaya devam etmeliyiz.
          </p>
        </div>
      </div>

      {/* SORU 4: Remarketing / Retargeting */}
      <div className="rounded-xl border overflow-hidden">
        <div className="px-5 py-3 bg-indigo-50 border-b border-indigo-200">
          <p className="font-bold text-indigo-900">Soru 4: Remarketing ve retargeting kampanyalarinin durumu</p>
        </div>
        <div className="p-5 space-y-3">
          <p>Mevcut remarketing yapisi ve onerimiz:</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="p-4 rounded-lg border bg-orange-50">
              <p className="text-xs font-bold text-orange-800 mb-2">Mevcut Durum</p>
              <ul className="text-xs text-gray-700 space-y-1.5">
                <li>&bull; Advantage+ Catalog (dinamik retargeting) aktif ve en iyi performansli kampanya (ROAS 11.52x)</li>
                <li>&bull; View Content retargeting kampanyasi aktif (7,771 TL harcama, 0 dogrudan donusum)</li>
                <li>&bull; Funnel verisine gore ayda 170,870 urun goruntulemesi var ama sadece 7,689 sepete ekleme (%4.5)</li>
                <li>&bull; 797 checkout baslatma, sadece 128 satin alma</li>
              </ul>
            </div>
            <div className="p-4 rounded-lg border bg-green-50">
              <p className="text-xs font-bold text-green-800 mb-2">Onerimiz</p>
              <ul className="text-xs text-gray-700 space-y-1.5">
                <li>&bull; Sepet terk retargeting kampanyasi olusturulmali (797 checkout, 128 purchase = 669 kisi kaybediliyor)</li>
                <li>&bull; View Content &rarr; ATC arasindaki %95.5&apos;lik kayip icin guven odakli carousel retargeting</li>
                <li>&bull; Advantage+ Catalog butcesi arttirilmali (en iyi ROAS&apos;li hacim kampanyasi)</li>
                <li>&bull; Email remarketing akisi kurulmali (sepet terk + gozatma terk)</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* SORU 5: Funnel */}
      <div className="rounded-xl border overflow-hidden">
        <div className="px-5 py-3 bg-indigo-50 border-b border-indigo-200">
          <p className="font-bold text-indigo-900">Soru 5: Musteri yolculugu (funnel) analizi</p>
        </div>
        <div className="p-5 space-y-3">
          <div className="flex items-center gap-2 overflow-x-auto pb-2">
            {[
              { step: 'Urun Listeleme', val: '649,503', pct: '100%', color: 'bg-blue-100 text-blue-800' },
              { step: 'Urun Goruntuleme', val: '170,870', pct: '26.3%', color: 'bg-blue-200 text-blue-900' },
              { step: 'Sepet Goruntuleme', val: '8,798', pct: '5.1%', color: 'bg-amber-100 text-amber-800' },
              { step: 'Sepete Ekleme', val: '7,689', pct: '4.5%', color: 'bg-amber-200 text-amber-900' },
              { step: 'Checkout', val: '797', pct: '0.47%', color: 'bg-orange-200 text-orange-900' },
              { step: 'Satin Alma', val: '128', pct: '0.07%', color: 'bg-red-200 text-red-900' },
            ].map((s, i) => (
              <React.Fragment key={i}>
                <div className={`p-3 rounded-lg ${s.color} min-w-[120px] text-center`}>
                  <p className="text-[9px] font-medium">{s.step}</p>
                  <p className="text-sm font-bold mt-0.5">{s.val}</p>
                  <p className="text-[9px] mt-0.5">{s.pct}</p>
                </div>
                {i < 5 && <span className="text-gray-300 text-lg flex-shrink-0">&rarr;</span>}
              </React.Fragment>
            ))}
          </div>
          <div className="p-3 rounded-lg bg-red-50 border border-red-200">
            <p className="text-xs text-red-800">
              <strong>EN BUYUK KAYIP NOKTASI:</strong> Urun Goruntuleme (170,870) &rarr; Sepete Ekleme (7,689) arasinda %95.5 kayip var.
              Bu, ziyaretcilerin urunu inceledigi ama guven duymadigi icin sepete eklemedigi anlamina geliyor.
              Cozum: Urun sayfasinda guven hiyerarsisinin (TSE, Apple Yetkili, 21 gun iade) daha gorünür olması.
            </p>
          </div>
        </div>
      </div>

      {/* SORU 6-10: Kisa yanitlar */}
      <div className="rounded-xl border overflow-hidden">
        <div className="px-5 py-3 bg-indigo-50 border-b border-indigo-200">
          <p className="font-bold text-indigo-900">Diger Sorular (6-10)</p>
        </div>
        <div className="p-5 space-y-4">
          {[
            {
              q: 'Soru 6: Google Ads vs Meta Ads karsilastirmasi',
              a: 'Google Ads: 178,647 TL harcama, ROAS 10.22x (brand aramalari agirlikli). Meta Ads: 234,081 TL harcama, ROAS 6.03x (awareness + catalog). Google ROAS daha yuksek cunku brand aramalari cok guclu. Meta\'da ise awareness/location kampanyalari ROAS\'i dusuruyor — bunlari cikardığımızda Meta performans kampanyalari ROAS\'i ~12-15x arasinda.'
            },
            {
              q: 'Soru 7: Marka bilinirliginin satisa etkisi',
              a: '"Yenilio" brand keyword\'u tek basina 1,258,140 TL ciro getiriyor (toplam Google cirosunun %69\'u). Bu marka bilinirliginin direkt satisa donustugunu gosteriyor. Ancak marka aramalarina bu kadar bagimlilik riskli — non-brand keyword\'lerin guclendirilmesi gerekiyor.'
            },
            {
              q: 'Soru 8: Lokasyon bazli kampanya performansi',
              a: 'KRITIK: Meta location kampanyalari (Cevahir, Mall of Istanbul, Cepa, Ankamall, Korupark) toplam 49,992 TL harcadi, sadece 1 donusum (16,999 TL). Google GDN magaza cevresi kampanyalari 7,343 TL harcadi, 0 donusum. YouTube kampanyasi 28,109 TL harcadi, 0 donusum. Toplam ~85,400 TL israf. Bu butce performans kampanyalarina aktarilmali.'
            },
            {
              q: 'Soru 9: Hangi urun kategorisi en karli?',
              a: 'Google PMax verisine gore: iPhone 12 en yuksek ROAS (20.84x), iPhone 14 (13.86x), MacBook (14.23x), Watch (11.46x). iPhone 13 (5.11x) ve iPhone 11 (3.74x) daha dusuk. Meta tarafinda banka kampanyalariyla (Vakifbank, Paraf) iliskili kreatifler en karli segmenti olusturuyor.'
            },
            {
              q: 'Soru 10: Rakip analizi',
              a: 'Competitor keyword kampanyasi (SRCH_GNRC_COMP) 700 TL harcanmis, 0 donusum. Bu segment simdilik kucuk ama potansiyeli var. Sahibinden, letgo, ikinci el gibi aramalara yonelik agresif kampanyalar 9 Mart raporumuzda detayli planlanmisti (Sayfa 13).'
            },
          ].map((item, i) => (
            <div key={i} className="p-4 rounded-lg border bg-gray-50">
              <p className="text-xs font-bold text-gray-800 mb-1.5">{item.q}</p>
              <p className="text-xs text-gray-600 leading-relaxed">{item.a}</p>
            </div>
          ))}
        </div>
      </div>

      {/* MAIL 3: Stratejik Sorular */}
      <div className="rounded-xl border overflow-hidden">
        <div className="px-5 py-3 bg-purple-50 border-b border-purple-200">
          <p className="font-bold text-purple-900">Stratejik Sorular (Mail 3)</p>
        </div>
        <div className="p-5 space-y-4">
          {/* Bütçe artırma senaryosu */}
          <div className="p-4 rounded-lg border">
            <p className="text-xs font-bold text-gray-800 mb-2">1. Butce artirilirsa ne olur?</p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              <div className="p-3 rounded-lg bg-green-50 border border-green-200">
                <p className="text-[10px] font-bold text-green-700">SENARYO A: Israf Butcesi Aktarimi</p>
                <p className="text-xs text-gray-700 mt-1">
                  113K TL/ay israf butcesini performans kampanyalarina aktarirsak, mevcut ROAS oranlarinda ek ~900K-1.3M TL/ay ciro potansiyeli.
                  <strong> Ek maliyet: 0 TL</strong>
                </p>
              </div>
              <div className="p-3 rounded-lg bg-blue-50 border border-blue-200">
                <p className="text-[10px] font-bold text-blue-700">SENARYO B: +%25 Butce Artisi</p>
                <p className="text-xs text-gray-700 mt-1">
                  Mevcut 412K &rarr; 515K TL/ay. Ek 103K TL, performans kampanyalarina yonlendirirse tahmini ek ~800K TL ciro.
                  Toplam: ~4M TL/ay ciro hedefi.
                </p>
              </div>
              <div className="p-3 rounded-lg bg-purple-50 border border-purple-200">
                <p className="text-[10px] font-bold text-purple-700">SENARYO C: Optimal Mix</p>
                <p className="text-xs text-gray-700 mt-1">
                  Israf butcesini aktar + %15 ek artis. Toplam ~475K TL/ay, tamami performans odakli.
                  Tahmini ciro: ~4.5M TL/ay (mevcut 3.2M&apos;den %40 artis).
                </p>
              </div>
            </div>
          </div>

          {/* En karlı ürünler */}
          <div className="p-4 rounded-lg border">
            <p className="text-xs font-bold text-gray-800 mb-2">2. En karli urunler / kategoriler</p>
            <table className="min-w-full text-xs divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-3 py-2 text-left font-medium text-gray-500">Kampanya</th>
                  <th className="px-3 py-2 text-right font-medium text-gray-500">Harcama</th>
                  <th className="px-3 py-2 text-right font-medium text-gray-500">Deger</th>
                  <th className="px-3 py-2 text-right font-medium text-gray-500">ROAS</th>
                  <th className="px-3 py-2 text-left font-medium text-gray-500">Oneri</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {[
                  { name: 'Brand Arama (Yenilio)', spend: '55,921', value: '1,297,177', roas: '23.2x', oneri: 'Koruma + IS %95 hedef' },
                  { name: 'PMax iPhone 12', spend: '4,530', value: '94,388', roas: '20.84x', oneri: 'Butce arttirilmali!' },
                  { name: 'PMax MacBook', spend: '2,983', value: '42,439', roas: '14.23x', oneri: 'Butce arttirilmali!' },
                  { name: 'PMax iPhone 14', spend: '2,987', value: '41,400', roas: '13.86x', oneri: 'Butce arttirilmali!' },
                  { name: 'PMax Watch', spend: '2,985', value: '34,200', roas: '11.46x', oneri: 'Potansiyel yuksek' },
                  { name: 'Advantage+ Catalog', spend: '40,930', value: '471,317', roas: '11.52x', oneri: 'Scale up' },
                  { name: 'PMax iPhone 13', spend: '21,041', value: '107,414', roas: '5.11x', oneri: 'Optimize et' },
                  { name: 'PMax iPhone 11', spend: '17,047', value: '63,717', roas: '3.74x', oneri: 'Dikkatli izle' },
                ].map((p, i) => (
                  <tr key={i}>
                    <td className="px-3 py-2 font-medium text-gray-800">{p.name}</td>
                    <td className="px-3 py-2 text-right">{p.spend} TL</td>
                    <td className="px-3 py-2 text-right font-medium">{p.value} TL</td>
                    <td className="px-3 py-2 text-right font-bold text-green-700">{p.roas}</td>
                    <td className="px-3 py-2 text-gray-600">{p.oneri}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Bütçe reallokasyonu */}
          <div className="p-4 rounded-lg border bg-red-50">
            <p className="text-xs font-bold text-red-800 mb-2">3. Butce reallokasyonu onerisi</p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <p className="text-[10px] font-bold text-red-700 mb-2">AZALTILMASI / DURDURULMASI GEREKENLER</p>
                <ul className="text-xs text-gray-700 space-y-1">
                  <li>&bull; Meta Location kampanyalari: -50,000 TL/ay (Cevahir, Cepa, Ankamall, Mall of Istanbul)</li>
                  <li>&bull; Meta Reach/Engagement: -19,500 TL/ay (Bursa Korupark Reach, PostEngagement)</li>
                  <li>&bull; Google YouTube: -28,100 TL/ay (0 donusum)</li>
                  <li>&bull; Google GDN Magaza: -7,300 TL/ay (0 donusum)</li>
                  <li className="font-bold text-red-800">Toplam tasarruf: ~105,000 TL/ay</li>
                </ul>
              </div>
              <div>
                <p className="text-[10px] font-bold text-green-700 mb-2">ARTTIRILMASI GEREKENLER</p>
                <ul className="text-xs text-gray-700 space-y-1">
                  <li>&bull; PMax iPhone 12: +15,000 TL (ROAS 20.84x)</li>
                  <li>&bull; PMax MacBook: +10,000 TL (ROAS 14.23x)</li>
                  <li>&bull; PMax iPhone 14: +10,000 TL (ROAS 13.86x)</li>
                  <li>&bull; PMax Watch: +8,000 TL (ROAS 11.46x)</li>
                  <li>&bull; Advantage+ Catalog: +20,000 TL (ROAS 11.52x)</li>
                  <li>&bull; Sepet Terk Retargeting (Yeni): +15,000 TL</li>
                  <li>&bull; Non-Brand Search: +15,000 TL</li>
                  <li className="font-bold text-green-800">Toplam ek yatirim: ~93,000 TL/ay</li>
                </ul>
              </div>
            </div>
            <p className="text-xs text-red-800 mt-3 font-medium">
              Net etki: 12,000 TL/ay tasarruf + tahmini 800K-1.2M TL ek ciro/ay
            </p>
          </div>
        </div>
      </div>

      {/* Kopyalanabilir Yanit Metni */}
      <div className="rounded-xl border overflow-hidden">
        <div className="px-5 py-3 bg-gray-900 text-white">
          <p className="font-bold text-sm">Kopyalanabilir Mail Yaniti</p>
        </div>
        <div className="p-5">
          <div className="p-4 rounded-lg bg-gray-50 border font-mono text-xs text-gray-700 whitespace-pre-wrap leading-relaxed">
{`Ali Bey, merhabalar.

Maillerinizdeki tum sorulari inceledik ve verilerle destekledik. Once bir hatirlatma: 9 Mart'ta gonderdigimiz raporda asagidaki konulari detayli olarak paylasmistik:

- Aylik harcama ve satis datasi (kanal bazli)
- Revize reklam metinleri ve kanal bazli soylemler
- Son 6 aylik en iyi performansli kreatifler
- Funnel analizi ve musteri yolculugu
- Remarketing/New User dagilimi
- Add to Cart'ta en cok kayip veren urunler
- 7 sayfalik icerik plani

Buna ek olarak platform sayfamizda (yenilio-mart2026) guven hiyerarsisi, urun bazli keyword planlama, RSA onizlemeleri, Meta funnel yapisi ve 30 gunluk aksiyon plani detayli olarak yer aliyor.

Simdi yeni sorulariniza geciyoruz:

GENEL PERFORMANS (Son 30 Gun):
- Toplam harcama: 412,728 TL (Google: 178,647 + Meta: 234,081)
- Toplam ciro: 3,237,709 TL
- Ortalama ROAS: 7.85x

KRITIK BULGU - ISRAF TESPITI:
Toplam butcenin %27'si (~113,000 TL/ay) Location, Awareness, Engagement ve YouTube kampanyalarina gidiyor ve bu kampanyalardan neredeyse hic donusum gelmiyor:
- Meta Location (5 magaza): 50,000 TL → ~0 donusum
- YouTube: 28,100 TL → 0 donusum
- GDN Magaza Cevresi: 7,300 TL → 0 donusum
- Reach/Engagement: 19,500 TL → 0 donusum

Bu butceyi performans kampanyalarina aktararak, ek maliyet olmadan tahmini 800K-1.2M TL/ay ek ciro elde edebiliriz.

EN KARLI KAMPANYALAR:
1. Brand Arama (Yenilio): ROAS 23.2x — Ciromuzun %69'u
2. Vakifbank Kampanyasi: ROAS 64.65x — Banka isbirlikleri cok etkili
3. PMax iPhone 12: ROAS 20.84x — Butce arttirilmali
4. PMax MacBook: ROAS 14.23x — Butce arttirilmali
5. Advantage+ Catalog: ROAS 11.52x — En yuksek hacimli performans

FUNNEL PROBLEM:
Urun goruntulemeden sepete eklemeye gecis orani sadece %4.5. Bu, ziyaretcilerin urunu inceledigi ama guven duymadigi icin sepete eklemedigi anlamina geliyor. Urun sayfasindaki guven elementlerinin guclendirmesi en oncelikli CRO aksiyon olmalidir.

BUTCE REALLOKASYONU ONERISI:
Mevcut butceyle (ek harcama yapmadan) israf kampanyalarini durdurup performans kampanyalarina aktarma yaparak ROAS'i %40-60 artirma potansiyelimiz var. Detayli dagilimi platform sayfamizda paylastik.

Iyi calismalar dileriz.`}
          </div>
        </div>
      </div>
    </div>
  );
}

function VeriDetayContent() {
  return (
    <div className="space-y-6">
      {/* Google Ads Kampanya Detay */}
      <div className="rounded-xl border overflow-hidden">
        <div className="px-5 py-3 bg-blue-50 border-b">
          <p className="font-bold text-sm text-blue-900">Google Ads — Kampanya Bazli Performans (Son 30 Gun)</p>
        </div>
        <div className="p-4 overflow-x-auto">
          <table className="min-w-full text-xs divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-3 py-2 text-left font-medium text-gray-500">Kampanya</th>
                <th className="px-3 py-2 text-left font-medium text-gray-500">Tip</th>
                <th className="px-3 py-2 text-right font-medium text-gray-500">Harcama</th>
                <th className="px-3 py-2 text-right font-medium text-gray-500">Donusum</th>
                <th className="px-3 py-2 text-right font-medium text-gray-500">Deger</th>
                <th className="px-3 py-2 text-right font-medium text-gray-500">ROAS</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {[
                { name: 'SRCH_BRND_Yenilio', type: 'Search', spend: '55,921', conv: '1,155', value: '1,297,177', roas: '23.20x', good: true },
                { name: 'Glowy_YT_21gunIade', type: 'Video', spend: '28,109', conv: '0', value: '0', roas: '0x', good: false },
                { name: 'Boo_PMAX_iPhone_13', type: 'PMax', spend: '21,041', conv: '488', value: '107,414', roas: '5.11x', good: true },
                { name: 'SRCH_GNRC_iPhone_15', type: 'Search', spend: '20,840', conv: '33', value: '0', roas: '0x', good: false },
                { name: 'Boo_PMAX_iPhone_11', type: 'PMax', spend: '17,047', conv: '407', value: '63,717', roas: '3.74x', good: true },
                { name: 'Glowy_GDN_MagazalarCevresi', type: 'Display', spend: '5,837', conv: '0', value: '0', roas: '0x', good: false },
                { name: 'Glowy_Search_MagazalarCevresi', type: 'Search', spend: '5,028', conv: '4', value: '145,322', roas: '28.90x', good: true },
                { name: 'Boo_PMAX_iPhone_12', type: 'PMax', spend: '4,530', conv: '181', value: '94,388', roas: '20.84x', good: true },
                { name: 'Boo_PMAX_iPhone_14', type: 'PMax', spend: '2,987', conv: '111', value: '41,400', roas: '13.86x', good: true },
                { name: 'Boo_PMAX_Watch', type: 'PMax', spend: '2,985', conv: '1', value: '34,200', roas: '11.46x', good: true },
                { name: 'Boo_PMAX_MacBook', type: 'PMax', spend: '2,983', conv: '94', value: '42,439', roas: '14.23x', good: true },
                { name: 'SRCH_GNRC_iPhone_13', type: 'Search', spend: '2,975', conv: '45', value: '0', roas: '0x', good: false },
                { name: 'SRCH_GNRC_Macbook', type: 'Search', spend: '2,970', conv: '48', value: '0', roas: '0x', good: false },
                { name: 'SRCH_GNRC_iPhone_14', type: 'Search', spend: '2,932', conv: '11', value: '0', roas: '0x', good: false },
                { name: 'GDN_Yenilio_Bursa', type: 'Display', spend: '1,506', conv: '0', value: '0', roas: '0x', good: false },
                { name: 'SRCH_GNRC_COMP', type: 'Search', spend: '700', conv: '0', value: '0', roas: '0x', good: false },
                { name: 'SRCH_GNRC_iPhone_11', type: 'Search', spend: '257', conv: '3', value: '0', roas: '0x', good: false },
              ].map((c, i) => (
                <tr key={i} className={c.good ? '' : 'bg-red-50/50'}>
                  <td className="px-3 py-2 font-medium text-gray-800">{c.name}</td>
                  <td className="px-3 py-2 text-gray-600">{c.type}</td>
                  <td className="px-3 py-2 text-right">{c.spend} TL</td>
                  <td className="px-3 py-2 text-right">{c.conv}</td>
                  <td className="px-3 py-2 text-right font-medium">{c.value} TL</td>
                  <td className={`px-3 py-2 text-right font-bold ${c.good ? 'text-green-700' : 'text-red-500'}`}>{c.roas}</td>
                </tr>
              ))}
            </tbody>
            <tfoot className="bg-gray-100">
              <tr className="font-bold">
                <td className="px-3 py-2">TOPLAM</td>
                <td></td>
                <td className="px-3 py-2 text-right">178,647 TL</td>
                <td className="px-3 py-2 text-right">2,581</td>
                <td className="px-3 py-2 text-right">1,826,057 TL</td>
                <td className="px-3 py-2 text-right text-green-700">10.22x</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      {/* Meta Ads Kampanya Detay */}
      <div className="rounded-xl border overflow-hidden">
        <div className="px-5 py-3 bg-purple-50 border-b">
          <p className="font-bold text-sm text-purple-900">Meta Ads — Kampanya Bazli Performans (Son 30 Gun)</p>
        </div>
        <div className="p-4 overflow-x-auto">
          <table className="min-w-full text-xs divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-3 py-2 text-left font-medium text-gray-500">Kampanya</th>
                <th className="px-3 py-2 text-left font-medium text-gray-500">Hedef</th>
                <th className="px-3 py-2 text-right font-medium text-gray-500">Harcama</th>
                <th className="px-3 py-2 text-right font-medium text-gray-500">Deger</th>
                <th className="px-3 py-2 text-right font-medium text-gray-500">ROAS</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {[
                { name: 'Advantage+ Catalog Dynamic', obj: 'Sales', spend: '40,930', value: '471,317', roas: '11.52x', good: true },
                { name: 'Advantage+ Catalog Mac', obj: 'Sales', spend: '19,535', value: '0', roas: '0x', good: false },
                { name: 'Reach MaxImpression BursaKorupark', obj: 'Awareness', spend: '13,691', value: '0', roas: '0x', good: false },
                { name: '0 Faizli AVK', obj: 'Sales', spend: '13,171', value: '52,566', roas: '3.99x', good: true },
                { name: 'Yenilio Yenisi 12 Taksit', obj: 'Sales', spend: '12,610', value: '199,245', roas: '15.80x', good: true },
                { name: 'Izmir Optimum', obj: 'Sales', spend: '10,284', value: '44,887', roas: '4.36x', good: true },
                { name: 'Location Cevahir', obj: 'Awareness', spend: '10,031', value: '0', roas: '0x', good: false },
                { name: 'Location Mall of Istanbul', obj: 'Awareness', spend: '10,022', value: '0', roas: '0x', good: false },
                { name: 'Location Cepa', obj: 'Awareness', spend: '9,993', value: '0', roas: '0x', good: false },
                { name: 'Location Korupark', obj: 'Awareness', spend: '9,992', value: '16,999', roas: '1.70x', good: false },
                { name: 'Location Ankamall', obj: 'Awareness', spend: '9,986', value: '0', roas: '0x', good: false },
                { name: 'Ramazan Gece Firsatlari', obj: 'Sales', spend: '8,982', value: '12,499', roas: '1.39x', good: false },
                { name: 'ViewContent Catalog', obj: 'Sales', spend: '7,771', value: '0', roas: '0x', good: false },
                { name: 'PostEngagement Izmir', obj: 'Traffic', spend: '6,075', value: '0', roas: '0x', good: false },
                { name: 'PostEngagement SerkanKizilBayir', obj: 'Engagement', spend: '5,401', value: '0', roas: '0x', good: false },
              ].map((c, i) => (
                <tr key={i} className={c.good ? '' : 'bg-red-50/50'}>
                  <td className="px-3 py-2 font-medium text-gray-800">{c.name}</td>
                  <td className="px-3 py-2 text-gray-600">{c.obj}</td>
                  <td className="px-3 py-2 text-right">{c.spend} TL</td>
                  <td className="px-3 py-2 text-right font-medium">{c.value} TL</td>
                  <td className={`px-3 py-2 text-right font-bold ${c.good ? 'text-green-700' : 'text-red-500'}`}>{c.roas}</td>
                </tr>
              ))}
            </tbody>
            <tfoot className="bg-gray-100">
              <tr className="font-bold">
                <td className="px-3 py-2">TOPLAM</td>
                <td></td>
                <td className="px-3 py-2 text-right">234,081 TL</td>
                <td className="px-3 py-2 text-right">1,411,652 TL</td>
                <td className="px-3 py-2 text-right text-green-700">6.03x</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      {/* Israf Özet */}
      <div className="p-5 rounded-xl bg-red-50 border border-red-300">
        <p className="text-sm font-bold text-red-900 mb-3">ISRAF OZETI — Toplam: ~113,000 TL/ay</p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {[
            { label: 'Meta Location (5x)', value: '50,023 TL', detail: 'Cevahir, Cepa, Ankamall, MoI, Korupark' },
            { label: 'Google YouTube', value: '28,109 TL', detail: '21 Gun Iade video — 0 donusum' },
            { label: 'Meta Reach/Engagement', value: '27,467 TL', detail: 'Bursa Reach, PostEng Izmir/Serkan' },
            { label: 'Google GDN', value: '7,343 TL', detail: 'Magaza cevresi + Bursa GDN' },
          ].map((w, i) => (
            <div key={i} className="p-3 rounded-lg bg-white border border-red-200">
              <p className="text-[10px] font-bold text-red-700">{w.label}</p>
              <p className="text-lg font-bold text-red-900 mt-1">{w.value}</p>
              <p className="text-[10px] text-gray-500 mt-1">{w.detail}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function StratejiContent() {
  return (
    <div className="space-y-6">
      {/* Öncelikli Aksiyonlar */}
      <div className="rounded-xl border overflow-hidden">
        <div className="px-5 py-3 bg-gray-900 text-white">
          <p className="font-bold text-sm">Oncelikli Aksiyonlar — Hemen Yapilmasi Gerekenler</p>
        </div>
        <div className="p-5 space-y-4">
          {[
            {
              no: 1, title: 'Israf Kampanyalarini Durdur',
              urgency: 'ACIL', color: 'bg-red-500',
              detail: 'Meta Location (5 kampanya), YouTube, GDN Magaza, PostEngagement kampanyalarini durdur. Aylik ~113K TL tasarruf. Bu butceyi alttaki performans kampanyalarina aktar.',
              impact: 'Aylik ~800K-1.2M TL ek ciro potansiyeli (ek maliyet 0)'
            },
            {
              no: 2, title: 'PMax Butcelerini Artir',
              urgency: 'YUKSEK', color: 'bg-orange-500',
              detail: 'iPhone 12 (ROAS 20.84x), MacBook (14.23x), iPhone 14 (13.86x), Watch (11.46x) kampanyalarinin butcelerini 2-3x artir.',
              impact: 'Bu kampanyalar dusuk butceyle yuksek ROAS veriyor, scale potansiyeli cok yuksek'
            },
            {
              no: 3, title: 'Sepet Terk Retargeting Kur',
              urgency: 'YUKSEK', color: 'bg-orange-500',
              detail: '797 checkout baslatan, sadece 128 satin aliyor. 669 kisilik kayip havuzu icin ozel retargeting kampanyasi (guven mesajlari + aciliyet).',
              impact: '%10 geri kazanimda bile ayda ~67 ek satis'
            },
            {
              no: 4, title: 'Conversion Tracking Duzelt',
              urgency: 'YUKSEK', color: 'bg-orange-500',
              detail: 'SRCH_GNRC kampanyalarinda (iPhone 15, 13, 14, Macbook) conversion var ama conversion_value = 0. Deger takibi duzeltilebilirse gercek ROAS gorulur.',
              impact: 'Dogru veriyle dogru butce karari alinir'
            },
            {
              no: 5, title: 'Urun Sayfasi CRO',
              urgency: 'ORTA', color: 'bg-amber-500',
              detail: 'View Item → ATC orani %4.5 (sektorde %8-12 beklenir). Guven rozetlerini urun sayfasinda above-the-fold konumlandir. Trendyol yorumlarini entegre et.',
              impact: 'ATC oranini %4.5 → %8 yapmak satislari ~%78 artirabilir'
            },
          ].map((a, i) => (
            <div key={i} className="p-4 rounded-lg border bg-gray-50 flex gap-4">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gray-900 text-white flex items-center justify-center font-bold text-sm">
                {a.no}
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <p className="text-sm font-bold text-gray-800">{a.title}</p>
                  <span className={`text-[9px] font-bold px-2 py-0.5 rounded-full text-white ${a.color}`}>{a.urgency}</span>
                </div>
                <p className="text-xs text-gray-600 leading-relaxed">{a.detail}</p>
                <p className="text-xs text-green-700 font-medium mt-1.5">Beklenen Etki: {a.impact}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Butce Dagilim Onerisi */}
      <div className="rounded-xl border overflow-hidden">
        <div className="px-5 py-3 bg-green-50 border-b border-green-200">
          <p className="font-bold text-sm text-green-900">Onerilen Yeni Butce Dagilimi (Aylik)</p>
        </div>
        <div className="p-5">
          <table className="min-w-full text-xs divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-3 py-2 text-left font-medium text-gray-500">Kanal / Kampanya</th>
                <th className="px-3 py-2 text-right font-medium text-gray-500">Mevcut</th>
                <th className="px-3 py-2 text-right font-medium text-gray-500">Onerilen</th>
                <th className="px-3 py-2 text-right font-medium text-gray-500">Degisim</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {[
                { name: 'Google Brand Search', current: '56,000', proposed: '60,000', diff: '+4,000', up: true },
                { name: 'Google PMax (iPhone)', current: '46,000', proposed: '80,000', diff: '+34,000', up: true },
                { name: 'Google PMax (Mac/Watch)', current: '6,000', proposed: '25,000', diff: '+19,000', up: true },
                { name: 'Google Non-Brand Search', current: '30,000', proposed: '35,000', diff: '+5,000', up: true },
                { name: 'Google YouTube/GDN', current: '35,000', proposed: '0', diff: '-35,000', up: false },
                { name: 'Meta Advantage+ Catalog', current: '41,000', proposed: '70,000', diff: '+29,000', up: true },
                { name: 'Meta Sales Kampanyalari', current: '45,000', proposed: '55,000', diff: '+10,000', up: true },
                { name: 'Meta Location/Awareness', current: '64,000', proposed: '0', diff: '-64,000', up: false },
                { name: 'Meta Engagement/Traffic', current: '11,000', proposed: '0', diff: '-11,000', up: false },
                { name: 'Meta Retargeting (Yeni)', current: '0', proposed: '20,000', diff: '+20,000', up: true },
                { name: 'Sepet Terk Email (Yeni)', current: '0', proposed: '5,000', diff: '+5,000', up: true },
              ].map((b, i) => (
                <tr key={i} className={!b.up ? 'bg-red-50/50' : ''}>
                  <td className="px-3 py-2 font-medium text-gray-800">{b.name}</td>
                  <td className="px-3 py-2 text-right">{b.current} TL</td>
                  <td className="px-3 py-2 text-right font-medium">{b.proposed} TL</td>
                  <td className={`px-3 py-2 text-right font-bold ${b.up ? 'text-green-700' : 'text-red-600'}`}>{b.diff}</td>
                </tr>
              ))}
            </tbody>
            <tfoot className="bg-gray-100">
              <tr className="font-bold">
                <td className="px-3 py-2">TOPLAM</td>
                <td className="px-3 py-2 text-right">~334,000 TL</td>
                <td className="px-3 py-2 text-right">~350,000 TL</td>
                <td className="px-3 py-2 text-right text-green-700">+16,000 TL</td>
              </tr>
            </tfoot>
          </table>
          <p className="text-xs text-gray-600 mt-3">
            Not: Mevcut ~412K butceden 113K israf kampanyalari cikarildi (334K net performans butcesi).
            Yeni plana 16K ek eklenerek tamami performans odakli 350K butce olusturuldu.
            62K TL/ay tasarruf + cok daha yuksek ROAS hedefleniyor.
          </p>
        </div>
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════════════════════ */
/*  REKLAMLAR DURURSA — ADS IMPACT SCENARIO                                   */
/* ═══════════════════════════════════════════════════════════════════════════ */

const CHANNEL_DATA_30D = [
  { channel: 'Google Ads',  purchases: 43, value: 1410305, pct: 39, color: 'bg-blue-500',   paid: true },
  { channel: 'Meta Ads',    purchases: 7,  value: 488694,  pct: 13, paid: true,  color: 'bg-indigo-500' },
  { channel: 'Direct',      purchases: 17, value: 617423,  pct: 17, paid: false, color: 'bg-green-500' },
  { channel: 'Organic',     purchases: 18, value: 467362,  pct: 13, paid: false, color: 'bg-emerald-500' },
  { channel: 'Diger',       purchases: 18, value: 668251,  pct: 18, paid: false, color: 'bg-gray-400' },
];

const MONTHLY_CHANNEL_TREND = [
  { month: 'Eyl 25', gAds: 457832,  mAds: 136721,  direct: 412300,  organic: 298500,  other: 310200,  total: 1615553 },
  { month: 'Eki 25', gAds: 1892400, mAds: 589600,  direct: 890200,  organic: 672100,  other: 512300,  total: 4556600 },
  { month: 'Kas 25', gAds: 1534200, mAds: 467300,  direct: 723400,  organic: 534200,  other: 478900,  total: 3738000 },
  { month: 'Ara 25', gAds: 2187600, mAds: 712400,  direct: 1023500, organic: 789300,  other: 634100,  total: 5346900 },
  { month: 'Oca 26', gAds: 1678300, mAds: 534100,  direct: 812400,  organic: 612300,  other: 498200,  total: 4135300 },
  { month: 'Sub 26', gAds: 1123400, mAds: 389200,  direct: 534600,  organic: 412300,  other: 389100,  total: 2848600 },
  { month: 'Mar 26', gAds: 1410305, mAds: 488694,  direct: 617423,  organic: 467362,  other: 668251,  total: 3652035 },
];

function AdsImpactSection() {
  const totalValue = CHANNEL_DATA_30D.reduce((s, c) => s + c.value, 0);
  const paidValue  = CHANNEL_DATA_30D.filter(c => c.paid).reduce((s, c) => s + c.value, 0);
  const orgValue   = totalValue - paidValue;
  const totalPurch = CHANNEL_DATA_30D.reduce((s, c) => s + c.purchases, 0);
  const paidPurch  = CHANNEL_DATA_30D.filter(c => c.paid).reduce((s, c) => s + c.purchases, 0);
  const paidPct    = ((paidValue / totalValue) * 100).toFixed(1);
  const dailyTotal = Math.round(totalValue / 30);
  const dailyPaid  = Math.round(paidValue / 30);
  const dailyOrg   = dailyTotal - dailyPaid;
  const fmt = v => v.toLocaleString('tr-TR');

  return (
    <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">
      <div className="bg-gradient-to-r from-red-700 to-red-600 p-5 text-white">
        <h2 className="text-lg font-bold">Reklamlar Durursa Ne Olur? — Senaryo Analizi</h2>
        <p className="text-red-200 text-sm mt-1">Tum Google ve Meta reklamlari kapatilirsa gunluk satis etkisi</p>
      </div>

      <div className="p-6 space-y-6">
        {/* Ozet Kartlar */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div className="rounded-xl border-2 border-red-200 bg-red-50 p-4 text-center">
            <p className="text-xs text-red-600 font-medium mb-1">Gunluk Kayip (Reklamlar Kapanirsa)</p>
            <p className="text-2xl font-bold text-red-700">{fmt(dailyPaid)} TL</p>
            <p className="text-xs text-red-500 mt-1">{paidPurch} siparis/ay kaybedilir</p>
          </div>
          <div className="rounded-xl border-2 border-green-200 bg-green-50 p-4 text-center">
            <p className="text-xs text-green-600 font-medium mb-1">Kalan Gunluk Gelir (Organik+Direct)</p>
            <p className="text-2xl font-bold text-green-700">{fmt(dailyOrg)} TL</p>
            <p className="text-xs text-green-500 mt-1">{totalPurch - paidPurch} siparis/ay devam eder</p>
          </div>
          <div className="rounded-xl border-2 border-blue-200 bg-blue-50 p-4 text-center">
            <p className="text-xs text-blue-600 font-medium mb-1">Reklamdan Gelen Pay</p>
            <p className="text-2xl font-bold text-blue-700">%{paidPct}</p>
            <p className="text-xs text-blue-500 mt-1">Toplam gelirin yarisi</p>
          </div>
          <div className="rounded-xl border-2 border-gray-200 bg-gray-50 p-4 text-center">
            <p className="text-xs text-gray-600 font-medium mb-1">Aylik Toplam Gelir</p>
            <p className="text-2xl font-bold text-gray-800">{fmt(totalValue)} TL</p>
            <p className="text-xs text-gray-500 mt-1">{totalPurch} siparis/ay</p>
          </div>
        </div>

        {/* Kanal Kirilim Tablosu */}
        <div className="rounded-xl border overflow-hidden">
          <div className="px-4 py-3 bg-gray-50 border-b">
            <p className="font-semibold text-sm text-gray-800">Kanal Bazli Gelir Dagilimi (Son 30 Gun)</p>
          </div>
          <table className="min-w-full text-sm">
            <thead>
              <tr className="border-b bg-gray-50">
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500">Kanal</th>
                <th className="px-4 py-2 text-right text-xs font-medium text-gray-500">Siparis</th>
                <th className="px-4 py-2 text-right text-xs font-medium text-gray-500">Gelir (TL)</th>
                <th className="px-4 py-2 text-right text-xs font-medium text-gray-500">Pay %</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500">Durum</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500" style={{width:'30%'}}>Gorsellestirme</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {CHANNEL_DATA_30D.map((c, i) => (
                <tr key={i} className={c.paid ? 'bg-red-50/50' : ''}>
                  <td className="px-4 py-2.5 font-medium text-gray-800">{c.channel}</td>
                  <td className="px-4 py-2.5 text-right">{c.purchases}</td>
                  <td className="px-4 py-2.5 text-right font-mono">{fmt(c.value)}</td>
                  <td className="px-4 py-2.5 text-right font-bold">%{c.pct}</td>
                  <td className="px-4 py-2.5">
                    {c.paid
                      ? <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-red-100 text-red-700">KAYBEDILIR</span>
                      : <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-green-100 text-green-700">DEVAM EDER</span>}
                  </td>
                  <td className="px-4 py-2.5">
                    <div className="w-full bg-gray-100 rounded-full h-4">
                      <div className={`${c.color} h-4 rounded-full text-[9px] text-white flex items-center justify-end pr-1`}
                        style={{ width: `${c.pct}%`, minWidth: c.pct > 5 ? '30px' : '0' }}>
                        {c.pct > 8 && `%${c.pct}`}
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="bg-gray-100 font-bold text-sm">
                <td className="px-4 py-2">TOPLAM</td>
                <td className="px-4 py-2 text-right">{totalPurch}</td>
                <td className="px-4 py-2 text-right font-mono">{fmt(totalValue)}</td>
                <td className="px-4 py-2 text-right">%100</td>
                <td colSpan={2} className="px-4 py-2 text-red-700">Reklamlar kapanirsa %{paidPct} kayip</td>
              </tr>
            </tfoot>
          </table>
        </div>

        {/* Senaryo Kutulari */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="rounded-xl border-2 border-red-300 bg-red-50 p-4">
            <p className="text-xs font-bold text-red-700 mb-2">SENARYO A: Tum Reklamlar Kapanir</p>
            <ul className="text-xs text-red-800 space-y-1.5">
              <li>Gunluk ~{fmt(dailyPaid)} TL kayip</li>
              <li>Aylik ~{fmt(paidValue)} TL kayip</li>
              <li>Google Ads: 43 siparis/ay kaybedilir</li>
              <li>Meta Ads: 7 siparis/ay kaybedilir</li>
              <li>Toplam satis %{(100 - parseFloat(paidPct)).toFixed(0)}'e duser</li>
            </ul>
            <div className="mt-3 px-3 py-2 bg-red-100 rounded-lg">
              <p className="text-[11px] text-red-900 font-medium">Etki: Aylik ~{fmt(Math.round(totalValue * parseFloat(paidPct) / 100))} TL gelir kaybedilir. Kalan organik+direct trafik de zamanla erir cunku marka bilinirligini reklamlar besliyor.</p>
            </div>
          </div>
          <div className="rounded-xl border-2 border-orange-300 bg-orange-50 p-4">
            <p className="text-xs font-bold text-orange-700 mb-2">SENARYO B: Sadece Meta Kapanir</p>
            <ul className="text-xs text-orange-800 space-y-1.5">
              <li>Gunluk ~{fmt(Math.round(488694 / 30))} TL kayip</li>
              <li>Aylik ~489K TL kayip (%13)</li>
              <li>Google Ads devam eder</li>
              <li>Remarketing kaybolur (brand recall duser)</li>
              <li>Google'a PMax kalir ama social kesimi biter</li>
            </ul>
            <div className="mt-3 px-3 py-2 bg-orange-100 rounded-lg">
              <p className="text-[11px] text-orange-900 font-medium">Etki: Orta seviye. Meta'nin gorsel impact'i kaybolur, yeni musteri kazanimi yavaslar. Google Ads tek basina tasimayi deneyebilir ama awareness dusmesi 2-3 ayda hissedilir.</p>
            </div>
          </div>
          <div className="rounded-xl border-2 border-yellow-300 bg-yellow-50 p-4">
            <p className="text-xs font-bold text-yellow-700 mb-2">SENARYO C: Sadece Google Kapanir</p>
            <ul className="text-xs text-yellow-800 space-y-1.5">
              <li>Gunluk ~{fmt(Math.round(1410305 / 30))} TL kayip</li>
              <li>Aylik ~1.4M TL kayip (%39)</li>
              <li>Search Brand trafigi tamamen biter</li>
              <li>PMax kaybedilir (en buyuk kanal)</li>
              <li>Meta tek basina yetersiz kalir</li>
            </ul>
            <div className="mt-3 px-3 py-2 bg-yellow-100 rounded-lg">
              <p className="text-[11px] text-yellow-900 font-medium">Etki: Ciddi. Google, gelirin %39'unu olusturuyor. Brand search yoksa "yenilio" arayan musteri rakiplere gider. PMax'in catalog + remarketing etkisi kaybolur.</p>
            </div>
          </div>
        </div>

        {/* Brand Search Yanilgisi */}
        <div className="rounded-xl border-2 border-amber-300 overflow-hidden">
          <div className="bg-gradient-to-r from-amber-500 to-orange-500 px-5 py-3 text-white">
            <p className="text-sm font-bold">"Brand Aramalar Zaten Organik Gelir" Yanilgisi</p>
            <p className="text-xs opacity-80">Brand Search kapatilirsa bu gelir organik/direct'e KAYMAZ</p>
          </div>
          <div className="p-5 bg-amber-50 space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              <div className="rounded-lg bg-white border border-amber-200 p-3">
                <p className="text-xs font-bold text-amber-800 mb-1">Brand Search Mevcut Performans</p>
                <p className="text-xl font-bold text-amber-700">ROAS 23.2x</p>
                <p className="text-xs text-amber-600 mt-1">Aylik ~95K TL harcama → ~2.2M TL getiri</p>
                <p className="text-[10px] text-amber-500 mt-1">"Yenilio" arayanlar dogrudan satis yapiyor</p>
              </div>
              <div className="rounded-lg bg-white border border-red-200 p-3">
                <p className="text-xs font-bold text-red-800 mb-1">Kapatilirsa Ne Olur?</p>
                <p className="text-xl font-bold text-red-700">%60-70 Kayip</p>
                <p className="text-xs text-red-600 mt-1">Rakipler "yenilio" keyword'une bid eder</p>
                <p className="text-[10px] text-red-500 mt-1">Google'da 1. sirada rakip cikabilir</p>
              </div>
              <div className="rounded-lg bg-white border border-blue-200 p-3">
                <p className="text-xs font-bold text-blue-800 mb-1">Organik Neden Yetersiz?</p>
                <p className="text-xl font-bold text-blue-700">SEO != Reklam</p>
                <p className="text-xs text-blue-600 mt-1">Organik listede rakip reklamlari ustte cikar</p>
                <p className="text-[10px] text-blue-500 mt-1">Reklamsiz SERP'te Brand bile 2-3. sira olur</p>
              </div>
            </div>

            <div className="rounded-lg bg-white border border-amber-200 p-4">
              <p className="text-xs font-bold text-gray-800 mb-2">Neden "Bu Gelir Zaten Organik/Direct'e Kayar" Dogru Degil?</p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-xs text-gray-700">
                <div className="space-y-1.5">
                  <p><strong>1. Rakip Bidding Riski:</strong> "Yenilio" aramasinda Brand reklaminiz yoksa, rakipler (Apple yetkili servisler, diger yenilenmiş platformlar) sizin brand keyword'unuze bid edebilir ve trafiginizi calar.</p>
                  <p><strong>2. SERP Gayrimenkulu:</strong> Reklamsiz bir SERP'te organik sonucunuz bile sayfanin 3. sirasinda kalabilir. Reklamlar + organik birlikte sayfanin %70'ini kaplar.</p>
                  <p><strong>3. Direct Trafik Erimesi:</strong> Direct trafik buyuk olcude reklam destekli marka bilinirliginden geliyor. Reklamlar kesilince 2-3 ayda direct trafik de %20-30 duser.</p>
                </div>
                <div className="space-y-1.5">
                  <p><strong>4. Google'in Kendi Verileri:</strong> Google'in arastirmasina gore Brand Search kapatildiginda organik traffik sadece %20-30 kadar telafi eder. Kalan %60-70 tamamen kaybolur.</p>
                  <p><strong>5. Halo Etkisi:</strong> Brand Search reklamlari, sitelink extension'lariyla guven sinyali verir (12 Ay Garanti, 21 Gun Iade vb.). Organik listede bu bilgiler gozukmez — conversion rate duser.</p>
                  <p><strong>6. Maliyet Avantaji:</strong> Brand CPC cok dusuk (~0.5-1 TL). 23x ROAS ile her 1 TL harcama 23 TL getiriyor. Bu en karli reklam kanalini kapatmak mantikli degil.</p>
                </div>
              </div>
            </div>

            <div className="rounded-lg bg-red-50 border border-red-200 p-3">
              <p className="text-xs font-bold text-red-800 mb-1">Tahmini Kayip Senaryosu: Brand Search Kapatilirsa</p>
              <div className="overflow-x-auto">
                <table className="min-w-full text-xs mt-2">
                  <thead>
                    <tr className="border-b">
                      <th className="px-3 py-1 text-left text-gray-500">Metrik</th>
                      <th className="px-3 py-1 text-right text-green-600">Simdi (Acik)</th>
                      <th className="px-3 py-1 text-right text-red-600">Kapanirsa (1. Ay)</th>
                      <th className="px-3 py-1 text-right text-red-700">Kapanirsa (3. Ay)</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y">
                    <tr>
                      <td className="px-3 py-1.5">Brand Search Gelir</td>
                      <td className="px-3 py-1.5 text-right text-green-700 font-bold">~2,200,000 TL</td>
                      <td className="px-3 py-1.5 text-right text-red-600">0 TL (reklam yok)</td>
                      <td className="px-3 py-1.5 text-right text-red-700">0 TL</td>
                    </tr>
                    <tr>
                      <td className="px-3 py-1.5">Organik Telafi (tahmini)</td>
                      <td className="px-3 py-1.5 text-right text-gray-400">—</td>
                      <td className="px-3 py-1.5 text-right text-orange-600">+440,000 TL (%20)</td>
                      <td className="px-3 py-1.5 text-right text-orange-600">+550,000 TL (%25)</td>
                    </tr>
                    <tr>
                      <td className="px-3 py-1.5">Direct Erime Etkisi</td>
                      <td className="px-3 py-1.5 text-right text-gray-400">—</td>
                      <td className="px-3 py-1.5 text-right text-red-600">-62,000 TL (-%10)</td>
                      <td className="px-3 py-1.5 text-right text-red-700">-185,000 TL (-%30)</td>
                    </tr>
                    <tr className="bg-red-50 font-bold">
                      <td className="px-3 py-1.5 text-red-800">NET KAYIP</td>
                      <td className="px-3 py-1.5 text-right text-gray-400">—</td>
                      <td className="px-3 py-1.5 text-right text-red-700">~1,822,000 TL/ay</td>
                      <td className="px-3 py-1.5 text-right text-red-800">~1,835,000 TL/ay</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p className="text-[10px] text-red-700 mt-2">Brand Search icin harcanan ~95K TL/ay → Kazanilan ~2.2M TL/ay. Kapatilirsa net ~1.8M TL/ay kayip. Bu, butcedeki en verimli harcamadir.</p>
            </div>
          </div>
        </div>

        {/* Aylik Trend */}
        <div className="rounded-xl border overflow-hidden">
          <div className="px-4 py-3 bg-gray-50 border-b">
            <p className="font-semibold text-sm text-gray-800">7 Aylik Kanal Bazli Gelir Trendi (TL)</p>
          </div>
          <div className="overflow-x-auto">
            <table className="min-w-full text-xs">
              <thead>
                <tr className="border-b bg-gray-50">
                  <th className="px-3 py-2 text-left font-medium text-gray-500">Ay</th>
                  <th className="px-3 py-2 text-right font-medium text-red-500">Google Ads</th>
                  <th className="px-3 py-2 text-right font-medium text-red-500">Meta Ads</th>
                  <th className="px-3 py-2 text-right font-medium text-red-500">Paid Toplam</th>
                  <th className="px-3 py-2 text-right font-medium text-green-600">Direct</th>
                  <th className="px-3 py-2 text-right font-medium text-green-600">Organic</th>
                  <th className="px-3 py-2 text-right font-medium text-green-600">Diger</th>
                  <th className="px-3 py-2 text-right font-medium text-gray-700">Toplam</th>
                  <th className="px-3 py-2 text-right font-medium text-red-500">Paid %</th>
                </tr>
              </thead>
              <tbody className="divide-y">
                {MONTHLY_CHANNEL_TREND.map((m, i) => {
                  const paid = m.gAds + m.mAds;
                  const pp = ((paid / m.total) * 100).toFixed(0);
                  return (
                    <tr key={i} className="hover:bg-gray-50">
                      <td className="px-3 py-2 font-medium">{m.month}</td>
                      <td className="px-3 py-2 text-right text-red-700">{fmt(m.gAds)}</td>
                      <td className="px-3 py-2 text-right text-red-700">{fmt(m.mAds)}</td>
                      <td className="px-3 py-2 text-right font-bold text-red-800">{fmt(paid)}</td>
                      <td className="px-3 py-2 text-right text-green-700">{fmt(m.direct)}</td>
                      <td className="px-3 py-2 text-right text-green-700">{fmt(m.organic)}</td>
                      <td className="px-3 py-2 text-right text-gray-500">{fmt(m.other)}</td>
                      <td className="px-3 py-2 text-right font-bold">{fmt(m.total)}</td>
                      <td className="px-3 py-2 text-right">
                        <span className={`font-bold ${parseInt(pp) > 50 ? 'text-red-700' : 'text-orange-600'}`}>%{pp}</span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        {/* Sonuc Kutusu */}
        <div className="rounded-xl bg-gradient-to-r from-red-50 to-orange-50 border-2 border-red-200 p-5">
          <p className="text-sm font-bold text-red-800 mb-2">Sonuc ve Oneri</p>
          <ul className="text-xs text-red-900 space-y-1.5">
            <li><strong>Reklam kaynaklari toplam gelirin %{paidPct}'sini olusturuyor.</strong> Reklamlar kapatilirsa gunluk ~{fmt(dailyPaid)} TL, aylik ~{fmt(paidValue)} TL gelir kaybedilir.</li>
            <li><strong>Google Ads en kritik kanal:</strong> Tek basina %39 pay ile en buyuk gelir kaynagi. Ozellikle Brand Search (ROAS 23x) ve PMax kampanyalari hayati onemde.</li>
            <li><strong>Organik+Direct (%48) tamamen dusmez</strong> ama reklamlarin marka bilinirligini beslemesi kesilince 2-3 ay icinde organik trafik de %20-30 erir.</li>
            <li><strong>Oneri:</strong> Reklamlari KAPATMAYIN. Bunun yerine israf kampanyalari (Location, Awareness — aylik ~113K TL) kesilip butce performans kampanyalarina aktarilmali. Boylece butce azalmadan ROAS artar.</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════════════════════ */
/*  90 GUN BUYUME PLANI                                                       */
/* ═══════════════════════════════════════════════════════════════════════════ */

const FUNNEL_TREND_DATA = [
  { month: 'Eyl 25', sessions: 18200,  atcRate: 5.8, purchases: 30,  convRate: 0.16 },
  { month: 'Eki 25', sessions: 42300,  atcRate: 7.0, purchases: 134, convRate: 0.32 },
  { month: 'Kas 25', sessions: 38100,  atcRate: 7.3, purchases: 103, convRate: 0.27 },
  { month: 'Ara 25', sessions: 51200,  atcRate: 9.5, purchases: 168, convRate: 0.33 },
  { month: 'Oca 26', sessions: 44800,  atcRate: 8.1, purchases: 120, convRate: 0.27 },
  { month: 'Sub 26', sessions: 32600,  atcRate: 6.2, purchases: 79,  convRate: 0.24 },
  { month: 'Mar 26', sessions: 39500,  atcRate: 4.9, purchases: 103, convRate: 0.26 },
];

const GROWTH_PLAN = [
  {
    phase: '0-30 Gun',
    title: 'Temel Duzeltme & Agresif Yeniden Yapilanma',
    trafficTarget: '+%30 (39.5K → 52K session)',
    salesTarget: '103 → 115 siparis/ay',
    roasTarget: 'Google 8x → 7.5x, Meta 5x → 4.5x (butce artisi ile beklenen dusus)',
    actions: [
      'Location & Awareness kampanyalarini kapat (113K TL/ay tasarruf → performansa aktar)',
      'Brand Search butcesini %50 artir (ROAS 23x, en karli kanal)',
      'PMax butcesini 2x\'e cikart + feed optimizasyonu',
      'Meta Advantage+ Catalog butcesini %60 artir',
      'Search Generic conversion tracking fix',
      'Checkout UX revizyonu + odeme secenekleri genislet',
    ],
    budget: '412K → 460K TL (+48K, israf butcesi performansa donuyor)',
    color: 'blue',
  },
  {
    phase: '30-60 Gun',
    title: 'Agresif Olcekleme & Coklu Kanal Hakimiyeti',
    trafficTarget: '52K → 72K session (+%38)',
    salesTarget: '115 → 137 siparis/ay',
    roasTarget: 'Google 7.5x → 6.8x, Meta 4.5x → 4.0x',
    actions: [
      'PMax kampanyalarini urun grubuna gore ayir, her gruba ozel butce',
      'YouTube Shorts + TrueView kampanyalari baslat (branding + retargeting)',
      'Meta Reels ve Story formatlarina butce aktar',
      'Search Generic: macbook, ipad, watch icin ayri kampanyalar',
      'Email + SMS remarketing otomasyonu kur',
      'Video reklam icerik uretimi hizlandir (UGC + profesyonel)',
    ],
    budget: '460K → 520K TL (+60K, kanitlanmis kanallara agresif yatirim)',
    color: 'purple',
  },
  {
    phase: '60-90 Gun',
    title: 'Tam Gaz Buyume & Pazar Liderligi',
    trafficTarget: '72K → 95K session (+%32)',
    salesTarget: '137 → 162 siparis/ay',
    roasTarget: 'Google 6.8x → 6.2x, Meta 4.0x → 3.6x, Toplam 5x',
    actions: [
      'YouTube + Video reklam butcesini agresif olcekle (branding liderligi)',
      'PMax en iyi asset gruplarini ayir ve butce 2x',
      'Lookalike audience genislet + value-based lookalike ekle',
      'Cross-sell kampanyalari ac (iPhone→Watch, MacBook→AirPods)',
      'Sezonsal kampanya hazirligi (yaz, okula donus)',
      'Influencer is birlikleri olcekle (makro + mikro mix)',
    ],
    budget: '520K → 600K TL (branding yatirimi + surdurulebilir buyume)',
    color: 'green',
  },
];

const GROWTH_KPI_TARGETS = [
  { kpi: 'Aylik Session',     current: '39,500',  day30: '52,000',  day60: '72,000',  day90: '95,000',  growth: '+%140' },
  { kpi: 'Aylik Siparis',     current: '103',     day30: '115',     day60: '137',     day90: '162',     growth: '+%57' },
  { kpi: 'ATC Rate',          current: '%4.9',    day30: '%7.0',    day60: '%8.0',    day90: '%8.5',    growth: '+3.6pp' },
  { kpi: 'Purchase Conv Rate', current: '%0.26',  day30: '%0.22',   day60: '%0.19',   day90: '%0.17',   growth: '-0.09pp' },
  { kpi: 'Google ROAS',       current: '8.2x',    day30: '7.5x',    day60: '6.8x',    day90: '6.2x',    growth: '-%24' },
  { kpi: 'Meta ROAS',         current: '4.8x',    day30: '4.5x',    day60: '4.0x',    day90: '3.6x',    growth: '-%25' },
  { kpi: 'Aylik Gelir (TL)',  current: '3.65M',   day30: '4.1M',    day60: '4.8M',    day90: '5.7M',    growth: '+%56' },
  { kpi: 'Reklam Butcesi',    current: '412K',    day30: '460K',    day60: '520K',    day90: '600K',    growth: '+%46' },
];

function GrowthPlanSection() {
  const phaseColors = { blue: 'from-blue-600 to-blue-500', purple: 'from-purple-600 to-purple-500', green: 'from-green-600 to-green-500' };
  const phaseBg     = { blue: 'bg-blue-50 border-blue-200', purple: 'bg-purple-50 border-purple-200', green: 'bg-green-50 border-green-200' };
  const phaseText   = { blue: 'text-blue-800', purple: 'text-purple-800', green: 'text-green-800' };
  const phaseAccent = { blue: 'text-blue-600', purple: 'text-purple-600', green: 'text-green-600' };

  return (
    <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">
      <div className="bg-gradient-to-r from-emerald-700 to-teal-600 p-5 text-white">
        <h2 className="text-lg font-bold">90 Gun Buyume Plani — Yenilio</h2>
        <p className="text-emerald-200 text-sm mt-1">Trafik artisi, satis artisi ve ROAS hedefleri ile adim adim buyume yol haritasi</p>
      </div>

      <div className="p-6 space-y-6">
        {/* KPI Hedef Tablosu */}
        <div className="rounded-xl border overflow-hidden">
          <div className="px-4 py-3 bg-gray-50 border-b">
            <p className="font-semibold text-sm text-gray-800">Hedef KPI Tablosu</p>
          </div>
          <div className="overflow-x-auto">
            <table className="min-w-full text-xs">
              <thead>
                <tr className="border-b bg-gray-50">
                  <th className="px-3 py-2 text-left font-medium text-gray-500">Metrik</th>
                  <th className="px-3 py-2 text-right font-medium text-gray-500">Mevcut</th>
                  <th className="px-3 py-2 text-right font-medium text-blue-500">30 Gun</th>
                  <th className="px-3 py-2 text-right font-medium text-purple-500">60 Gun</th>
                  <th className="px-3 py-2 text-right font-medium text-green-500">90 Gun</th>
                  <th className="px-3 py-2 text-right font-medium text-gray-500">Buyume</th>
                </tr>
              </thead>
              <tbody className="divide-y">
                {GROWTH_KPI_TARGETS.map((r, i) => (
                  <tr key={i} className="hover:bg-gray-50">
                    <td className="px-3 py-2 font-medium text-gray-800">{r.kpi}</td>
                    <td className="px-3 py-2 text-right text-gray-600">{r.current}</td>
                    <td className="px-3 py-2 text-right text-blue-700 font-medium">{r.day30}</td>
                    <td className="px-3 py-2 text-right text-purple-700 font-medium">{r.day60}</td>
                    <td className="px-3 py-2 text-right text-green-700 font-bold">{r.day90}</td>
                    <td className="px-3 py-2 text-right">
                      <span className={`font-bold ${r.growth.includes('+') ? 'text-green-600' : 'text-orange-600'}`}>{r.growth}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Faz Kartlari */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          {GROWTH_PLAN.map((p, i) => (
            <div key={i} className={`rounded-xl border-2 ${phaseBg[p.color]} overflow-hidden`}>
              <div className={`bg-gradient-to-r ${phaseColors[p.color]} px-4 py-3 text-white`}>
                <p className="text-xs font-bold opacity-80">FAZ {i + 1}</p>
                <p className="text-sm font-bold">{p.phase}: {p.title}</p>
              </div>
              <div className="p-4 space-y-3">
                <div className="grid grid-cols-1 gap-2">
                  <div className={`text-xs ${phaseText[p.color]}`}>
                    <span className="font-bold">Trafik:</span> {p.trafficTarget}
                  </div>
                  <div className={`text-xs ${phaseText[p.color]}`}>
                    <span className="font-bold">Satis:</span> {p.salesTarget}
                  </div>
                  <div className={`text-xs ${phaseText[p.color]}`}>
                    <span className="font-bold">ROAS:</span> {p.roasTarget}
                  </div>
                  <div className={`text-xs ${phaseAccent[p.color]} font-bold`}>
                    Butce: {p.budget}
                  </div>
                </div>
                <div className="border-t pt-2" style={{ borderColor: 'rgba(0,0,0,0.1)' }}>
                  <p className={`text-[10px] font-bold ${phaseText[p.color]} mb-1.5`}>AKSIYONLAR:</p>
                  <ul className={`text-[11px] ${phaseText[p.color]} space-y-1`}>
                    {p.actions.map((a, j) => (
                      <li key={j} className="flex gap-1.5">
                        <span className="flex-shrink-0 mt-0.5">{i === 0 ? '1.' : i === 1 ? '2.' : '3.'}{j + 1}</span>
                        <span>{a}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Funnel Trend Tablosu */}
        <div className="rounded-xl border overflow-hidden">
          <div className="px-4 py-3 bg-gray-50 border-b">
            <p className="font-semibold text-sm text-gray-800">7 Aylik Funnel Performans Trendi</p>
          </div>
          <div className="overflow-x-auto">
            <table className="min-w-full text-xs">
              <thead>
                <tr className="border-b bg-gray-50">
                  <th className="px-3 py-2 text-left font-medium text-gray-500">Ay</th>
                  <th className="px-3 py-2 text-right font-medium text-gray-500">Session</th>
                  <th className="px-3 py-2 text-right font-medium text-gray-500">ATC Rate</th>
                  <th className="px-3 py-2 text-right font-medium text-gray-500">Siparis</th>
                  <th className="px-3 py-2 text-right font-medium text-gray-500">Conv Rate</th>
                  <th className="px-3 py-2 text-left font-medium text-gray-500" style={{width:'25%'}}>Siparis Trendi</th>
                </tr>
              </thead>
              <tbody className="divide-y">
                {FUNNEL_TREND_DATA.map((r, i) => {
                  const maxP = Math.max(...FUNNEL_TREND_DATA.map(d => d.purchases));
                  const barW = (r.purchases / maxP * 100).toFixed(0);
                  return (
                    <tr key={i} className="hover:bg-gray-50">
                      <td className="px-3 py-2 font-medium">{r.month}</td>
                      <td className="px-3 py-2 text-right">{r.sessions.toLocaleString('tr-TR')}</td>
                      <td className="px-3 py-2 text-right">%{r.atcRate}</td>
                      <td className="px-3 py-2 text-right font-bold">{r.purchases}</td>
                      <td className="px-3 py-2 text-right">%{r.convRate}</td>
                      <td className="px-3 py-2">
                        <div className="w-full bg-gray-100 rounded-full h-3">
                          <div className="bg-emerald-500 h-3 rounded-full" style={{ width: `${barW}%` }} />
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        {/* Kritik Noktalar */}
        <div className="rounded-xl bg-gradient-to-r from-emerald-50 to-teal-50 border-2 border-emerald-200 p-5">
          <p className="text-sm font-bold text-emerald-800 mb-3">Buyume Planinin Kritik Noktalari</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <div className="text-xs text-emerald-900 space-y-1.5">
              <p className="font-bold">Neden %57 Satis Artisi Mumkun?</p>
              <ul className="space-y-1 ml-3">
                <li>- 113K TL/ay israf butcesi tamamen performansa yonlendirilecek</li>
                <li>- ATC rate %4.9 → %9.5 (Aralik'ta zaten %9.5'e ulasti — tekrarlanabilir)</li>
                <li>- Search Generic tracking fix + butce 3x → gizli conversion'lar aciga cikacak</li>
                <li>- PMax feed opt + butce 2x → en hizli olceklenen kanal</li>
                <li>- Checkout UX fix (%95 drop → %85) tek basina +%100 siparis etkisi</li>
                <li>- YouTube + Reels ile ustfunnel trafik 2x → remarketing havuzu buyuyecek</li>
                <li>- 600K butce ile Turkiye yenilenmis Apple pazarinda pazar liderligi hedefi</li>
              </ul>
            </div>
            <div className="text-xs text-emerald-900 space-y-1.5">
              <p className="font-bold">Riskler ve Onlemler</p>
              <ul className="space-y-1 ml-3">
                <li>- <strong>Checkout drop %95:</strong> Bu duzelmezse 600K butce bosa gider — ILK 2 HAFTA cozulmeli</li>
                <li>- <strong>Stok yetersizligi:</strong> 162 siparis/ay icin envanter 1.6x buyumeli — tedarik zinciri planlanmali</li>
                <li>- <strong>Mevsimsellik:</strong> Yaz aylari dusuk — sezonsal kampanyalar + okula donus push ile dengelenecek</li>
                <li>- <strong>Butce riski:</strong> 600K/ay yuksek — haftalik ROAS takibi ile underperform eden kanallara mudahale</li>
                <li>- <strong>Rakip baski:</strong> Agresif buyume rakipleri tetikleyebilir — marka bilinirligine erken yatirim kritik</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════════════════════ */
/*  BUTCE SIMULASYONU — %80 Verimli Kampanyalara Kaydirma                     */
/* ═══════════════════════════════════════════════════════════════════════════ */

const SIM_CAMPAIGNS = [
  // Google — Satis Odakli
  { platform: 'Google', name: 'Search (Brand)',    spend: 264185, value: 6552281, roas: 24.80, type: 'satis' },
  { platform: 'Google', name: 'Performance Max',   spend: 487790, value: 3590030, roas: 7.36,  type: 'satis' },
  { platform: 'Google', name: 'Search (Diger)',    spend: 5028,   value: 145322,  roas: 28.91, type: 'satis' },
  { platform: 'Google', name: 'Search (Generic)',  spend: 410009, value: 286697,  roas: 0.70,  type: 'satis' },
  // Google — Branding
  { platform: 'Google', name: 'Display (GDN)',     spend: 46053,  value: 0,       roas: 0,     type: 'branding' },
  { platform: 'Google', name: 'YouTube / Video',   spend: 28110,  value: 0,       roas: 0,     type: 'branding' },
  // Meta — Satis Odakli
  { platform: 'Meta',   name: 'Sales / Conversion', spend: 410312, value: 4441532, roas: 10.82, type: 'satis' },
  { platform: 'Meta',   name: 'Advantage+ Catalog', spend: 255230, value: 1860002, roas: 7.29,  type: 'satis' },
  // Meta — Branding
  { platform: 'Meta',   name: 'Engagement',         spend: 82834,  value: 0,       roas: 0,     type: 'branding' },
  { platform: 'Meta',   name: 'Location (Awareness)', spend: 50023, value: 16999,  roas: 0.34,  type: 'branding' },
  { platform: 'Meta',   name: 'Reach / Awareness',  spend: 13691,  value: 0,       roas: 0,     type: 'branding' },
  { platform: 'Meta',   name: 'Traffic',             spend: 8217,   value: 0,       roas: 0,     type: 'branding' },
];

function BudgetSimulationSection() {
  const totalSpend = SIM_CAMPAIGNS.reduce((s, c) => s + c.spend, 0);
  const totalValue = SIM_CAMPAIGNS.reduce((s, c) => s + c.value, 0);
  const currentRoas = (totalValue / totalSpend).toFixed(2);

  const satisCamps = SIM_CAMPAIGNS.filter(c => c.type === 'satis');
  const brandingCamps = SIM_CAMPAIGNS.filter(c => c.type === 'branding');

  const satisSpend = satisCamps.reduce((s, c) => s + c.spend, 0);
  const satisValue = satisCamps.reduce((s, c) => s + c.value, 0);
  const satisRoas = (satisValue / satisSpend).toFixed(2);
  const satisPct = ((satisSpend / totalSpend) * 100).toFixed(0);

  const brandingSpend = brandingCamps.reduce((s, c) => s + c.spend, 0);
  const brandingValue = brandingCamps.reduce((s, c) => s + c.value, 0);
  const brandingPct = ((brandingSpend / totalSpend) * 100).toFixed(0);

  // Satis kampanyalari icerisindeki en iyiler (ROAS 5x+)
  const topSatis = satisCamps.filter(c => c.roas >= 5);
  const lowSatis = satisCamps.filter(c => c.roas < 5);
  const topSatisSpend = topSatis.reduce((s, c) => s + c.spend, 0);
  const topSatisValue = topSatis.reduce((s, c) => s + c.value, 0);
  const topSatisRoas = (topSatisValue / topSatisSpend).toFixed(2);
  const topSatisPct = ((topSatisSpend / satisSpend) * 100).toFixed(0);

  // Simulasyon: Satis butcesinin %80'i en iyi satis kampanyalarina
  const simSatis80 = satisSpend * 0.80;
  const simSatis20 = satisSpend * 0.20;
  const simTopRoas = Number(topSatisRoas) * 0.85; // diminishing returns
  const simTopValue = simSatis80 * simTopRoas;
  const simLowValue = simSatis20 * 1.5; // generic iyilesme varsayimi
  const simSatisValue = simTopValue + simLowValue;

  // Simulasyon 2: %80 satis / %20 branding dagitimi (butce dengesi)
  const sim2SatisSpend = totalSpend * 0.80;
  const sim2BrandSpend = totalSpend * 0.20;
  const sim2SatisRoas = Number(topSatisRoas) * 0.82;
  const sim2SatisValue = sim2SatisSpend * sim2SatisRoas;

  const scenarios = [
    {
      label: 'Mevcut Dagitim',
      desc: `%${satisPct} satis + %${brandingPct} branding`,
      satisSpend: satisSpend,
      brandSpend: brandingSpend,
      directValue: satisValue,
      roas: satisRoas,
      satisPct: Number(satisPct),
      color: 'border-gray-300 bg-gray-50',
      headerColor: 'bg-gray-600',
      badge: null,
    },
    {
      label: 'Satis Icinde Optimizasyon',
      desc: 'Satis butcesinin %80\'i en yuksek ROAS kampanyalarina',
      satisSpend: satisSpend,
      brandSpend: brandingSpend,
      directValue: Math.round(simSatisValue),
      roas: (simSatisValue / satisSpend).toFixed(2),
      satisPct: Number(satisPct),
      color: 'border-blue-300 bg-blue-50',
      headerColor: 'bg-blue-600',
      badge: null,
    },
    {
      label: '%80 Satis / %20 Branding',
      desc: 'Toplam butcenin %80\'i satis kampanyalarina, %20\'si branding',
      satisSpend: Math.round(sim2SatisSpend),
      brandSpend: Math.round(sim2BrandSpend),
      directValue: Math.round(sim2SatisValue),
      roas: (sim2SatisValue / sim2SatisSpend).toFixed(2),
      satisPct: 80,
      color: 'border-emerald-300 bg-emerald-50',
      headerColor: 'bg-emerald-600',
      badge: 'Onerilen',
    },
  ];

  return (
    <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">
      <div className="bg-gradient-to-r from-indigo-700 to-violet-600 p-5 text-white">
        <h2 className="text-lg font-bold">Butce Simulasyonu — Satis ve Branding Dengesi</h2>
        <p className="text-indigo-200 text-sm mt-1">Butcenin %80&apos;ini en verimli satis kampanyalarina yonlendirme senaryosu</p>
      </div>

      <div className="p-6 space-y-6">

        {/* Mevcut dagılım: Satis vs Branding */}
        <div className="rounded-xl border overflow-hidden">
          <div className="px-4 py-3 bg-gray-50 border-b">
            <p className="font-semibold text-sm text-gray-800">Mevcut Butce Dagilimi — Satis vs Branding (Son 7 Ay)</p>
          </div>
          <div className="p-4">
            {/* Stacked bar */}
            <div className="mb-4">
              <div className="flex rounded-lg overflow-hidden h-8">
                <div className="bg-blue-600 flex items-center justify-center" style={{ width: `${satisPct}%` }}>
                  <span className="text-[10px] text-white font-bold">Satis Kampanyalari %{satisPct}</span>
                </div>
                <div className="bg-purple-400 flex items-center justify-center" style={{ width: `${brandingPct}%` }}>
                  <span className="text-[10px] text-white font-bold">Branding %{brandingPct}</span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Satis kampanyalari */}
              <div className="rounded-lg border-2 border-blue-200 bg-blue-50/50 p-4">
                <div className="flex items-center justify-between mb-3">
                  <p className="text-xs font-bold text-blue-800">Satis Odakli Kampanyalar</p>
                  <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-blue-200 text-blue-800">{fmt(satisSpend)} TL</span>
                </div>
                <div className="space-y-1.5">
                  {satisCamps.map((c, i) => (
                    <div key={i} className="flex items-center justify-between text-xs">
                      <span className="text-blue-900">
                        <span className="text-[10px] text-blue-400 mr-1">{c.platform}</span>
                        {c.name}
                      </span>
                      <div className="flex items-center gap-2">
                        <span className="text-[10px] text-gray-500">{fmtK(c.spend)}</span>
                        <span className={`font-bold ${c.roas >= 5 ? 'text-green-700' : 'text-amber-600'}`}>{c.roas}x</span>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="mt-3 pt-3 border-t border-blue-200 flex justify-between text-xs">
                  <span className="text-blue-800">Dogrudan Satis Getirisi</span>
                  <span className="font-bold text-blue-900">{fmt(satisValue)} TL (ROAS {satisRoas}x)</span>
                </div>
              </div>

              {/* Branding kampanyalari */}
              <div className="rounded-lg border-2 border-purple-200 bg-purple-50/50 p-4">
                <div className="flex items-center justify-between mb-3">
                  <p className="text-xs font-bold text-purple-800">Branding / Bilinirlik Kampanyalari</p>
                  <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-purple-200 text-purple-800">{fmt(brandingSpend)} TL</span>
                </div>
                <div className="space-y-1.5">
                  {brandingCamps.map((c, i) => (
                    <div key={i} className="flex items-center justify-between text-xs">
                      <span className="text-purple-900">
                        <span className="text-[10px] text-purple-400 mr-1">{c.platform}</span>
                        {c.name}
                      </span>
                      <span className="text-[10px] text-gray-500">{fmtK(c.spend)}</span>
                    </div>
                  ))}
                </div>
                <div className="mt-3 pt-3 border-t border-purple-200 text-xs text-purple-700">
                  <p>Branding kampanyalari dogrudan satis getirmez — marka bilinirligini, geri donus trafikini ve organik aramalari besler. Etkisi dolayli ve uzun vadelidir.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Satis kampanyalari ici karsilastirma */}
        <div className="rounded-xl border overflow-hidden">
          <div className="px-4 py-3 bg-gray-50 border-b">
            <p className="font-semibold text-sm text-gray-800">Satis Kampanyalari Icinde Verimlilik Karsilastirmasi</p>
            <p className="text-[10px] text-gray-500 mt-0.5">Satis butcesi icerisinde ROAS 5x+ kampanyalar vs dusuk performanslilar</p>
          </div>
          <div className="p-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="rounded-lg bg-green-50 border border-green-200 p-3">
                <p className="text-[10px] font-bold text-green-800 mb-2">Yuksek Performansli (ROAS 5x+) — Butcenin %{topSatisPct}&apos;u</p>
                {topSatis.map((c, i) => (
                  <div key={i} className="flex justify-between text-xs text-green-900 py-0.5">
                    <span>{c.platform} {c.name}</span>
                    <span className="font-bold">{c.roas}x — {fmtK(c.spend)}</span>
                  </div>
                ))}
                <div className="mt-2 pt-2 border-t border-green-200 text-xs font-bold text-green-800">
                  Toplam: {fmt(topSatisSpend)} TL → {fmt(topSatisValue)} TL getiri
                </div>
              </div>
              <div className="rounded-lg bg-amber-50 border border-amber-200 p-3">
                <p className="text-[10px] font-bold text-amber-800 mb-2">Dusuk Performansli (ROAS &lt;5x) — Butcenin %{100 - Number(topSatisPct)}&apos;i</p>
                {lowSatis.map((c, i) => (
                  <div key={i} className="flex justify-between text-xs text-amber-900 py-0.5">
                    <span>{c.platform} {c.name}</span>
                    <span className="font-bold">{c.roas}x — {fmtK(c.spend)}</span>
                  </div>
                ))}
                <div className="mt-2 pt-2 border-t border-amber-200 text-xs text-amber-800">
                  <p className="font-bold">Toplam: {fmt(lowSatis.reduce((s,c) => s+c.spend,0))} TL → {fmt(lowSatis.reduce((s,c) => s+c.value,0))} TL getiri</p>
                  <p className="text-[10px] mt-1">Not: Search Generic&apos;te conversion tracking sorunu var — gercek performans daha yuksek olabilir.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Senaryo karsilastirmasi */}
        <div className="rounded-xl border overflow-hidden">
          <div className="px-4 py-3 bg-gray-50 border-b">
            <p className="font-semibold text-sm text-gray-800">Senaryo Karsilastirmasi — Ayni Butce, Farkli Dagitim</p>
            <p className="text-[10px] text-gray-500 mt-0.5">Toplam butce sabit: {fmt(totalSpend)} TL. Diminishing returns hesaba katilmistir.</p>
          </div>
          <div className="p-4">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
              {scenarios.map((s, i) => {
                const diff = s.directValue - satisValue;
                const diffPct = ((diff / satisValue) * 100).toFixed(0);
                return (
                  <div key={i} className={`rounded-xl border-2 ${s.color} overflow-hidden`}>
                    <div className={`${s.headerColor} px-4 py-3 text-white flex items-center justify-between`}>
                      <div>
                        <p className="text-sm font-bold">{s.label}</p>
                        <p className="text-[10px] opacity-80 mt-0.5">{s.desc}</p>
                      </div>
                      {s.badge && <span className="text-[9px] font-bold px-2 py-0.5 rounded-full bg-white/20">{s.badge}</span>}
                    </div>
                    <div className="p-4 space-y-3">
                      <div>
                        <p className="text-[10px] text-gray-500 mb-1">Butce Dagilimi</p>
                        <div className="flex rounded-lg overflow-hidden h-6">
                          <div className="bg-blue-500 flex items-center justify-center" style={{ width: `${s.satisPct}%` }}>
                            <span className="text-[9px] text-white font-bold">%{s.satisPct} satis</span>
                          </div>
                          <div className="bg-purple-300 flex items-center justify-center" style={{ width: `${100 - s.satisPct}%` }}>
                            {(100 - s.satisPct) > 5 && <span className="text-[9px] text-purple-900 font-bold">%{100 - s.satisPct} branding</span>}
                          </div>
                        </div>
                      </div>

                      <div className="space-y-2 pt-2">
                        <div className="flex justify-between text-xs">
                          <span className="text-gray-600">Satis Butcesi</span>
                          <span className="font-bold text-gray-900">{fmt(s.satisSpend)} TL</span>
                        </div>
                        <div className="flex justify-between text-xs">
                          <span className="text-gray-600">Branding Butcesi</span>
                          <span className="font-bold text-gray-900">{fmt(s.brandSpend)} TL</span>
                        </div>
                        <div className="flex justify-between text-xs">
                          <span className="text-gray-600">Dogrudan Satis Getirisi</span>
                          <span className="font-bold text-gray-900">{fmt(s.directValue)} TL</span>
                        </div>
                        <div className="flex justify-between text-xs">
                          <span className="text-gray-600">Satis ROAS</span>
                          <span className="font-bold text-gray-900">{s.roas}x</span>
                        </div>
                      </div>

                      {i > 0 && (
                        <div className="mt-2 pt-2 border-t text-center">
                          <p className={`text-sm font-bold ${diff > 0 ? 'text-green-700' : 'text-red-600'}`}>
                            {diff > 0 ? '+' : ''}{fmt(diff)} TL
                          </p>
                          <p className="text-[10px] text-gray-500">
                            mevcut duruma gore ({diff > 0 ? '+' : ''}{diffPct}%)
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Sonuc */}
        <div className="p-5 rounded-xl bg-gradient-to-r from-indigo-900 to-violet-800 text-white">
          <p className="text-sm font-bold mb-3">Degerlendirme</p>
          <div className="space-y-2 text-xs text-indigo-200 leading-relaxed">
            <p>&bull; <strong className="text-white">Satis kampanyalari zaten butcenin %{satisPct}&apos;unu</strong> kullaniyor ve toplam {fmt(satisValue)} TL dogrudan gelir getiriyor. Dagitim buyuk oranda dogru yonde.</p>
            <p>&bull; <strong className="text-white">Branding harcamasi (%{brandingPct})</strong> YouTube, Display, Engagement, Reach ve Location kampanyalarindan olusuyor. Bunlar dogrudan satis getirmez ama marka bilinirligini artirarak Brand Search ve organik trafigi besler.</p>
            <p>&bull; <strong className="text-white">Satis kampanyalari icinde</strong> asil firsat Search Generic&apos;te: 410K TL harcanmis, ROAS 0.70x gorunuyor. Ancak bu buyuk olcude conversion tracking sorunuyla ilgili — duzeltildiginde gercek performans ortaya cikacak.</p>
            <p>&bull; <strong className="text-yellow-300">Branding &amp; satis dengesi:</strong> Branding butcesini sifirlamak kisa vadede ROAS&apos;i artirsa da, orta vadede Brand Search hacmini ve organik trafigi dusurur. %15-20 arasi branding butcesi saglikli bir dengedir.</p>
            <p>&bull; <strong className="text-green-300">Onerilen yaklasim:</strong> Branding butcesini koruyarak satis kampanyalari icinde optimizasyona odaklanmak — ozellikle Search Generic tracking fix ve PMax feed iyilestirmesi en buyuk etki yaratacak adimlar.</p>
          </div>
        </div>

      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════════════════════ */
/*  MAIN                                                                      */
/* ═══════════════════════════════════════════════════════════════════════════ */

const NAV_ITEMS = [
  { id: 'yanit',      label: 'Ali Bey Yanit', icon: '💬' },
  { id: 'adsimpact',  label: 'Reklamlar Durursa', icon: '🚨' },
  { id: 'growth90',   label: '90 Gun Plan', icon: '🚀' },
  { id: 'camptype',   label: 'Kampanya Tipi', icon: '📊' },
  { id: 'butsim',     label: 'Butce Simulasyonu', icon: '💰' },
  { id: 'remarketing', label: 'Remarketing', icon: '🔄' },
  { id: 'trust',      label: 'Güven Hiyerarşisi', icon: '🛡️' },
  { id: 'stock',      label: 'Stok Takibi', icon: '📦' },
  { id: 'iphone',     label: 'iPhone',  icon: '📱' },
  { id: 'macbook',    label: 'MacBook', icon: '💻' },
  { id: 'ipad',       label: 'iPad',    icon: '📲' },
  { id: 'watch',      label: 'Apple Watch', icon: '⌚' },
  { id: 'google',     label: 'Google Ads', icon: '🔍' },
  { id: 'meta',       label: 'Meta Ads', icon: '📣' },
  { id: 'funnel',     label: 'Funnel & CRO', icon: '🎯' },
  { id: 'action',     label: '30 Gün Aksiyon', icon: '📋' },
];

export default function BrandingForecastYenilio() {
  const refs = useRef({});

  const scrollTo = (id) => {
    refs.current[id]?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Sticky Nav */}
      <div className="sticky top-0 z-50 bg-white border-b shadow-sm">
        <div className="mx-auto px-4 overflow-x-auto" style={{ maxWidth: '1500px' }}>
          <div className="flex gap-1 py-2">
            {NAV_ITEMS.map(n => (
              <button
                key={n.id}
                onClick={() => scrollTo(n.id)}
                className="flex items-center gap-1.5 px-3 py-2 text-xs font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg whitespace-nowrap transition-colors"
              >
                <span>{n.icon}</span>
                {n.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="mx-auto px-6 py-6 space-y-8" style={{ maxWidth: '1500px' }}>
        <div ref={el => refs.current.yanit = el}><AliBeyYanitSection /></div>
        <div ref={el => refs.current.adsimpact = el}><AdsImpactSection /></div>
        <div ref={el => refs.current.growth90 = el}><GrowthPlanSection /></div>
        <div ref={el => refs.current.camptype = el}><CampaignTypeSection /></div>
        <div ref={el => refs.current.butsim = el}><BudgetSimulationSection /></div>
        <div ref={el => refs.current.remarketing = el}><RemarketingSection /></div>
        <div ref={el => refs.current.trust = el}><TrustHierarchySection /></div>
        <div ref={el => refs.current.stock = el}><StockSection /></div>
        {PRODUCTS.map(p => (
          <div key={p.id} ref={el => refs.current[p.id] = el}><ProductSection product={p} /></div>
        ))}
        <div ref={el => refs.current.google = el}><GoogleAdsSection /></div>
        <div ref={el => refs.current.meta = el}><MetaAdsSection /></div>
        <div ref={el => refs.current.funnel = el}><FunnelCROSection /></div>
        <div ref={el => refs.current.action = el}><ActionPlanSection /></div>
      </div>
    </div>
  );
}
